/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AppVersionResult = {
  __typename?: 'AppVersionResult';
  version: Scalars['String']['output'];
};

export type Audio = {
  __typename?: 'Audio';
  cancelled: Scalars['Boolean']['output'];
  character?: Maybe<Character>;
  characterConnection: AudioCharacterConnection;
  comps: Array<Comp>;
  compsConnection: AudioCompsConnection;
  created: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['String']['output']>;
  episode?: Maybe<Episode>;
  episodeConnection: AudioEpisodeConnection;
  from: ContextBlock;
  fromConnection: AudioFromConnection;
  groups: Array<AudioGroup>;
  groupsConnection: AudioGroupsConnection;
  hasTakes: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  library?: Maybe<Library>;
  ordinal: Scalars['Float']['output'];
  performanceNotes?: Maybe<Scalars['String']['output']>;
  recordingStatus: RecordingStatus;
  script: Script;
  selectInfo: SelectInfo;
  tag: Scalars['String']['output'];
  takes: Array<Take>;
  takesConnection: AudioTakesConnection;
  text: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type AudioCharacterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type AudioCharacterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioCharacterConnectionSort>>;
  where?: InputMaybe<AudioCharacterConnectionWhere>;
};


export type AudioCompsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompOptions>;
  where?: InputMaybe<CompWhere>;
};


export type AudioCompsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioCompsConnectionSort>>;
  where?: InputMaybe<AudioCompsConnectionWhere>;
};


export type AudioEpisodeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type AudioEpisodeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioEpisodeConnectionSort>>;
  where?: InputMaybe<AudioEpisodeConnectionWhere>;
};


export type AudioFromArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ContextBlockOptions>;
  where?: InputMaybe<ContextBlockWhere>;
};


export type AudioFromConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioFromConnectionSort>>;
  where?: InputMaybe<AudioFromConnectionWhere>;
};


export type AudioGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AudioGroupOptions>;
  where?: InputMaybe<AudioGroupWhere>;
};


export type AudioGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioGroupsConnectionSort>>;
  where?: InputMaybe<AudioGroupsConnectionWhere>;
};


export type AudioRecordingStatusArgs = {
  recordingSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type AudioTakesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TakeOptions>;
  where?: InputMaybe<TakeWhere>;
};


export type AudioTakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioTakesConnectionSort>>;
  where?: InputMaybe<AudioTakesConnectionWhere>;
};

export type AudioCharacterAggregateInput = {
  AND?: InputMaybe<Array<AudioCharacterAggregateInput>>;
  NOT?: InputMaybe<AudioCharacterAggregateInput>;
  OR?: InputMaybe<Array<AudioCharacterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioCharacterNodeAggregationWhereInput>;
};

export type AudioCharacterConnection = {
  __typename?: 'AudioCharacterConnection';
  edges: Array<AudioCharacterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioCharacterConnectionSort = {
  node?: InputMaybe<CharacterSort>;
};

export type AudioCharacterConnectionWhere = {
  AND?: InputMaybe<Array<AudioCharacterConnectionWhere>>;
  NOT?: InputMaybe<AudioCharacterConnectionWhere>;
  OR?: InputMaybe<Array<AudioCharacterConnectionWhere>>;
  node?: InputMaybe<CharacterWhere>;
};

export type AudioCharacterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioCharacterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioCharacterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioCharacterNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioCharacterRelationship = {
  __typename?: 'AudioCharacterRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type AudioCompsAggregateInput = {
  AND?: InputMaybe<Array<AudioCompsAggregateInput>>;
  NOT?: InputMaybe<AudioCompsAggregateInput>;
  OR?: InputMaybe<Array<AudioCompsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioCompsNodeAggregationWhereInput>;
};

export type AudioCompsConnection = {
  __typename?: 'AudioCompsConnection';
  edges: Array<AudioCompsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioCompsConnectionSort = {
  node?: InputMaybe<CompSort>;
};

export type AudioCompsConnectionWhere = {
  AND?: InputMaybe<Array<AudioCompsConnectionWhere>>;
  NOT?: InputMaybe<AudioCompsConnectionWhere>;
  OR?: InputMaybe<Array<AudioCompsConnectionWhere>>;
  node?: InputMaybe<CompWhere>;
};

export type AudioCompsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioCompsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioCompsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioCompsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioCompsRelationship = {
  __typename?: 'AudioCompsRelationship';
  cursor: Scalars['String']['output'];
  node: Comp;
};

export type AudioConnection = {
  __typename?: 'AudioConnection';
  edges: Array<AudioEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioEdge = {
  __typename?: 'AudioEdge';
  cursor: Scalars['String']['output'];
  node: Audio;
};

export type AudioEpisodeAggregateInput = {
  AND?: InputMaybe<Array<AudioEpisodeAggregateInput>>;
  NOT?: InputMaybe<AudioEpisodeAggregateInput>;
  OR?: InputMaybe<Array<AudioEpisodeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioEpisodeNodeAggregationWhereInput>;
};

export type AudioEpisodeConnection = {
  __typename?: 'AudioEpisodeConnection';
  edges: Array<AudioEpisodeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioEpisodeConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type AudioEpisodeConnectionWhere = {
  AND?: InputMaybe<Array<AudioEpisodeConnectionWhere>>;
  NOT?: InputMaybe<AudioEpisodeConnectionWhere>;
  OR?: InputMaybe<Array<AudioEpisodeConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type AudioEpisodeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioEpisodeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioEpisodeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioEpisodeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioEpisodeRelationship = {
  __typename?: 'AudioEpisodeRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type AudioFromAggregateInput = {
  AND?: InputMaybe<Array<AudioFromAggregateInput>>;
  NOT?: InputMaybe<AudioFromAggregateInput>;
  OR?: InputMaybe<Array<AudioFromAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioFromNodeAggregationWhereInput>;
};

export type AudioFromConnection = {
  __typename?: 'AudioFromConnection';
  edges: Array<AudioFromRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioFromConnectionSort = {
  node?: InputMaybe<ContextBlockSort>;
};

export type AudioFromConnectionWhere = {
  AND?: InputMaybe<Array<AudioFromConnectionWhere>>;
  NOT?: InputMaybe<AudioFromConnectionWhere>;
  OR?: InputMaybe<Array<AudioFromConnectionWhere>>;
  node?: InputMaybe<ContextBlockWhere>;
};

export type AudioFromNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioFromNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioFromNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioFromNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioFromRelationship = {
  __typename?: 'AudioFromRelationship';
  cursor: Scalars['String']['output'];
  node: ContextBlock;
};

export type AudioGroup = {
  __typename?: 'AudioGroup';
  audios: Array<Audio>;
  audiosConnection: AudioGroupAudiosConnection;
  cancelled: Scalars['Boolean']['output'];
  characters: Array<Character>;
  charactersConnection: AudioGroupCharactersConnection;
  episode?: Maybe<Episode>;
  episodeConnection: AudioGroupEpisodeConnection;
  id: Scalars['ID']['output'];
  ordinal: Scalars['Float']['output'];
  tag: Scalars['String']['output'];
};


export type AudioGroupAudiosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AudioOptions>;
  where?: InputMaybe<AudioWhere>;
};


export type AudioGroupAudiosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioGroupAudiosConnectionSort>>;
  where?: InputMaybe<AudioGroupAudiosConnectionWhere>;
};


export type AudioGroupCharactersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type AudioGroupCharactersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioGroupCharactersConnectionSort>>;
  where?: InputMaybe<AudioGroupCharactersConnectionWhere>;
};


export type AudioGroupEpisodeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type AudioGroupEpisodeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AudioGroupEpisodeConnectionSort>>;
  where?: InputMaybe<AudioGroupEpisodeConnectionWhere>;
};

export type AudioGroupAudiosAggregateInput = {
  AND?: InputMaybe<Array<AudioGroupAudiosAggregateInput>>;
  NOT?: InputMaybe<AudioGroupAudiosAggregateInput>;
  OR?: InputMaybe<Array<AudioGroupAudiosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioGroupAudiosNodeAggregationWhereInput>;
};

export type AudioGroupAudiosConnection = {
  __typename?: 'AudioGroupAudiosConnection';
  edges: Array<AudioGroupAudiosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioGroupAudiosConnectionSort = {
  node?: InputMaybe<AudioSort>;
};

export type AudioGroupAudiosConnectionWhere = {
  AND?: InputMaybe<Array<AudioGroupAudiosConnectionWhere>>;
  NOT?: InputMaybe<AudioGroupAudiosConnectionWhere>;
  OR?: InputMaybe<Array<AudioGroupAudiosConnectionWhere>>;
  node?: InputMaybe<AudioWhere>;
};

export type AudioGroupAudiosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioGroupAudiosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioGroupAudiosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioGroupAudiosNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioGroupAudiosRelationship = {
  __typename?: 'AudioGroupAudiosRelationship';
  cursor: Scalars['String']['output'];
  node: Audio;
};

export type AudioGroupCharactersAggregateInput = {
  AND?: InputMaybe<Array<AudioGroupCharactersAggregateInput>>;
  NOT?: InputMaybe<AudioGroupCharactersAggregateInput>;
  OR?: InputMaybe<Array<AudioGroupCharactersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioGroupCharactersNodeAggregationWhereInput>;
};

export type AudioGroupCharactersConnection = {
  __typename?: 'AudioGroupCharactersConnection';
  edges: Array<AudioGroupCharactersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioGroupCharactersConnectionSort = {
  node?: InputMaybe<CharacterSort>;
};

export type AudioGroupCharactersConnectionWhere = {
  AND?: InputMaybe<Array<AudioGroupCharactersConnectionWhere>>;
  NOT?: InputMaybe<AudioGroupCharactersConnectionWhere>;
  OR?: InputMaybe<Array<AudioGroupCharactersConnectionWhere>>;
  node?: InputMaybe<CharacterWhere>;
};

export type AudioGroupCharactersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioGroupCharactersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioGroupCharactersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioGroupCharactersNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioGroupCharactersRelationship = {
  __typename?: 'AudioGroupCharactersRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type AudioGroupEdge = {
  __typename?: 'AudioGroupEdge';
  cursor: Scalars['String']['output'];
  node: AudioGroup;
};

export type AudioGroupEpisodeAggregateInput = {
  AND?: InputMaybe<Array<AudioGroupEpisodeAggregateInput>>;
  NOT?: InputMaybe<AudioGroupEpisodeAggregateInput>;
  OR?: InputMaybe<Array<AudioGroupEpisodeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioGroupEpisodeNodeAggregationWhereInput>;
};

export type AudioGroupEpisodeConnection = {
  __typename?: 'AudioGroupEpisodeConnection';
  edges: Array<AudioGroupEpisodeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioGroupEpisodeConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type AudioGroupEpisodeConnectionWhere = {
  AND?: InputMaybe<Array<AudioGroupEpisodeConnectionWhere>>;
  NOT?: InputMaybe<AudioGroupEpisodeConnectionWhere>;
  OR?: InputMaybe<Array<AudioGroupEpisodeConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type AudioGroupEpisodeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioGroupEpisodeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioGroupEpisodeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioGroupEpisodeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioGroupEpisodeRelationship = {
  __typename?: 'AudioGroupEpisodeRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type AudioGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AudioGroupSort objects to sort AudioGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AudioGroupSort>>;
};

/** Fields to sort AudioGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one AudioGroupSort object. */
export type AudioGroupSort = {
  cancelled?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  ordinal?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  tag?: InputMaybe<SortDirection>;
};

export type AudioGroupWhere = {
  AND?: InputMaybe<Array<AudioGroupWhere>>;
  NOT?: InputMaybe<AudioGroupWhere>;
  OR?: InputMaybe<Array<AudioGroupWhere>>;
  audiosAggregate?: InputMaybe<AudioGroupAudiosAggregateInput>;
  /** Return AudioGroups where all of the related AudioGroupAudiosConnections match this filter */
  audiosConnection_ALL?: InputMaybe<AudioGroupAudiosConnectionWhere>;
  /** Return AudioGroups where none of the related AudioGroupAudiosConnections match this filter */
  audiosConnection_NONE?: InputMaybe<AudioGroupAudiosConnectionWhere>;
  /** Return AudioGroups where one of the related AudioGroupAudiosConnections match this filter */
  audiosConnection_SINGLE?: InputMaybe<AudioGroupAudiosConnectionWhere>;
  /** Return AudioGroups where some of the related AudioGroupAudiosConnections match this filter */
  audiosConnection_SOME?: InputMaybe<AudioGroupAudiosConnectionWhere>;
  /** Return AudioGroups where all of the related Audio match this filter */
  audios_ALL?: InputMaybe<AudioWhere>;
  /** Return AudioGroups where none of the related Audio match this filter */
  audios_NONE?: InputMaybe<AudioWhere>;
  /** Return AudioGroups where one of the related Audio match this filter */
  audios_SINGLE?: InputMaybe<AudioWhere>;
  /** Return AudioGroups where some of the related Audio match this filter */
  audios_SOME?: InputMaybe<AudioWhere>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  charactersAggregate?: InputMaybe<AudioGroupCharactersAggregateInput>;
  /** Return AudioGroups where all of the related AudioGroupCharactersConnections match this filter */
  charactersConnection_ALL?: InputMaybe<AudioGroupCharactersConnectionWhere>;
  /** Return AudioGroups where none of the related AudioGroupCharactersConnections match this filter */
  charactersConnection_NONE?: InputMaybe<AudioGroupCharactersConnectionWhere>;
  /** Return AudioGroups where one of the related AudioGroupCharactersConnections match this filter */
  charactersConnection_SINGLE?: InputMaybe<AudioGroupCharactersConnectionWhere>;
  /** Return AudioGroups where some of the related AudioGroupCharactersConnections match this filter */
  charactersConnection_SOME?: InputMaybe<AudioGroupCharactersConnectionWhere>;
  /** Return AudioGroups where all of the related Characters match this filter */
  characters_ALL?: InputMaybe<CharacterWhere>;
  /** Return AudioGroups where none of the related Characters match this filter */
  characters_NONE?: InputMaybe<CharacterWhere>;
  /** Return AudioGroups where one of the related Characters match this filter */
  characters_SINGLE?: InputMaybe<CharacterWhere>;
  /** Return AudioGroups where some of the related Characters match this filter */
  characters_SOME?: InputMaybe<CharacterWhere>;
  episode?: InputMaybe<EpisodeWhere>;
  episodeAggregate?: InputMaybe<AudioGroupEpisodeAggregateInput>;
  episodeConnection?: InputMaybe<AudioGroupEpisodeConnectionWhere>;
  episodeConnection_NOT?: InputMaybe<AudioGroupEpisodeConnectionWhere>;
  episode_NOT?: InputMaybe<EpisodeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AudioGroupsAggregateInput = {
  AND?: InputMaybe<Array<AudioGroupsAggregateInput>>;
  NOT?: InputMaybe<AudioGroupsAggregateInput>;
  OR?: InputMaybe<Array<AudioGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioGroupsNodeAggregationWhereInput>;
};

export type AudioGroupsConnection = {
  __typename?: 'AudioGroupsConnection';
  edges: Array<AudioGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioGroupsConnectionSort = {
  node?: InputMaybe<AudioGroupSort>;
};

export type AudioGroupsConnectionWhere = {
  AND?: InputMaybe<Array<AudioGroupsConnectionWhere>>;
  NOT?: InputMaybe<AudioGroupsConnectionWhere>;
  OR?: InputMaybe<Array<AudioGroupsConnectionWhere>>;
  node?: InputMaybe<AudioGroupWhere>;
};

export type AudioGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioGroupsNodeAggregationWhereInput>>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioGroupsRelationship = {
  __typename?: 'AudioGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: AudioGroup;
};

export type AudioInput = {
  fromContextId: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  tag: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AudioOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AudioSort objects to sort Audio by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AudioSort>>;
};

/** Fields to sort Audio by. The order in which sorts are applied is not guaranteed when specifying many fields in one AudioSort object. */
export type AudioSort = {
  cancelled?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  customFields?: InputMaybe<SortDirection>;
  hasTakes?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  library?: InputMaybe<SortDirection>;
  ordinal?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  performanceNotes?: InputMaybe<SortDirection>;
  recordingStatus?: InputMaybe<SortDirection>;
  script?: InputMaybe<SortDirection>;
  selectInfo?: InputMaybe<SortDirection>;
  tag?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export type AudioTakesAggregateInput = {
  AND?: InputMaybe<Array<AudioTakesAggregateInput>>;
  NOT?: InputMaybe<AudioTakesAggregateInput>;
  OR?: InputMaybe<Array<AudioTakesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AudioTakesNodeAggregationWhereInput>;
};

export type AudioTakesConnection = {
  __typename?: 'AudioTakesConnection';
  edges: Array<AudioTakesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudioTakesConnectionSort = {
  edge?: InputMaybe<HasTakeSort>;
  node?: InputMaybe<TakeSort>;
};

export type AudioTakesConnectionWhere = {
  AND?: InputMaybe<Array<AudioTakesConnectionWhere>>;
  NOT?: InputMaybe<AudioTakesConnectionWhere>;
  OR?: InputMaybe<Array<AudioTakesConnectionWhere>>;
  edge?: InputMaybe<HasTakeWhere>;
  node?: InputMaybe<TakeWhere>;
};

export type AudioTakesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AudioTakesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AudioTakesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AudioTakesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  take_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AudioTakesRelationship = {
  __typename?: 'AudioTakesRelationship';
  cursor: Scalars['String']['output'];
  node: Take;
  properties: HasTake;
};

export type AudioUpdateInput = {
  customFields?: InputMaybe<Scalars['String']['input']>;
  library?: InputMaybe<Library>;
  performanceNotes?: InputMaybe<Scalars['String']['input']>;
};

export type AudioWhere = {
  AND?: InputMaybe<Array<AudioWhere>>;
  NOT?: InputMaybe<AudioWhere>;
  OR?: InputMaybe<Array<AudioWhere>>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  character?: InputMaybe<CharacterWhere>;
  characterAggregate?: InputMaybe<AudioCharacterAggregateInput>;
  characterConnection?: InputMaybe<AudioCharacterConnectionWhere>;
  characterConnection_NOT?: InputMaybe<AudioCharacterConnectionWhere>;
  character_NOT?: InputMaybe<CharacterWhere>;
  compsAggregate?: InputMaybe<AudioCompsAggregateInput>;
  /** Return Audio where all of the related AudioCompsConnections match this filter */
  compsConnection_ALL?: InputMaybe<AudioCompsConnectionWhere>;
  /** Return Audio where none of the related AudioCompsConnections match this filter */
  compsConnection_NONE?: InputMaybe<AudioCompsConnectionWhere>;
  /** Return Audio where one of the related AudioCompsConnections match this filter */
  compsConnection_SINGLE?: InputMaybe<AudioCompsConnectionWhere>;
  /** Return Audio where some of the related AudioCompsConnections match this filter */
  compsConnection_SOME?: InputMaybe<AudioCompsConnectionWhere>;
  /** Return Audio where all of the related Comps match this filter */
  comps_ALL?: InputMaybe<CompWhere>;
  /** Return Audio where none of the related Comps match this filter */
  comps_NONE?: InputMaybe<CompWhere>;
  /** Return Audio where one of the related Comps match this filter */
  comps_SINGLE?: InputMaybe<CompWhere>;
  /** Return Audio where some of the related Comps match this filter */
  comps_SOME?: InputMaybe<CompWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  customFields_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  customFields_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  customFields_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFields_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  episode?: InputMaybe<EpisodeWhere>;
  episodeAggregate?: InputMaybe<AudioEpisodeAggregateInput>;
  episodeConnection?: InputMaybe<AudioEpisodeConnectionWhere>;
  episodeConnection_NOT?: InputMaybe<AudioEpisodeConnectionWhere>;
  episode_NOT?: InputMaybe<EpisodeWhere>;
  from?: InputMaybe<ContextBlockWhere>;
  fromAggregate?: InputMaybe<AudioFromAggregateInput>;
  fromConnection?: InputMaybe<AudioFromConnectionWhere>;
  fromConnection_NOT?: InputMaybe<AudioFromConnectionWhere>;
  from_NOT?: InputMaybe<ContextBlockWhere>;
  groupsAggregate?: InputMaybe<AudioGroupsAggregateInput>;
  /** Return Audio where all of the related AudioGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<AudioGroupsConnectionWhere>;
  /** Return Audio where none of the related AudioGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<AudioGroupsConnectionWhere>;
  /** Return Audio where one of the related AudioGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<AudioGroupsConnectionWhere>;
  /** Return Audio where some of the related AudioGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<AudioGroupsConnectionWhere>;
  /** Return Audio where all of the related AudioGroups match this filter */
  groups_ALL?: InputMaybe<AudioGroupWhere>;
  /** Return Audio where none of the related AudioGroups match this filter */
  groups_NONE?: InputMaybe<AudioGroupWhere>;
  /** Return Audio where one of the related AudioGroups match this filter */
  groups_SINGLE?: InputMaybe<AudioGroupWhere>;
  /** Return Audio where some of the related AudioGroups match this filter */
  groups_SOME?: InputMaybe<AudioGroupWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  library?: InputMaybe<Library>;
  library_IN?: InputMaybe<Array<InputMaybe<Library>>>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  performanceNotes?: InputMaybe<Scalars['String']['input']>;
  performanceNotes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  performanceNotes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  performanceNotes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  performanceNotes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  takesAggregate?: InputMaybe<AudioTakesAggregateInput>;
  /** Return Audio where all of the related AudioTakesConnections match this filter */
  takesConnection_ALL?: InputMaybe<AudioTakesConnectionWhere>;
  /** Return Audio where none of the related AudioTakesConnections match this filter */
  takesConnection_NONE?: InputMaybe<AudioTakesConnectionWhere>;
  /** Return Audio where one of the related AudioTakesConnections match this filter */
  takesConnection_SINGLE?: InputMaybe<AudioTakesConnectionWhere>;
  /** Return Audio where some of the related AudioTakesConnections match this filter */
  takesConnection_SOME?: InputMaybe<AudioTakesConnectionWhere>;
  /** Return Audio where all of the related Takes match this filter */
  takes_ALL?: InputMaybe<TakeWhere>;
  /** Return Audio where none of the related Takes match this filter */
  takes_NONE?: InputMaybe<TakeWhere>;
  /** Return Audio where one of the related Takes match this filter */
  takes_SINGLE?: InputMaybe<TakeWhere>;
  /** Return Audio where some of the related Takes match this filter */
  takes_SOME?: InputMaybe<TakeWhere>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CancelContent = {
  id: Scalars['String']['input'];
  type: CancelContentType;
};

export enum CancelContentType {
  Audio = 'AUDIO',
  AudioGroup = 'AUDIO_GROUP',
  Line = 'LINE'
}

export type Character = {
  __typename?: 'Character';
  audio: Array<Audio>;
  audioConnection: CharacterAudioConnection;
  created: Scalars['DateTime']['output'];
  episodes: Array<Episode>;
  episodesConnection: CharacterEpisodesConnection;
  groups: Array<LineGroup>;
  groupsConnection: CharacterGroupsConnection;
  id: Scalars['ID']['output'];
  lines: Array<Line>;
  linesConnection: CharacterLinesConnection;
  name: Scalars['String']['output'];
  show: Show;
  showConnection: CharacterShowConnection;
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type CharacterAudioArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AudioOptions>;
  where?: InputMaybe<AudioWhere>;
};


export type CharacterAudioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CharacterAudioConnectionSort>>;
  where?: InputMaybe<CharacterAudioConnectionWhere>;
};


export type CharacterEpisodesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type CharacterEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CharacterEpisodesConnectionSort>>;
  where?: InputMaybe<CharacterEpisodesConnectionWhere>;
};


export type CharacterGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LineGroupOptions>;
  where?: InputMaybe<LineGroupWhere>;
};


export type CharacterGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CharacterGroupsConnectionSort>>;
  where?: InputMaybe<CharacterGroupsConnectionWhere>;
};


export type CharacterLinesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LineOptions>;
  where?: InputMaybe<LineWhere>;
};


export type CharacterLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CharacterLinesConnectionSort>>;
  where?: InputMaybe<CharacterLinesConnectionWhere>;
};


export type CharacterShowArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ShowOptions>;
  where?: InputMaybe<ShowWhere>;
};


export type CharacterShowConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CharacterShowConnectionSort>>;
  where?: InputMaybe<CharacterShowConnectionWhere>;
};

export type CharacterAudioAggregateInput = {
  AND?: InputMaybe<Array<CharacterAudioAggregateInput>>;
  NOT?: InputMaybe<CharacterAudioAggregateInput>;
  OR?: InputMaybe<Array<CharacterAudioAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CharacterAudioNodeAggregationWhereInput>;
};

export type CharacterAudioConnection = {
  __typename?: 'CharacterAudioConnection';
  edges: Array<CharacterAudioRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharacterAudioConnectionSort = {
  node?: InputMaybe<AudioSort>;
};

export type CharacterAudioConnectionWhere = {
  AND?: InputMaybe<Array<CharacterAudioConnectionWhere>>;
  NOT?: InputMaybe<CharacterAudioConnectionWhere>;
  OR?: InputMaybe<Array<CharacterAudioConnectionWhere>>;
  node?: InputMaybe<AudioWhere>;
};

export type CharacterAudioNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CharacterAudioNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CharacterAudioNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CharacterAudioNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CharacterAudioRelationship = {
  __typename?: 'CharacterAudioRelationship';
  cursor: Scalars['String']['output'];
  node: Audio;
};

export type CharacterConnectInput = {
  episodes?: InputMaybe<Array<CharacterEpisodesConnectFieldInput>>;
  show?: InputMaybe<CharacterShowConnectFieldInput>;
};

export type CharacterConnectWhere = {
  node: CharacterWhere;
};

export type CharacterCreateInput = {
  episodes?: InputMaybe<CharacterEpisodesFieldInput>;
  name: Scalars['String']['input'];
  show?: InputMaybe<CharacterShowFieldInput>;
};

export type CharacterEdge = {
  __typename?: 'CharacterEdge';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type CharacterEpisodesAggregateInput = {
  AND?: InputMaybe<Array<CharacterEpisodesAggregateInput>>;
  NOT?: InputMaybe<CharacterEpisodesAggregateInput>;
  OR?: InputMaybe<Array<CharacterEpisodesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CharacterEpisodesNodeAggregationWhereInput>;
};

export type CharacterEpisodesConnectFieldInput = {
  connect?: InputMaybe<Array<EpisodeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EpisodeConnectWhere>;
};

export type CharacterEpisodesConnection = {
  __typename?: 'CharacterEpisodesConnection';
  edges: Array<CharacterEpisodesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharacterEpisodesConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type CharacterEpisodesConnectionWhere = {
  AND?: InputMaybe<Array<CharacterEpisodesConnectionWhere>>;
  NOT?: InputMaybe<CharacterEpisodesConnectionWhere>;
  OR?: InputMaybe<Array<CharacterEpisodesConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type CharacterEpisodesCreateFieldInput = {
  node: EpisodeCreateInput;
};

export type CharacterEpisodesFieldInput = {
  connect?: InputMaybe<Array<CharacterEpisodesConnectFieldInput>>;
  create?: InputMaybe<Array<CharacterEpisodesCreateFieldInput>>;
};

export type CharacterEpisodesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CharacterEpisodesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CharacterEpisodesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CharacterEpisodesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CharacterEpisodesRelationship = {
  __typename?: 'CharacterEpisodesRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type CharacterEpisodesUpdateConnectionInput = {
  node?: InputMaybe<EpisodeUpdateInput>;
};

export type CharacterEpisodesUpdateFieldInput = {
  connect?: InputMaybe<Array<CharacterEpisodesConnectFieldInput>>;
  create?: InputMaybe<Array<CharacterEpisodesCreateFieldInput>>;
  update?: InputMaybe<CharacterEpisodesUpdateConnectionInput>;
  where?: InputMaybe<CharacterEpisodesConnectionWhere>;
};

export type CharacterGroupsAggregateInput = {
  AND?: InputMaybe<Array<CharacterGroupsAggregateInput>>;
  NOT?: InputMaybe<CharacterGroupsAggregateInput>;
  OR?: InputMaybe<Array<CharacterGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CharacterGroupsNodeAggregationWhereInput>;
};

export type CharacterGroupsConnection = {
  __typename?: 'CharacterGroupsConnection';
  edges: Array<CharacterGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharacterGroupsConnectionSort = {
  node?: InputMaybe<LineGroupSort>;
};

export type CharacterGroupsConnectionWhere = {
  AND?: InputMaybe<Array<CharacterGroupsConnectionWhere>>;
  NOT?: InputMaybe<CharacterGroupsConnectionWhere>;
  OR?: InputMaybe<Array<CharacterGroupsConnectionWhere>>;
  node?: InputMaybe<LineGroupWhere>;
};

export type CharacterGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CharacterGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CharacterGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CharacterGroupsNodeAggregationWhereInput>>;
  lineNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CharacterGroupsRelationship = {
  __typename?: 'CharacterGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: LineGroup;
};

/**
 * The edge properties for the following fields:
 * * Character.lines
 * * Line.character
 */
export type CharacterHasLine = {
  __typename?: 'CharacterHasLine';
  alias?: Maybe<Scalars['String']['output']>;
};

export type CharacterHasLineAggregationWhereInput = {
  AND?: InputMaybe<Array<CharacterHasLineAggregationWhereInput>>;
  NOT?: InputMaybe<CharacterHasLineAggregationWhereInput>;
  OR?: InputMaybe<Array<CharacterHasLineAggregationWhereInput>>;
  alias_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alias_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CharacterHasLineSort = {
  alias?: InputMaybe<SortDirection>;
};

export type CharacterHasLineWhere = {
  AND?: InputMaybe<Array<CharacterHasLineWhere>>;
  NOT?: InputMaybe<CharacterHasLineWhere>;
  OR?: InputMaybe<Array<CharacterHasLineWhere>>;
  alias?: InputMaybe<Scalars['String']['input']>;
  alias_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  alias_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  alias_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alias_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CharacterLinesAggregateInput = {
  AND?: InputMaybe<Array<CharacterLinesAggregateInput>>;
  NOT?: InputMaybe<CharacterLinesAggregateInput>;
  OR?: InputMaybe<Array<CharacterLinesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CharacterHasLineAggregationWhereInput>;
  node?: InputMaybe<CharacterLinesNodeAggregationWhereInput>;
};

export type CharacterLinesConnection = {
  __typename?: 'CharacterLinesConnection';
  edges: Array<CharacterLinesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharacterLinesConnectionSort = {
  edge?: InputMaybe<CharacterHasLineSort>;
  node?: InputMaybe<LineSort>;
};

export type CharacterLinesConnectionWhere = {
  AND?: InputMaybe<Array<CharacterLinesConnectionWhere>>;
  NOT?: InputMaybe<CharacterLinesConnectionWhere>;
  OR?: InputMaybe<Array<CharacterLinesConnectionWhere>>;
  edge?: InputMaybe<CharacterHasLineWhere>;
  node?: InputMaybe<LineWhere>;
};

export type CharacterLinesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CharacterLinesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CharacterLinesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CharacterLinesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CharacterLinesRelationship = {
  __typename?: 'CharacterLinesRelationship';
  cursor: Scalars['String']['output'];
  node: Line;
  properties: CharacterHasLine;
};

export type CharacterOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CharacterSort objects to sort Characters by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CharacterSort>>;
};

export type CharacterRelationInput = {
  episodes?: InputMaybe<Array<CharacterEpisodesCreateFieldInput>>;
  show?: InputMaybe<CharacterShowCreateFieldInput>;
};

export type CharacterShowAggregateInput = {
  AND?: InputMaybe<Array<CharacterShowAggregateInput>>;
  NOT?: InputMaybe<CharacterShowAggregateInput>;
  OR?: InputMaybe<Array<CharacterShowAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CharacterShowNodeAggregationWhereInput>;
};

export type CharacterShowConnectFieldInput = {
  connect?: InputMaybe<ShowConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ShowConnectWhere>;
};

export type CharacterShowConnection = {
  __typename?: 'CharacterShowConnection';
  edges: Array<CharacterShowRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharacterShowConnectionSort = {
  node?: InputMaybe<ShowSort>;
};

export type CharacterShowConnectionWhere = {
  AND?: InputMaybe<Array<CharacterShowConnectionWhere>>;
  NOT?: InputMaybe<CharacterShowConnectionWhere>;
  OR?: InputMaybe<Array<CharacterShowConnectionWhere>>;
  node?: InputMaybe<ShowWhere>;
};

export type CharacterShowCreateFieldInput = {
  node: ShowCreateInput;
};

export type CharacterShowFieldInput = {
  connect?: InputMaybe<CharacterShowConnectFieldInput>;
  create?: InputMaybe<CharacterShowCreateFieldInput>;
};

export type CharacterShowNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CharacterShowNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CharacterShowNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CharacterShowNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CharacterShowRelationship = {
  __typename?: 'CharacterShowRelationship';
  cursor: Scalars['String']['output'];
  node: Show;
};

export type CharacterShowUpdateConnectionInput = {
  node?: InputMaybe<ShowUpdateInput>;
};

export type CharacterShowUpdateFieldInput = {
  connect?: InputMaybe<CharacterShowConnectFieldInput>;
  create?: InputMaybe<CharacterShowCreateFieldInput>;
  update?: InputMaybe<CharacterShowUpdateConnectionInput>;
  where?: InputMaybe<CharacterShowConnectionWhere>;
};

/** Fields to sort Characters by. The order in which sorts are applied is not guaranteed when specifying many fields in one CharacterSort object. */
export type CharacterSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export type CharacterUpdateInput = {
  episodes?: InputMaybe<Array<CharacterEpisodesUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<CharacterShowUpdateFieldInput>;
};

export type CharacterWhere = {
  AND?: InputMaybe<Array<CharacterWhere>>;
  NOT?: InputMaybe<CharacterWhere>;
  OR?: InputMaybe<Array<CharacterWhere>>;
  audioAggregate?: InputMaybe<CharacterAudioAggregateInput>;
  /** Return Characters where all of the related CharacterAudioConnections match this filter */
  audioConnection_ALL?: InputMaybe<CharacterAudioConnectionWhere>;
  /** Return Characters where none of the related CharacterAudioConnections match this filter */
  audioConnection_NONE?: InputMaybe<CharacterAudioConnectionWhere>;
  /** Return Characters where one of the related CharacterAudioConnections match this filter */
  audioConnection_SINGLE?: InputMaybe<CharacterAudioConnectionWhere>;
  /** Return Characters where some of the related CharacterAudioConnections match this filter */
  audioConnection_SOME?: InputMaybe<CharacterAudioConnectionWhere>;
  /** Return Characters where all of the related Audio match this filter */
  audio_ALL?: InputMaybe<AudioWhere>;
  /** Return Characters where none of the related Audio match this filter */
  audio_NONE?: InputMaybe<AudioWhere>;
  /** Return Characters where one of the related Audio match this filter */
  audio_SINGLE?: InputMaybe<AudioWhere>;
  /** Return Characters where some of the related Audio match this filter */
  audio_SOME?: InputMaybe<AudioWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  episodesAggregate?: InputMaybe<CharacterEpisodesAggregateInput>;
  /** Return Characters where all of the related CharacterEpisodesConnections match this filter */
  episodesConnection_ALL?: InputMaybe<CharacterEpisodesConnectionWhere>;
  /** Return Characters where none of the related CharacterEpisodesConnections match this filter */
  episodesConnection_NONE?: InputMaybe<CharacterEpisodesConnectionWhere>;
  /** Return Characters where one of the related CharacterEpisodesConnections match this filter */
  episodesConnection_SINGLE?: InputMaybe<CharacterEpisodesConnectionWhere>;
  /** Return Characters where some of the related CharacterEpisodesConnections match this filter */
  episodesConnection_SOME?: InputMaybe<CharacterEpisodesConnectionWhere>;
  /** Return Characters where all of the related Episodes match this filter */
  episodes_ALL?: InputMaybe<EpisodeWhere>;
  /** Return Characters where none of the related Episodes match this filter */
  episodes_NONE?: InputMaybe<EpisodeWhere>;
  /** Return Characters where one of the related Episodes match this filter */
  episodes_SINGLE?: InputMaybe<EpisodeWhere>;
  /** Return Characters where some of the related Episodes match this filter */
  episodes_SOME?: InputMaybe<EpisodeWhere>;
  groupsAggregate?: InputMaybe<CharacterGroupsAggregateInput>;
  /** Return Characters where all of the related CharacterGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<CharacterGroupsConnectionWhere>;
  /** Return Characters where none of the related CharacterGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<CharacterGroupsConnectionWhere>;
  /** Return Characters where one of the related CharacterGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<CharacterGroupsConnectionWhere>;
  /** Return Characters where some of the related CharacterGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<CharacterGroupsConnectionWhere>;
  /** Return Characters where all of the related LineGroups match this filter */
  groups_ALL?: InputMaybe<LineGroupWhere>;
  /** Return Characters where none of the related LineGroups match this filter */
  groups_NONE?: InputMaybe<LineGroupWhere>;
  /** Return Characters where one of the related LineGroups match this filter */
  groups_SINGLE?: InputMaybe<LineGroupWhere>;
  /** Return Characters where some of the related LineGroups match this filter */
  groups_SOME?: InputMaybe<LineGroupWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  linesAggregate?: InputMaybe<CharacterLinesAggregateInput>;
  /** Return Characters where all of the related CharacterLinesConnections match this filter */
  linesConnection_ALL?: InputMaybe<CharacterLinesConnectionWhere>;
  /** Return Characters where none of the related CharacterLinesConnections match this filter */
  linesConnection_NONE?: InputMaybe<CharacterLinesConnectionWhere>;
  /** Return Characters where one of the related CharacterLinesConnections match this filter */
  linesConnection_SINGLE?: InputMaybe<CharacterLinesConnectionWhere>;
  /** Return Characters where some of the related CharacterLinesConnections match this filter */
  linesConnection_SOME?: InputMaybe<CharacterLinesConnectionWhere>;
  /** Return Characters where all of the related Lines match this filter */
  lines_ALL?: InputMaybe<LineWhere>;
  /** Return Characters where none of the related Lines match this filter */
  lines_NONE?: InputMaybe<LineWhere>;
  /** Return Characters where one of the related Lines match this filter */
  lines_SINGLE?: InputMaybe<LineWhere>;
  /** Return Characters where some of the related Lines match this filter */
  lines_SOME?: InputMaybe<LineWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<ShowWhere>;
  showAggregate?: InputMaybe<CharacterShowAggregateInput>;
  showConnection?: InputMaybe<CharacterShowConnectionWhere>;
  showConnection_NOT?: InputMaybe<CharacterShowConnectionWhere>;
  show_NOT?: InputMaybe<ShowWhere>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CharactersConnection = {
  __typename?: 'CharactersConnection';
  edges: Array<CharacterEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Comp = {
  __typename?: 'Comp';
  alt: Scalars['Boolean']['output'];
  circled: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  takes: Array<Take>;
  takesConnection: CompTakesConnection;
};


export type CompTakesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TakeOptions>;
  where?: InputMaybe<TakeWhere>;
};


export type CompTakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CompTakesConnectionSort>>;
  where?: InputMaybe<CompTakesConnectionWhere>;
};

export type CompEdge = {
  __typename?: 'CompEdge';
  cursor: Scalars['String']['output'];
  node: Comp;
};

/**
 * The edge properties for the following fields:
 * * Comp.takes
 */
export type CompHasTake = {
  __typename?: 'CompHasTake';
  subStrings: Scalars['String']['output'];
};

export type CompHasTakeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompHasTakeAggregationWhereInput>>;
  NOT?: InputMaybe<CompHasTakeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompHasTakeAggregationWhereInput>>;
  subStrings_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subStrings_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subStrings_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subStrings_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subStrings_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subStrings_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subStrings_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subStrings_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subStrings_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subStrings_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subStrings_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subStrings_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subStrings_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subStrings_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subStrings_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompHasTakeSort = {
  subStrings?: InputMaybe<SortDirection>;
};

export type CompHasTakeWhere = {
  AND?: InputMaybe<Array<CompHasTakeWhere>>;
  NOT?: InputMaybe<CompHasTakeWhere>;
  OR?: InputMaybe<Array<CompHasTakeWhere>>;
  subStrings?: InputMaybe<Scalars['String']['input']>;
  subStrings_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subStrings_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subStrings_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  subStrings_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CompOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CompSort objects to sort Comps by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CompSort>>;
};

/** Fields to sort Comps by. The order in which sorts are applied is not guaranteed when specifying many fields in one CompSort object. */
export type CompSort = {
  alt?: InputMaybe<SortDirection>;
  circled?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  note?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
};

export type CompTakesAggregateInput = {
  AND?: InputMaybe<Array<CompTakesAggregateInput>>;
  NOT?: InputMaybe<CompTakesAggregateInput>;
  OR?: InputMaybe<Array<CompTakesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CompHasTakeAggregationWhereInput>;
  node?: InputMaybe<CompTakesNodeAggregationWhereInput>;
};

export type CompTakesConnection = {
  __typename?: 'CompTakesConnection';
  edges: Array<CompTakesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompTakesConnectionSort = {
  edge?: InputMaybe<CompHasTakeSort>;
  node?: InputMaybe<TakeSort>;
};

export type CompTakesConnectionWhere = {
  AND?: InputMaybe<Array<CompTakesConnectionWhere>>;
  NOT?: InputMaybe<CompTakesConnectionWhere>;
  OR?: InputMaybe<Array<CompTakesConnectionWhere>>;
  edge?: InputMaybe<CompHasTakeWhere>;
  node?: InputMaybe<TakeWhere>;
};

export type CompTakesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CompTakesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CompTakesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CompTakesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  take_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CompTakesRelationship = {
  __typename?: 'CompTakesRelationship';
  cursor: Scalars['String']['output'];
  node: Take;
  properties: CompHasTake;
};

export type CompWhere = {
  AND?: InputMaybe<Array<CompWhere>>;
  NOT?: InputMaybe<CompWhere>;
  OR?: InputMaybe<Array<CompWhere>>;
  alt?: InputMaybe<Scalars['Boolean']['input']>;
  circled?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  note_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  note_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  note_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  note_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  takesAggregate?: InputMaybe<CompTakesAggregateInput>;
  /** Return Comps where all of the related CompTakesConnections match this filter */
  takesConnection_ALL?: InputMaybe<CompTakesConnectionWhere>;
  /** Return Comps where none of the related CompTakesConnections match this filter */
  takesConnection_NONE?: InputMaybe<CompTakesConnectionWhere>;
  /** Return Comps where one of the related CompTakesConnections match this filter */
  takesConnection_SINGLE?: InputMaybe<CompTakesConnectionWhere>;
  /** Return Comps where some of the related CompTakesConnections match this filter */
  takesConnection_SOME?: InputMaybe<CompTakesConnectionWhere>;
  /** Return Comps where all of the related Takes match this filter */
  takes_ALL?: InputMaybe<TakeWhere>;
  /** Return Comps where none of the related Takes match this filter */
  takes_NONE?: InputMaybe<TakeWhere>;
  /** Return Comps where one of the related Takes match this filter */
  takes_SINGLE?: InputMaybe<TakeWhere>;
  /** Return Comps where some of the related Takes match this filter */
  takes_SOME?: InputMaybe<TakeWhere>;
};

export type CompsConnection = {
  __typename?: 'CompsConnection';
  edges: Array<CompEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContextBlock = {
  __typename?: 'ContextBlock';
  audios: Array<Audio>;
  audiosConnection: ContextBlockAudiosConnection;
  created: Scalars['DateTime']['output'];
  episode?: Maybe<Episode>;
  episodeConnection: ContextBlockEpisodeConnection;
  id: Scalars['ID']['output'];
  ordinal: Scalars['Float']['output'];
  script?: Maybe<Script>;
  scriptConnection: ContextBlockScriptConnection;
  text: Scalars['String']['output'];
  type: ContextBlockType;
};


export type ContextBlockAudiosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AudioOptions>;
  where?: InputMaybe<AudioWhere>;
};


export type ContextBlockAudiosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContextBlockAudiosConnectionSort>>;
  where?: InputMaybe<ContextBlockAudiosConnectionWhere>;
};


export type ContextBlockEpisodeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type ContextBlockEpisodeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContextBlockEpisodeConnectionSort>>;
  where?: InputMaybe<ContextBlockEpisodeConnectionWhere>;
};


export type ContextBlockScriptArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScriptOptions>;
  where?: InputMaybe<ScriptWhere>;
};


export type ContextBlockScriptConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContextBlockScriptConnectionSort>>;
  where?: InputMaybe<ContextBlockScriptConnectionWhere>;
};

export type ContextBlockAudiosAggregateInput = {
  AND?: InputMaybe<Array<ContextBlockAudiosAggregateInput>>;
  NOT?: InputMaybe<ContextBlockAudiosAggregateInput>;
  OR?: InputMaybe<Array<ContextBlockAudiosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContextBlockAudiosNodeAggregationWhereInput>;
};

export type ContextBlockAudiosConnection = {
  __typename?: 'ContextBlockAudiosConnection';
  edges: Array<ContextBlockAudiosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContextBlockAudiosConnectionSort = {
  node?: InputMaybe<AudioSort>;
};

export type ContextBlockAudiosConnectionWhere = {
  AND?: InputMaybe<Array<ContextBlockAudiosConnectionWhere>>;
  NOT?: InputMaybe<ContextBlockAudiosConnectionWhere>;
  OR?: InputMaybe<Array<ContextBlockAudiosConnectionWhere>>;
  node?: InputMaybe<AudioWhere>;
};

export type ContextBlockAudiosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContextBlockAudiosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContextBlockAudiosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContextBlockAudiosNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContextBlockAudiosRelationship = {
  __typename?: 'ContextBlockAudiosRelationship';
  cursor: Scalars['String']['output'];
  node: Audio;
};

export type ContextBlockEdge = {
  __typename?: 'ContextBlockEdge';
  cursor: Scalars['String']['output'];
  node: ContextBlock;
};

export type ContextBlockEpisodeAggregateInput = {
  AND?: InputMaybe<Array<ContextBlockEpisodeAggregateInput>>;
  NOT?: InputMaybe<ContextBlockEpisodeAggregateInput>;
  OR?: InputMaybe<Array<ContextBlockEpisodeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContextBlockEpisodeNodeAggregationWhereInput>;
};

export type ContextBlockEpisodeConnection = {
  __typename?: 'ContextBlockEpisodeConnection';
  edges: Array<ContextBlockEpisodeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContextBlockEpisodeConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type ContextBlockEpisodeConnectionWhere = {
  AND?: InputMaybe<Array<ContextBlockEpisodeConnectionWhere>>;
  NOT?: InputMaybe<ContextBlockEpisodeConnectionWhere>;
  OR?: InputMaybe<Array<ContextBlockEpisodeConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type ContextBlockEpisodeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContextBlockEpisodeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContextBlockEpisodeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContextBlockEpisodeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContextBlockEpisodeRelationship = {
  __typename?: 'ContextBlockEpisodeRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type ContextBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ContextBlockSort objects to sort ContextBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ContextBlockSort>>;
};

export type ContextBlockScriptAggregateInput = {
  AND?: InputMaybe<Array<ContextBlockScriptAggregateInput>>;
  NOT?: InputMaybe<ContextBlockScriptAggregateInput>;
  OR?: InputMaybe<Array<ContextBlockScriptAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContextBlockScriptNodeAggregationWhereInput>;
};

export type ContextBlockScriptConnection = {
  __typename?: 'ContextBlockScriptConnection';
  edges: Array<ContextBlockScriptRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContextBlockScriptConnectionSort = {
  node?: InputMaybe<ScriptSort>;
};

export type ContextBlockScriptConnectionWhere = {
  AND?: InputMaybe<Array<ContextBlockScriptConnectionWhere>>;
  NOT?: InputMaybe<ContextBlockScriptConnectionWhere>;
  OR?: InputMaybe<Array<ContextBlockScriptConnectionWhere>>;
  node?: InputMaybe<ScriptWhere>;
};

export type ContextBlockScriptNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContextBlockScriptNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContextBlockScriptNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContextBlockScriptNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ContextBlockScriptRelationship = {
  __typename?: 'ContextBlockScriptRelationship';
  cursor: Scalars['String']['output'];
  node: Script;
};

/** Fields to sort ContextBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContextBlockSort object. */
export type ContextBlockSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  ordinal?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum ContextBlockType {
  Action = 'ACTION',
  EndAct = 'END_ACT',
  General = 'GENERAL',
  NewAct = 'NEW_ACT',
  SceneHeading = 'SCENE_HEADING',
  Shot = 'SHOT',
  Transition = 'TRANSITION'
}

export type ContextBlockWhere = {
  AND?: InputMaybe<Array<ContextBlockWhere>>;
  NOT?: InputMaybe<ContextBlockWhere>;
  OR?: InputMaybe<Array<ContextBlockWhere>>;
  audiosAggregate?: InputMaybe<ContextBlockAudiosAggregateInput>;
  /** Return ContextBlocks where all of the related ContextBlockAudiosConnections match this filter */
  audiosConnection_ALL?: InputMaybe<ContextBlockAudiosConnectionWhere>;
  /** Return ContextBlocks where none of the related ContextBlockAudiosConnections match this filter */
  audiosConnection_NONE?: InputMaybe<ContextBlockAudiosConnectionWhere>;
  /** Return ContextBlocks where one of the related ContextBlockAudiosConnections match this filter */
  audiosConnection_SINGLE?: InputMaybe<ContextBlockAudiosConnectionWhere>;
  /** Return ContextBlocks where some of the related ContextBlockAudiosConnections match this filter */
  audiosConnection_SOME?: InputMaybe<ContextBlockAudiosConnectionWhere>;
  /** Return ContextBlocks where all of the related Audio match this filter */
  audios_ALL?: InputMaybe<AudioWhere>;
  /** Return ContextBlocks where none of the related Audio match this filter */
  audios_NONE?: InputMaybe<AudioWhere>;
  /** Return ContextBlocks where one of the related Audio match this filter */
  audios_SINGLE?: InputMaybe<AudioWhere>;
  /** Return ContextBlocks where some of the related Audio match this filter */
  audios_SOME?: InputMaybe<AudioWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  episode?: InputMaybe<EpisodeWhere>;
  episodeAggregate?: InputMaybe<ContextBlockEpisodeAggregateInput>;
  episodeConnection?: InputMaybe<ContextBlockEpisodeConnectionWhere>;
  episodeConnection_NOT?: InputMaybe<ContextBlockEpisodeConnectionWhere>;
  episode_NOT?: InputMaybe<EpisodeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<ScriptWhere>;
  scriptAggregate?: InputMaybe<ContextBlockScriptAggregateInput>;
  scriptConnection?: InputMaybe<ContextBlockScriptConnectionWhere>;
  scriptConnection_NOT?: InputMaybe<ContextBlockScriptConnectionWhere>;
  script_NOT?: InputMaybe<ScriptWhere>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContextBlockType>;
  type_IN?: InputMaybe<Array<ContextBlockType>>;
};

export type ContextBlocksConnection = {
  __typename?: 'ContextBlocksConnection';
  edges: Array<ContextBlockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateCharacter = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateCharactersMutationResponse = {
  __typename?: 'CreateCharactersMutationResponse';
  characters: Array<Character>;
  info: CreateInfo;
};

export type CreateContextBlock = {
  id: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  type: ContextBlockType;
};

export type CreateEpisodesMutationResponse = {
  __typename?: 'CreateEpisodesMutationResponse';
  episodes: Array<Episode>;
  info: CreateInfo;
};

/** Information about the number of nodes and relationships created during a create mutation */
export type CreateInfo = {
  __typename?: 'CreateInfo';
  /** @deprecated This field has been deprecated because bookmarks are now handled by the driver. */
  bookmark?: Maybe<Scalars['String']['output']>;
  nodesCreated: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
};

export type CreateLineGroup = {
  id: Scalars['String']['input'];
  lineNo: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  parent: GroupParent;
  unchangedChildren: Array<UnchangedGroupChildren>;
};

export type CreateSeasonsMutationResponse = {
  __typename?: 'CreateSeasonsMutationResponse';
  info: CreateInfo;
  seasons: Array<Season>;
};

export type CreateShowsMutationResponse = {
  __typename?: 'CreateShowsMutationResponse';
  info: CreateInfo;
  shows: Array<Show>;
};

export type CreateSong = {
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  unchangedChildren: Array<UnchangedSongChildren>;
};

export type DeleteInfo = {
  __typename?: 'DeleteInfo';
  nodesDeleted: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type DetachContent = {
  id: Scalars['String']['input'];
  type: DetachContentType;
};

export enum DetachContentType {
  Line = 'LINE',
  LineGroup = 'LINE_GROUP',
  Song = 'SONG'
}

export type Episode = {
  __typename?: 'Episode';
  characters: Array<Character>;
  charactersConnection: EpisodeCharactersConnection;
  content: Array<EpisodeContent>;
  contentConnection: EpisodeContentConnection;
  created: Scalars['DateTime']['output'];
  currentScript?: Maybe<Script>;
  currentScriptConnection: EpisodeCurrentScriptConnection;
  hasLines?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  recordingSessions: Array<RecordingSession>;
  recordingSessionsConnection: EpisodeRecordingSessionsConnection;
  scripts: Array<Script>;
  season: Season;
  seasonConnection: EpisodeSeasonConnection;
  title: Scalars['String']['output'];
  totalVoices: Scalars['Int']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type EpisodeCharactersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type EpisodeCharactersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EpisodeCharactersConnectionSort>>;
  where?: InputMaybe<EpisodeCharactersConnectionWhere>;
};


export type EpisodeContentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<EpisodeContentWhere>;
};


export type EpisodeContentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EpisodeContentConnectionWhere>;
};


export type EpisodeCurrentScriptArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScriptOptions>;
  where?: InputMaybe<ScriptWhere>;
};


export type EpisodeCurrentScriptConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EpisodeCurrentScriptConnectionSort>>;
  where?: InputMaybe<EpisodeCurrentScriptConnectionWhere>;
};


export type EpisodeRecordingSessionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordingSessionOptions>;
  where?: InputMaybe<RecordingSessionWhere>;
};


export type EpisodeRecordingSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EpisodeRecordingSessionsConnectionSort>>;
  where?: InputMaybe<EpisodeRecordingSessionsConnectionWhere>;
};


export type EpisodeSeasonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SeasonOptions>;
  where?: InputMaybe<SeasonWhere>;
};


export type EpisodeSeasonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EpisodeSeasonConnectionSort>>;
  where?: InputMaybe<EpisodeSeasonConnectionWhere>;
};

export type EpisodeCharactersAggregateInput = {
  AND?: InputMaybe<Array<EpisodeCharactersAggregateInput>>;
  NOT?: InputMaybe<EpisodeCharactersAggregateInput>;
  OR?: InputMaybe<Array<EpisodeCharactersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EpisodeCharactersNodeAggregationWhereInput>;
};

export type EpisodeCharactersConnectFieldInput = {
  connect?: InputMaybe<Array<CharacterConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CharacterConnectWhere>;
};

export type EpisodeCharactersConnection = {
  __typename?: 'EpisodeCharactersConnection';
  edges: Array<EpisodeCharactersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EpisodeCharactersConnectionSort = {
  node?: InputMaybe<CharacterSort>;
};

export type EpisodeCharactersConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeCharactersConnectionWhere>>;
  NOT?: InputMaybe<EpisodeCharactersConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeCharactersConnectionWhere>>;
  node?: InputMaybe<CharacterWhere>;
};

export type EpisodeCharactersCreateFieldInput = {
  node: CharacterCreateInput;
};

export type EpisodeCharactersFieldInput = {
  connect?: InputMaybe<Array<EpisodeCharactersConnectFieldInput>>;
  create?: InputMaybe<Array<EpisodeCharactersCreateFieldInput>>;
};

export type EpisodeCharactersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EpisodeCharactersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EpisodeCharactersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EpisodeCharactersNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EpisodeCharactersRelationship = {
  __typename?: 'EpisodeCharactersRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type EpisodeCharactersUpdateConnectionInput = {
  node?: InputMaybe<CharacterUpdateInput>;
};

export type EpisodeCharactersUpdateFieldInput = {
  connect?: InputMaybe<Array<EpisodeCharactersConnectFieldInput>>;
  create?: InputMaybe<Array<EpisodeCharactersCreateFieldInput>>;
  update?: InputMaybe<EpisodeCharactersUpdateConnectionInput>;
  where?: InputMaybe<EpisodeCharactersConnectionWhere>;
};

export type EpisodeConnectInput = {
  characters?: InputMaybe<Array<EpisodeCharactersConnectFieldInput>>;
  season?: InputMaybe<EpisodeSeasonConnectFieldInput>;
};

export type EpisodeConnectWhere = {
  node: EpisodeWhere;
};

export type EpisodeContent = Audio | AudioGroup | ContextBlock | Line | LineGroup;

export type EpisodeContentAudioConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeContentAudioConnectionWhere>>;
  NOT?: InputMaybe<EpisodeContentAudioConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeContentAudioConnectionWhere>>;
  node?: InputMaybe<AudioWhere>;
};

export type EpisodeContentAudioGroupConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeContentAudioGroupConnectionWhere>>;
  NOT?: InputMaybe<EpisodeContentAudioGroupConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeContentAudioGroupConnectionWhere>>;
  node?: InputMaybe<AudioGroupWhere>;
};

export type EpisodeContentConnection = {
  __typename?: 'EpisodeContentConnection';
  edges: Array<EpisodeContentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EpisodeContentConnectionWhere = {
  Audio?: InputMaybe<EpisodeContentAudioConnectionWhere>;
  AudioGroup?: InputMaybe<EpisodeContentAudioGroupConnectionWhere>;
  ContextBlock?: InputMaybe<EpisodeContentContextBlockConnectionWhere>;
  Line?: InputMaybe<EpisodeContentLineConnectionWhere>;
  LineGroup?: InputMaybe<EpisodeContentLineGroupConnectionWhere>;
};

export type EpisodeContentContextBlockConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeContentContextBlockConnectionWhere>>;
  NOT?: InputMaybe<EpisodeContentContextBlockConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeContentContextBlockConnectionWhere>>;
  node?: InputMaybe<ContextBlockWhere>;
};

export type EpisodeContentLineConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeContentLineConnectionWhere>>;
  NOT?: InputMaybe<EpisodeContentLineConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeContentLineConnectionWhere>>;
  node?: InputMaybe<LineWhere>;
};

export type EpisodeContentLineGroupConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeContentLineGroupConnectionWhere>>;
  NOT?: InputMaybe<EpisodeContentLineGroupConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeContentLineGroupConnectionWhere>>;
  node?: InputMaybe<LineGroupWhere>;
};

export type EpisodeContentRelationship = {
  __typename?: 'EpisodeContentRelationship';
  cursor: Scalars['String']['output'];
  node: EpisodeContent;
};

export type EpisodeContentWhere = {
  Audio?: InputMaybe<AudioWhere>;
  AudioGroup?: InputMaybe<AudioGroupWhere>;
  ContextBlock?: InputMaybe<ContextBlockWhere>;
  Line?: InputMaybe<LineWhere>;
  LineGroup?: InputMaybe<LineGroupWhere>;
};

export type EpisodeCreateInput = {
  characters?: InputMaybe<EpisodeCharactersFieldInput>;
  season?: InputMaybe<EpisodeSeasonFieldInput>;
  title: Scalars['String']['input'];
};

export type EpisodeCurrentScriptAggregateInput = {
  AND?: InputMaybe<Array<EpisodeCurrentScriptAggregateInput>>;
  NOT?: InputMaybe<EpisodeCurrentScriptAggregateInput>;
  OR?: InputMaybe<Array<EpisodeCurrentScriptAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EpisodeCurrentScriptNodeAggregationWhereInput>;
};

export type EpisodeCurrentScriptConnection = {
  __typename?: 'EpisodeCurrentScriptConnection';
  edges: Array<EpisodeCurrentScriptRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EpisodeCurrentScriptConnectionSort = {
  node?: InputMaybe<ScriptSort>;
};

export type EpisodeCurrentScriptConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeCurrentScriptConnectionWhere>>;
  NOT?: InputMaybe<EpisodeCurrentScriptConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeCurrentScriptConnectionWhere>>;
  node?: InputMaybe<ScriptWhere>;
};

export type EpisodeCurrentScriptNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EpisodeCurrentScriptNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EpisodeCurrentScriptNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EpisodeCurrentScriptNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EpisodeCurrentScriptRelationship = {
  __typename?: 'EpisodeCurrentScriptRelationship';
  cursor: Scalars['String']['output'];
  node: Script;
};

export type EpisodeEdge = {
  __typename?: 'EpisodeEdge';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type EpisodeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EpisodeSort objects to sort Episodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EpisodeSort>>;
};

export type EpisodeRecordingSessionsAggregateInput = {
  AND?: InputMaybe<Array<EpisodeRecordingSessionsAggregateInput>>;
  NOT?: InputMaybe<EpisodeRecordingSessionsAggregateInput>;
  OR?: InputMaybe<Array<EpisodeRecordingSessionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EpisodeRecordingSessionsNodeAggregationWhereInput>;
};

export type EpisodeRecordingSessionsConnection = {
  __typename?: 'EpisodeRecordingSessionsConnection';
  edges: Array<EpisodeRecordingSessionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EpisodeRecordingSessionsConnectionSort = {
  edge?: InputMaybe<SessionHasEpisodeSort>;
  node?: InputMaybe<RecordingSessionSort>;
};

export type EpisodeRecordingSessionsConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeRecordingSessionsConnectionWhere>>;
  NOT?: InputMaybe<EpisodeRecordingSessionsConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeRecordingSessionsConnectionWhere>>;
  edge?: InputMaybe<SessionHasEpisodeWhere>;
  node?: InputMaybe<RecordingSessionWhere>;
};

export type EpisodeRecordingSessionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EpisodeRecordingSessionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EpisodeRecordingSessionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EpisodeRecordingSessionsNodeAggregationWhereInput>>;
  actor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  beginTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  engineer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  engineer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  studio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  studio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EpisodeRecordingSessionsRelationship = {
  __typename?: 'EpisodeRecordingSessionsRelationship';
  cursor: Scalars['String']['output'];
  node: RecordingSession;
  properties: SessionHasEpisode;
};

export type EpisodeRelationInput = {
  characters?: InputMaybe<Array<EpisodeCharactersCreateFieldInput>>;
  season?: InputMaybe<EpisodeSeasonCreateFieldInput>;
};

export type EpisodeSeasonAggregateInput = {
  AND?: InputMaybe<Array<EpisodeSeasonAggregateInput>>;
  NOT?: InputMaybe<EpisodeSeasonAggregateInput>;
  OR?: InputMaybe<Array<EpisodeSeasonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EpisodeSeasonNodeAggregationWhereInput>;
};

export type EpisodeSeasonConnectFieldInput = {
  connect?: InputMaybe<SeasonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SeasonConnectWhere>;
};

export type EpisodeSeasonConnection = {
  __typename?: 'EpisodeSeasonConnection';
  edges: Array<EpisodeSeasonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EpisodeSeasonConnectionSort = {
  node?: InputMaybe<SeasonSort>;
};

export type EpisodeSeasonConnectionWhere = {
  AND?: InputMaybe<Array<EpisodeSeasonConnectionWhere>>;
  NOT?: InputMaybe<EpisodeSeasonConnectionWhere>;
  OR?: InputMaybe<Array<EpisodeSeasonConnectionWhere>>;
  node?: InputMaybe<SeasonWhere>;
};

export type EpisodeSeasonCreateFieldInput = {
  node: SeasonCreateInput;
};

export type EpisodeSeasonFieldInput = {
  connect?: InputMaybe<EpisodeSeasonConnectFieldInput>;
  create?: InputMaybe<EpisodeSeasonCreateFieldInput>;
};

export type EpisodeSeasonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EpisodeSeasonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EpisodeSeasonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EpisodeSeasonNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EpisodeSeasonRelationship = {
  __typename?: 'EpisodeSeasonRelationship';
  cursor: Scalars['String']['output'];
  node: Season;
};

export type EpisodeSeasonUpdateConnectionInput = {
  node?: InputMaybe<SeasonUpdateInput>;
};

export type EpisodeSeasonUpdateFieldInput = {
  connect?: InputMaybe<EpisodeSeasonConnectFieldInput>;
  create?: InputMaybe<EpisodeSeasonCreateFieldInput>;
  update?: InputMaybe<EpisodeSeasonUpdateConnectionInput>;
  where?: InputMaybe<EpisodeSeasonConnectionWhere>;
};

/** Fields to sort Episodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one EpisodeSort object. */
export type EpisodeSort = {
  created?: InputMaybe<SortDirection>;
  hasLines?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  totalVoices?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export type EpisodeUpdateInput = {
  characters?: InputMaybe<Array<EpisodeCharactersUpdateFieldInput>>;
  season?: InputMaybe<EpisodeSeasonUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeWhere = {
  AND?: InputMaybe<Array<EpisodeWhere>>;
  NOT?: InputMaybe<EpisodeWhere>;
  OR?: InputMaybe<Array<EpisodeWhere>>;
  charactersAggregate?: InputMaybe<EpisodeCharactersAggregateInput>;
  /** Return Episodes where all of the related EpisodeCharactersConnections match this filter */
  charactersConnection_ALL?: InputMaybe<EpisodeCharactersConnectionWhere>;
  /** Return Episodes where none of the related EpisodeCharactersConnections match this filter */
  charactersConnection_NONE?: InputMaybe<EpisodeCharactersConnectionWhere>;
  /** Return Episodes where one of the related EpisodeCharactersConnections match this filter */
  charactersConnection_SINGLE?: InputMaybe<EpisodeCharactersConnectionWhere>;
  /** Return Episodes where some of the related EpisodeCharactersConnections match this filter */
  charactersConnection_SOME?: InputMaybe<EpisodeCharactersConnectionWhere>;
  /** Return Episodes where all of the related Characters match this filter */
  characters_ALL?: InputMaybe<CharacterWhere>;
  /** Return Episodes where none of the related Characters match this filter */
  characters_NONE?: InputMaybe<CharacterWhere>;
  /** Return Episodes where one of the related Characters match this filter */
  characters_SINGLE?: InputMaybe<CharacterWhere>;
  /** Return Episodes where some of the related Characters match this filter */
  characters_SOME?: InputMaybe<CharacterWhere>;
  /** Return Episodes where all of the related EpisodeContentConnections match this filter */
  contentConnection_ALL?: InputMaybe<EpisodeContentConnectionWhere>;
  /** Return Episodes where none of the related EpisodeContentConnections match this filter */
  contentConnection_NONE?: InputMaybe<EpisodeContentConnectionWhere>;
  /** Return Episodes where one of the related EpisodeContentConnections match this filter */
  contentConnection_SINGLE?: InputMaybe<EpisodeContentConnectionWhere>;
  /** Return Episodes where some of the related EpisodeContentConnections match this filter */
  contentConnection_SOME?: InputMaybe<EpisodeContentConnectionWhere>;
  /** Return Episodes where all of the related EpisodeContents match this filter */
  content_ALL?: InputMaybe<EpisodeContentWhere>;
  /** Return Episodes where none of the related EpisodeContents match this filter */
  content_NONE?: InputMaybe<EpisodeContentWhere>;
  /** Return Episodes where one of the related EpisodeContents match this filter */
  content_SINGLE?: InputMaybe<EpisodeContentWhere>;
  /** Return Episodes where some of the related EpisodeContents match this filter */
  content_SOME?: InputMaybe<EpisodeContentWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentScript?: InputMaybe<ScriptWhere>;
  currentScriptAggregate?: InputMaybe<EpisodeCurrentScriptAggregateInput>;
  currentScriptConnection?: InputMaybe<EpisodeCurrentScriptConnectionWhere>;
  currentScriptConnection_NOT?: InputMaybe<EpisodeCurrentScriptConnectionWhere>;
  currentScript_NOT?: InputMaybe<ScriptWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordingSessionsAggregate?: InputMaybe<EpisodeRecordingSessionsAggregateInput>;
  /** Return Episodes where all of the related EpisodeRecordingSessionsConnections match this filter */
  recordingSessionsConnection_ALL?: InputMaybe<EpisodeRecordingSessionsConnectionWhere>;
  /** Return Episodes where none of the related EpisodeRecordingSessionsConnections match this filter */
  recordingSessionsConnection_NONE?: InputMaybe<EpisodeRecordingSessionsConnectionWhere>;
  /** Return Episodes where one of the related EpisodeRecordingSessionsConnections match this filter */
  recordingSessionsConnection_SINGLE?: InputMaybe<EpisodeRecordingSessionsConnectionWhere>;
  /** Return Episodes where some of the related EpisodeRecordingSessionsConnections match this filter */
  recordingSessionsConnection_SOME?: InputMaybe<EpisodeRecordingSessionsConnectionWhere>;
  /** Return Episodes where all of the related RecordingSessions match this filter */
  recordingSessions_ALL?: InputMaybe<RecordingSessionWhere>;
  /** Return Episodes where none of the related RecordingSessions match this filter */
  recordingSessions_NONE?: InputMaybe<RecordingSessionWhere>;
  /** Return Episodes where one of the related RecordingSessions match this filter */
  recordingSessions_SINGLE?: InputMaybe<RecordingSessionWhere>;
  /** Return Episodes where some of the related RecordingSessions match this filter */
  recordingSessions_SOME?: InputMaybe<RecordingSessionWhere>;
  season?: InputMaybe<SeasonWhere>;
  seasonAggregate?: InputMaybe<EpisodeSeasonAggregateInput>;
  seasonConnection?: InputMaybe<EpisodeSeasonConnectionWhere>;
  seasonConnection_NOT?: InputMaybe<EpisodeSeasonConnectionWhere>;
  season_NOT?: InputMaybe<SeasonWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EpisodesConnection = {
  __typename?: 'EpisodesConnection';
  edges: Array<EpisodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupParent = {
  id: Scalars['String']['input'];
  type: GroupParentType;
};

export enum GroupParentType {
  Episode = 'EPISODE',
  Song = 'SONG'
}

/**
 * The edge properties for the following fields:
 * * Line.takes
 * * Take.line
 * * Take.audio
 * * Audio.takes
 */
export type HasTake = {
  __typename?: 'HasTake';
  select?: Maybe<SelectType>;
};

export type HasTakeSort = {
  select?: InputMaybe<SortDirection>;
};

export type HasTakeWhere = {
  AND?: InputMaybe<Array<HasTakeWhere>>;
  NOT?: InputMaybe<HasTakeWhere>;
  OR?: InputMaybe<Array<HasTakeWhere>>;
  select?: InputMaybe<SelectType>;
  select_IN?: InputMaybe<Array<InputMaybe<SelectType>>>;
};

export type IdResult = {
  __typename?: 'IdResult';
  id: Scalars['String']['output'];
};

export type InitialCharacter = {
  alias?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InitialLine = {
  character: InitialCharacter;
  groupId?: InputMaybe<Scalars['String']['input']>;
  library: Scalars['Boolean']['input'];
  lineNo: Scalars['String']['input'];
  lineStatus: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  performanceNotes?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type InitialLineGroup = {
  id: Scalars['String']['input'];
  lineNo: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
};

export type InitialRecordingSession = {
  id: Scalars['String']['input'];
  scratch: Scalars['Boolean']['input'];
  type: RecordingSessionType;
};

export enum Library {
  Required = 'REQUIRED',
  Satisfied = 'SATISFIED'
}

export type Line = {
  __typename?: 'Line';
  allTakes: Array<Take>;
  cancelled: Scalars['Boolean']['output'];
  character: Character;
  characterConnection: LineCharacterConnection;
  characterName: Scalars['String']['output'];
  comps: Array<Comp>;
  compsConnection: LineCompsConnection;
  created: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['String']['output']>;
  episode?: Maybe<Episode>;
  episodeConnection: LineEpisodeConnection;
  groups: Array<LineGroup>;
  groupsConnection: LineGroupsConnection;
  hasOverride: Scalars['Boolean']['output'];
  hasRevisions: Scalars['Boolean']['output'];
  hasTakes: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  library?: Maybe<Library>;
  lineNo: Scalars['String']['output'];
  lineStatus: LineStatus;
  ordinal: Scalars['Float']['output'];
  override?: Maybe<Take>;
  overrideCharacter?: Maybe<Character>;
  overrideCharacterName?: Maybe<Scalars['String']['output']>;
  overrideConnection: LineOverrideConnection;
  overrideText?: Maybe<Scalars['String']['output']>;
  performanceNotes?: Maybe<Scalars['String']['output']>;
  recordingStatus: RecordingStatus;
  revisionChainId: Scalars['ID']['output'];
  revisions: Array<Line>;
  script: Script;
  selectInfo: SelectInfo;
  takes: Array<Take>;
  takesConnection: LineTakesConnection;
  text: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type LineAllTakesArgs = {
  recordingSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type LineCharacterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type LineCharacterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineCharacterConnectionSort>>;
  where?: InputMaybe<LineCharacterConnectionWhere>;
};


export type LineCompsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CompOptions>;
  where?: InputMaybe<CompWhere>;
};


export type LineCompsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineCompsConnectionSort>>;
  where?: InputMaybe<LineCompsConnectionWhere>;
};


export type LineEpisodeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type LineEpisodeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineEpisodeConnectionSort>>;
  where?: InputMaybe<LineEpisodeConnectionWhere>;
};


export type LineGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LineGroupOptions>;
  where?: InputMaybe<LineGroupWhere>;
};


export type LineGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineGroupsConnectionSort>>;
  where?: InputMaybe<LineGroupsConnectionWhere>;
};


export type LineOverrideArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TakeOptions>;
  where?: InputMaybe<TakeWhere>;
};


export type LineOverrideConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineOverrideConnectionSort>>;
  where?: InputMaybe<LineOverrideConnectionWhere>;
};


export type LineRecordingStatusArgs = {
  recordingSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type LineTakesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TakeOptions>;
  where?: InputMaybe<TakeWhere>;
};


export type LineTakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineTakesConnectionSort>>;
  where?: InputMaybe<LineTakesConnectionWhere>;
};

export type LineCharacterAggregateInput = {
  AND?: InputMaybe<Array<LineCharacterAggregateInput>>;
  NOT?: InputMaybe<LineCharacterAggregateInput>;
  OR?: InputMaybe<Array<LineCharacterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CharacterHasLineAggregationWhereInput>;
  node?: InputMaybe<LineCharacterNodeAggregationWhereInput>;
};

export type LineCharacterConnection = {
  __typename?: 'LineCharacterConnection';
  edges: Array<LineCharacterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineCharacterConnectionSort = {
  edge?: InputMaybe<CharacterHasLineSort>;
  node?: InputMaybe<CharacterSort>;
};

export type LineCharacterConnectionWhere = {
  AND?: InputMaybe<Array<LineCharacterConnectionWhere>>;
  NOT?: InputMaybe<LineCharacterConnectionWhere>;
  OR?: InputMaybe<Array<LineCharacterConnectionWhere>>;
  edge?: InputMaybe<CharacterHasLineWhere>;
  node?: InputMaybe<CharacterWhere>;
};

export type LineCharacterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineCharacterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineCharacterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineCharacterNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineCharacterRelationship = {
  __typename?: 'LineCharacterRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
  properties: CharacterHasLine;
};

export type LineCompsAggregateInput = {
  AND?: InputMaybe<Array<LineCompsAggregateInput>>;
  NOT?: InputMaybe<LineCompsAggregateInput>;
  OR?: InputMaybe<Array<LineCompsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineCompsNodeAggregationWhereInput>;
};

export type LineCompsConnection = {
  __typename?: 'LineCompsConnection';
  edges: Array<LineCompsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineCompsConnectionSort = {
  node?: InputMaybe<CompSort>;
};

export type LineCompsConnectionWhere = {
  AND?: InputMaybe<Array<LineCompsConnectionWhere>>;
  NOT?: InputMaybe<LineCompsConnectionWhere>;
  OR?: InputMaybe<Array<LineCompsConnectionWhere>>;
  node?: InputMaybe<CompWhere>;
};

export type LineCompsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineCompsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineCompsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineCompsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LineCompsRelationship = {
  __typename?: 'LineCompsRelationship';
  cursor: Scalars['String']['output'];
  node: Comp;
};

export type LineEdge = {
  __typename?: 'LineEdge';
  cursor: Scalars['String']['output'];
  node: Line;
};

export type LineEpisodeAggregateInput = {
  AND?: InputMaybe<Array<LineEpisodeAggregateInput>>;
  NOT?: InputMaybe<LineEpisodeAggregateInput>;
  OR?: InputMaybe<Array<LineEpisodeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineEpisodeNodeAggregationWhereInput>;
};

export type LineEpisodeConnection = {
  __typename?: 'LineEpisodeConnection';
  edges: Array<LineEpisodeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineEpisodeConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type LineEpisodeConnectionWhere = {
  AND?: InputMaybe<Array<LineEpisodeConnectionWhere>>;
  NOT?: InputMaybe<LineEpisodeConnectionWhere>;
  OR?: InputMaybe<Array<LineEpisodeConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type LineEpisodeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineEpisodeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineEpisodeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineEpisodeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineEpisodeRelationship = {
  __typename?: 'LineEpisodeRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type LineGroup = {
  __typename?: 'LineGroup';
  cancelled: Scalars['Boolean']['output'];
  characterName: Array<Scalars['String']['output']>;
  characters: Array<Character>;
  charactersConnection: LineGroupCharactersConnection;
  created: Scalars['DateTime']['output'];
  episode?: Maybe<Episode>;
  episodeConnection: LineGroupEpisodeConnection;
  id: Scalars['ID']['output'];
  lineNo: Scalars['String']['output'];
  lines: Array<Line>;
  linesConnection: LineGroupLinesConnection;
  ordinal: Scalars['Float']['output'];
  overrideText: Array<Scalars['String']['output']>;
  status: Array<LineStatus>;
  text: Array<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type LineGroupCharactersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type LineGroupCharactersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineGroupCharactersConnectionSort>>;
  where?: InputMaybe<LineGroupCharactersConnectionWhere>;
};


export type LineGroupEpisodeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type LineGroupEpisodeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineGroupEpisodeConnectionSort>>;
  where?: InputMaybe<LineGroupEpisodeConnectionWhere>;
};


export type LineGroupLinesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LineOptions>;
  where?: InputMaybe<LineWhere>;
};


export type LineGroupLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LineGroupLinesConnectionSort>>;
  where?: InputMaybe<LineGroupLinesConnectionWhere>;
};

export type LineGroupCharactersAggregateInput = {
  AND?: InputMaybe<Array<LineGroupCharactersAggregateInput>>;
  NOT?: InputMaybe<LineGroupCharactersAggregateInput>;
  OR?: InputMaybe<Array<LineGroupCharactersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineGroupCharactersNodeAggregationWhereInput>;
};

export type LineGroupCharactersConnection = {
  __typename?: 'LineGroupCharactersConnection';
  edges: Array<LineGroupCharactersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineGroupCharactersConnectionSort = {
  node?: InputMaybe<CharacterSort>;
};

export type LineGroupCharactersConnectionWhere = {
  AND?: InputMaybe<Array<LineGroupCharactersConnectionWhere>>;
  NOT?: InputMaybe<LineGroupCharactersConnectionWhere>;
  OR?: InputMaybe<Array<LineGroupCharactersConnectionWhere>>;
  node?: InputMaybe<CharacterWhere>;
};

export type LineGroupCharactersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineGroupCharactersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineGroupCharactersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineGroupCharactersNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineGroupCharactersRelationship = {
  __typename?: 'LineGroupCharactersRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type LineGroupEdge = {
  __typename?: 'LineGroupEdge';
  cursor: Scalars['String']['output'];
  node: LineGroup;
};

export type LineGroupEpisodeAggregateInput = {
  AND?: InputMaybe<Array<LineGroupEpisodeAggregateInput>>;
  NOT?: InputMaybe<LineGroupEpisodeAggregateInput>;
  OR?: InputMaybe<Array<LineGroupEpisodeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineGroupEpisodeNodeAggregationWhereInput>;
};

export type LineGroupEpisodeConnection = {
  __typename?: 'LineGroupEpisodeConnection';
  edges: Array<LineGroupEpisodeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineGroupEpisodeConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type LineGroupEpisodeConnectionWhere = {
  AND?: InputMaybe<Array<LineGroupEpisodeConnectionWhere>>;
  NOT?: InputMaybe<LineGroupEpisodeConnectionWhere>;
  OR?: InputMaybe<Array<LineGroupEpisodeConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type LineGroupEpisodeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineGroupEpisodeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineGroupEpisodeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineGroupEpisodeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineGroupEpisodeRelationship = {
  __typename?: 'LineGroupEpisodeRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type LineGroupLinesAggregateInput = {
  AND?: InputMaybe<Array<LineGroupLinesAggregateInput>>;
  NOT?: InputMaybe<LineGroupLinesAggregateInput>;
  OR?: InputMaybe<Array<LineGroupLinesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineGroupLinesNodeAggregationWhereInput>;
};

export type LineGroupLinesConnection = {
  __typename?: 'LineGroupLinesConnection';
  edges: Array<LineGroupLinesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineGroupLinesConnectionSort = {
  node?: InputMaybe<LineSort>;
};

export type LineGroupLinesConnectionWhere = {
  AND?: InputMaybe<Array<LineGroupLinesConnectionWhere>>;
  NOT?: InputMaybe<LineGroupLinesConnectionWhere>;
  OR?: InputMaybe<Array<LineGroupLinesConnectionWhere>>;
  node?: InputMaybe<LineWhere>;
};

export type LineGroupLinesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineGroupLinesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineGroupLinesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineGroupLinesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineGroupLinesRelationship = {
  __typename?: 'LineGroupLinesRelationship';
  cursor: Scalars['String']['output'];
  node: Line;
};

export type LineGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LineGroupSort objects to sort LineGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LineGroupSort>>;
};

/** Fields to sort LineGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one LineGroupSort object. */
export type LineGroupSort = {
  cancelled?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lineNo?: InputMaybe<SortDirection>;
  ordinal?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export type LineGroupWhere = {
  AND?: InputMaybe<Array<LineGroupWhere>>;
  NOT?: InputMaybe<LineGroupWhere>;
  OR?: InputMaybe<Array<LineGroupWhere>>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  charactersAggregate?: InputMaybe<LineGroupCharactersAggregateInput>;
  /** Return LineGroups where all of the related LineGroupCharactersConnections match this filter */
  charactersConnection_ALL?: InputMaybe<LineGroupCharactersConnectionWhere>;
  /** Return LineGroups where none of the related LineGroupCharactersConnections match this filter */
  charactersConnection_NONE?: InputMaybe<LineGroupCharactersConnectionWhere>;
  /** Return LineGroups where one of the related LineGroupCharactersConnections match this filter */
  charactersConnection_SINGLE?: InputMaybe<LineGroupCharactersConnectionWhere>;
  /** Return LineGroups where some of the related LineGroupCharactersConnections match this filter */
  charactersConnection_SOME?: InputMaybe<LineGroupCharactersConnectionWhere>;
  /** Return LineGroups where all of the related Characters match this filter */
  characters_ALL?: InputMaybe<CharacterWhere>;
  /** Return LineGroups where none of the related Characters match this filter */
  characters_NONE?: InputMaybe<CharacterWhere>;
  /** Return LineGroups where one of the related Characters match this filter */
  characters_SINGLE?: InputMaybe<CharacterWhere>;
  /** Return LineGroups where some of the related Characters match this filter */
  characters_SOME?: InputMaybe<CharacterWhere>;
  episode?: InputMaybe<EpisodeWhere>;
  episodeAggregate?: InputMaybe<LineGroupEpisodeAggregateInput>;
  episodeConnection?: InputMaybe<LineGroupEpisodeConnectionWhere>;
  episodeConnection_NOT?: InputMaybe<LineGroupEpisodeConnectionWhere>;
  episode_NOT?: InputMaybe<EpisodeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lineNo?: InputMaybe<Scalars['String']['input']>;
  lineNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lineNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lineNo_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lineNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  linesAggregate?: InputMaybe<LineGroupLinesAggregateInput>;
  /** Return LineGroups where all of the related LineGroupLinesConnections match this filter */
  linesConnection_ALL?: InputMaybe<LineGroupLinesConnectionWhere>;
  /** Return LineGroups where none of the related LineGroupLinesConnections match this filter */
  linesConnection_NONE?: InputMaybe<LineGroupLinesConnectionWhere>;
  /** Return LineGroups where one of the related LineGroupLinesConnections match this filter */
  linesConnection_SINGLE?: InputMaybe<LineGroupLinesConnectionWhere>;
  /** Return LineGroups where some of the related LineGroupLinesConnections match this filter */
  linesConnection_SOME?: InputMaybe<LineGroupLinesConnectionWhere>;
  /** Return LineGroups where all of the related Lines match this filter */
  lines_ALL?: InputMaybe<LineWhere>;
  /** Return LineGroups where none of the related Lines match this filter */
  lines_NONE?: InputMaybe<LineWhere>;
  /** Return LineGroups where one of the related Lines match this filter */
  lines_SINGLE?: InputMaybe<LineWhere>;
  /** Return LineGroups where some of the related Lines match this filter */
  lines_SOME?: InputMaybe<LineWhere>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LineGroupsAggregateInput = {
  AND?: InputMaybe<Array<LineGroupsAggregateInput>>;
  NOT?: InputMaybe<LineGroupsAggregateInput>;
  OR?: InputMaybe<Array<LineGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineGroupsNodeAggregationWhereInput>;
};

export type LineGroupsConnection = {
  __typename?: 'LineGroupsConnection';
  edges: Array<LineGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineGroupsConnectionSort = {
  node?: InputMaybe<LineGroupSort>;
};

export type LineGroupsConnectionWhere = {
  AND?: InputMaybe<Array<LineGroupsConnectionWhere>>;
  NOT?: InputMaybe<LineGroupsConnectionWhere>;
  OR?: InputMaybe<Array<LineGroupsConnectionWhere>>;
  node?: InputMaybe<LineGroupWhere>;
};

export type LineGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineGroupsNodeAggregationWhereInput>>;
  lineNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LineGroupsRelationship = {
  __typename?: 'LineGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: LineGroup;
};

export enum LineOperation {
  DataUpdate = 'DATA_UPDATE',
  DataUpdateHiddenRev = 'DATA_UPDATE_HIDDEN_REV',
  Edit = 'EDIT',
  LineChange = 'LINE_CHANGE',
  NewLine = 'NEW_LINE',
  NoChange = 'NO_CHANGE'
}

export type LineOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LineSort objects to sort Lines by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LineSort>>;
};

export type LineOverrideAggregateInput = {
  AND?: InputMaybe<Array<LineOverrideAggregateInput>>;
  NOT?: InputMaybe<LineOverrideAggregateInput>;
  OR?: InputMaybe<Array<LineOverrideAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineOverrideNodeAggregationWhereInput>;
};

export type LineOverrideConnection = {
  __typename?: 'LineOverrideConnection';
  edges: Array<LineOverrideRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineOverrideConnectionSort = {
  node?: InputMaybe<TakeSort>;
};

export type LineOverrideConnectionWhere = {
  AND?: InputMaybe<Array<LineOverrideConnectionWhere>>;
  NOT?: InputMaybe<LineOverrideConnectionWhere>;
  OR?: InputMaybe<Array<LineOverrideConnectionWhere>>;
  node?: InputMaybe<TakeWhere>;
};

export type LineOverrideNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineOverrideNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineOverrideNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineOverrideNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  take_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LineOverrideRelationship = {
  __typename?: 'LineOverrideRelationship';
  cursor: Scalars['String']['output'];
  node: Take;
};

export type LineParent = {
  id: Scalars['String']['input'];
  type: LineParentType;
};

export enum LineParentType {
  Episode = 'EPISODE',
  LineGroup = 'LINE_GROUP',
  Song = 'SONG'
}

/** Fields to sort Lines by. The order in which sorts are applied is not guaranteed when specifying many fields in one LineSort object. */
export type LineSort = {
  cancelled?: InputMaybe<SortDirection>;
  characterName?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  customFields?: InputMaybe<SortDirection>;
  hasOverride?: InputMaybe<SortDirection>;
  hasRevisions?: InputMaybe<SortDirection>;
  hasTakes?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  library?: InputMaybe<SortDirection>;
  lineNo?: InputMaybe<SortDirection>;
  lineStatus?: InputMaybe<SortDirection>;
  ordinal?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  overrideCharacter?: InputMaybe<SortDirection>;
  overrideCharacterName?: InputMaybe<SortDirection>;
  overrideText?: InputMaybe<SortDirection>;
  performanceNotes?: InputMaybe<SortDirection>;
  recordingStatus?: InputMaybe<SortDirection>;
  revisionChainId?: InputMaybe<SortDirection>;
  script?: InputMaybe<SortDirection>;
  selectInfo?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export enum LineStatus {
  Edit = 'EDIT',
  LineChange = 'LINE_CHANGE',
  LocationChange = 'LOCATION_CHANGE',
  NewLine = 'NEW_LINE',
  Original = 'ORIGINAL'
}

export type LineTakesAggregateInput = {
  AND?: InputMaybe<Array<LineTakesAggregateInput>>;
  NOT?: InputMaybe<LineTakesAggregateInput>;
  OR?: InputMaybe<Array<LineTakesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LineTakesNodeAggregationWhereInput>;
};

export type LineTakesConnection = {
  __typename?: 'LineTakesConnection';
  edges: Array<LineTakesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineTakesConnectionSort = {
  edge?: InputMaybe<HasTakeSort>;
  node?: InputMaybe<TakeSort>;
};

export type LineTakesConnectionWhere = {
  AND?: InputMaybe<Array<LineTakesConnectionWhere>>;
  NOT?: InputMaybe<LineTakesConnectionWhere>;
  OR?: InputMaybe<Array<LineTakesConnectionWhere>>;
  edge?: InputMaybe<HasTakeWhere>;
  node?: InputMaybe<TakeWhere>;
};

export type LineTakesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LineTakesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LineTakesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LineTakesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  note_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  note_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  note_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  note_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  take_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  take_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  take_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LineTakesRelationship = {
  __typename?: 'LineTakesRelationship';
  cursor: Scalars['String']['output'];
  node: Take;
  properties: HasTake;
};

export type LineUpdateInput = {
  customFields?: InputMaybe<Scalars['String']['input']>;
  library?: InputMaybe<Library>;
};

export type LineWhere = {
  AND?: InputMaybe<Array<LineWhere>>;
  NOT?: InputMaybe<LineWhere>;
  OR?: InputMaybe<Array<LineWhere>>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  character?: InputMaybe<CharacterWhere>;
  characterAggregate?: InputMaybe<LineCharacterAggregateInput>;
  characterConnection?: InputMaybe<LineCharacterConnectionWhere>;
  characterConnection_NOT?: InputMaybe<LineCharacterConnectionWhere>;
  character_NOT?: InputMaybe<CharacterWhere>;
  compsAggregate?: InputMaybe<LineCompsAggregateInput>;
  /** Return Lines where all of the related LineCompsConnections match this filter */
  compsConnection_ALL?: InputMaybe<LineCompsConnectionWhere>;
  /** Return Lines where none of the related LineCompsConnections match this filter */
  compsConnection_NONE?: InputMaybe<LineCompsConnectionWhere>;
  /** Return Lines where one of the related LineCompsConnections match this filter */
  compsConnection_SINGLE?: InputMaybe<LineCompsConnectionWhere>;
  /** Return Lines where some of the related LineCompsConnections match this filter */
  compsConnection_SOME?: InputMaybe<LineCompsConnectionWhere>;
  /** Return Lines where all of the related Comps match this filter */
  comps_ALL?: InputMaybe<CompWhere>;
  /** Return Lines where none of the related Comps match this filter */
  comps_NONE?: InputMaybe<CompWhere>;
  /** Return Lines where one of the related Comps match this filter */
  comps_SINGLE?: InputMaybe<CompWhere>;
  /** Return Lines where some of the related Comps match this filter */
  comps_SOME?: InputMaybe<CompWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  customFields_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  customFields_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  customFields_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFields_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  episode?: InputMaybe<EpisodeWhere>;
  episodeAggregate?: InputMaybe<LineEpisodeAggregateInput>;
  episodeConnection?: InputMaybe<LineEpisodeConnectionWhere>;
  episodeConnection_NOT?: InputMaybe<LineEpisodeConnectionWhere>;
  episode_NOT?: InputMaybe<EpisodeWhere>;
  groupsAggregate?: InputMaybe<LineGroupsAggregateInput>;
  /** Return Lines where all of the related LineGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<LineGroupsConnectionWhere>;
  /** Return Lines where none of the related LineGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<LineGroupsConnectionWhere>;
  /** Return Lines where one of the related LineGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<LineGroupsConnectionWhere>;
  /** Return Lines where some of the related LineGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<LineGroupsConnectionWhere>;
  /** Return Lines where all of the related LineGroups match this filter */
  groups_ALL?: InputMaybe<LineGroupWhere>;
  /** Return Lines where none of the related LineGroups match this filter */
  groups_NONE?: InputMaybe<LineGroupWhere>;
  /** Return Lines where one of the related LineGroups match this filter */
  groups_SINGLE?: InputMaybe<LineGroupWhere>;
  /** Return Lines where some of the related LineGroups match this filter */
  groups_SOME?: InputMaybe<LineGroupWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  library?: InputMaybe<Library>;
  library_IN?: InputMaybe<Array<InputMaybe<Library>>>;
  lineNo?: InputMaybe<Scalars['String']['input']>;
  lineNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lineNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lineNo_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lineNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lineStatus?: InputMaybe<LineStatus>;
  lineStatus_IN?: InputMaybe<Array<LineStatus>>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  override?: InputMaybe<TakeWhere>;
  overrideAggregate?: InputMaybe<LineOverrideAggregateInput>;
  overrideConnection?: InputMaybe<LineOverrideConnectionWhere>;
  overrideConnection_NOT?: InputMaybe<LineOverrideConnectionWhere>;
  override_NOT?: InputMaybe<TakeWhere>;
  performanceNotes?: InputMaybe<Scalars['String']['input']>;
  performanceNotes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  performanceNotes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  performanceNotes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  performanceNotes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  revisionChainId?: InputMaybe<Scalars['ID']['input']>;
  revisionChainId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  revisionChainId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  revisionChainId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisionChainId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  takesAggregate?: InputMaybe<LineTakesAggregateInput>;
  /** Return Lines where all of the related LineTakesConnections match this filter */
  takesConnection_ALL?: InputMaybe<LineTakesConnectionWhere>;
  /** Return Lines where none of the related LineTakesConnections match this filter */
  takesConnection_NONE?: InputMaybe<LineTakesConnectionWhere>;
  /** Return Lines where one of the related LineTakesConnections match this filter */
  takesConnection_SINGLE?: InputMaybe<LineTakesConnectionWhere>;
  /** Return Lines where some of the related LineTakesConnections match this filter */
  takesConnection_SOME?: InputMaybe<LineTakesConnectionWhere>;
  /** Return Lines where all of the related Takes match this filter */
  takes_ALL?: InputMaybe<TakeWhere>;
  /** Return Lines where none of the related Takes match this filter */
  takes_NONE?: InputMaybe<TakeWhere>;
  /** Return Lines where one of the related Takes match this filter */
  takes_SINGLE?: InputMaybe<TakeWhere>;
  /** Return Lines where some of the related Takes match this filter */
  takes_SOME?: InputMaybe<TakeWhere>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LinesConnection = {
  __typename?: 'LinesConnection';
  edges: Array<LineEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cascadeDeleteEpisode: DeleteInfo;
  cascadeDeleteSeason: DeleteInfo;
  cascadeDeleteShow: DeleteInfo;
  createCharacters: CreateCharactersMutationResponse;
  createEpisodes: CreateEpisodesMutationResponse;
  createInitialData: MutationResult;
  createParsedLines: ParsedLinesOutput;
  createSeasons: CreateSeasonsMutationResponse;
  createShows: CreateShowsMutationResponse;
  deleteScript: MutationResult;
  deleteTakes: DeleteInfo;
  saveRecordingSessionDraft: IdResult;
  updateAudio: UpdateAudioMutationResponse;
  updateCharacterAssignment: MutationResult;
  updateCharacters: UpdateCharactersMutationResponse;
  updateEpisodes: UpdateEpisodesMutationResponse;
  updateLines: UpdateLinesMutationResponse;
  updatePerformanceNotes: Line;
  updateRecordingSessions: UpdateRecordingSessionsMutationResponse;
  updateSeasons: UpdateSeasonsMutationResponse;
  updateShows: UpdateShowsMutationResponse;
  updateTakeProperties: MutationResult;
};


export type MutationCascadeDeleteEpisodeArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationCascadeDeleteSeasonArgs = {
  seasonId: Scalars['ID']['input'];
};


export type MutationCascadeDeleteShowArgs = {
  showId: Scalars['ID']['input'];
};


export type MutationCreateCharactersArgs = {
  input: Array<CharacterCreateInput>;
};


export type MutationCreateEpisodesArgs = {
  input: Array<EpisodeCreateInput>;
};


export type MutationCreateInitialDataArgs = {
  createCharacters: Array<InitialCharacter>;
  createGroups: Array<InitialLineGroup>;
  createRecordingSessions: Array<InitialRecordingSession>;
  episodeId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  lines: Array<InitialLine>;
};


export type MutationCreateParsedLinesArgs = {
  audio: Array<AudioInput>;
  cancel: Array<CancelContent>;
  closeDraftScript?: InputMaybe<Scalars['Boolean']['input']>;
  createCharacters: Array<CreateCharacter>;
  createContextBlocks: Array<CreateContextBlock>;
  createGroups: Array<CreateLineGroup>;
  createSongs: Array<CreateSong>;
  detach: Array<DetachContent>;
  episodeId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fromDraftScript: Scalars['Boolean']['input'];
  lines: Array<ProcessedLine>;
};


export type MutationCreateSeasonsArgs = {
  input: Array<SeasonCreateInput>;
};


export type MutationCreateShowsArgs = {
  input: Array<ShowCreateInput>;
};


export type MutationDeleteScriptArgs = {
  episodeId: Scalars['ID']['input'];
  scriptId: Scalars['ID']['input'];
};


export type MutationDeleteTakesArgs = {
  where?: InputMaybe<TakeWhere>;
};


export type MutationSaveRecordingSessionDraftArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationUpdateAudioArgs = {
  update?: InputMaybe<AudioUpdateInput>;
  where?: InputMaybe<AudioWhere>;
};


export type MutationUpdateCharacterAssignmentArgs = {
  entityId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
  newCharacterIds: Array<Scalars['ID']['input']>;
  type: UpdateCharacterAssignmentType;
};


export type MutationUpdateCharactersArgs = {
  connect?: InputMaybe<CharacterConnectInput>;
  create?: InputMaybe<CharacterRelationInput>;
  update?: InputMaybe<CharacterUpdateInput>;
  where?: InputMaybe<CharacterWhere>;
};


export type MutationUpdateEpisodesArgs = {
  connect?: InputMaybe<EpisodeConnectInput>;
  create?: InputMaybe<EpisodeRelationInput>;
  update?: InputMaybe<EpisodeUpdateInput>;
  where?: InputMaybe<EpisodeWhere>;
};


export type MutationUpdateLinesArgs = {
  update?: InputMaybe<LineUpdateInput>;
  where?: InputMaybe<LineWhere>;
};


export type MutationUpdatePerformanceNotesArgs = {
  lineId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};


export type MutationUpdateRecordingSessionsArgs = {
  update?: InputMaybe<RecordingSessionUpdateInput>;
  where?: InputMaybe<RecordingSessionWhere>;
};


export type MutationUpdateSeasonsArgs = {
  connect?: InputMaybe<SeasonConnectInput>;
  create?: InputMaybe<SeasonRelationInput>;
  update?: InputMaybe<SeasonUpdateInput>;
  where?: InputMaybe<SeasonWhere>;
};


export type MutationUpdateShowsArgs = {
  connect?: InputMaybe<ShowConnectInput>;
  create?: InputMaybe<ShowRelationInput>;
  update?: InputMaybe<ShowUpdateInput>;
  where?: InputMaybe<ShowWhere>;
};


export type MutationUpdateTakePropertiesArgs = {
  lineId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  select: SelectType;
  take?: InputMaybe<Scalars['String']['input']>;
  takeId: Scalars['ID']['input'];
};

export type MutationResult = {
  __typename?: 'MutationResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParsedAudioCharacter = {
  __typename?: 'ParsedAudioCharacter';
  id: Scalars['ID']['output'];
};

export type ParsedAudioGroupOutput = {
  __typename?: 'ParsedAudioGroupOutput';
  audios: Array<ParsedAudioOutput>;
  id: Scalars['ID']['output'];
  ordinal: Scalars['Float']['output'];
  tag: Scalars['String']['output'];
};

export type ParsedAudioGroupOutputWhere = {
  AND?: InputMaybe<Array<ParsedAudioGroupOutputWhere>>;
  NOT?: InputMaybe<ParsedAudioGroupOutputWhere>;
  OR?: InputMaybe<Array<ParsedAudioGroupOutputWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ParsedAudioOutput = {
  __typename?: 'ParsedAudioOutput';
  character?: Maybe<ParsedAudioCharacter>;
  id: Scalars['ID']['output'];
  ordinal: Scalars['Float']['output'];
  tag: Scalars['String']['output'];
};

export type ParsedAudioOutputWhere = {
  AND?: InputMaybe<Array<ParsedAudioOutputWhere>>;
  NOT?: InputMaybe<ParsedAudioOutputWhere>;
  OR?: InputMaybe<Array<ParsedAudioOutputWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ParsedLineGroupOutput = {
  __typename?: 'ParsedLineGroupOutput';
  id: Scalars['ID']['output'];
  lines: Array<ParsedLineOutput>;
  ordinal: Scalars['Float']['output'];
};

export type ParsedLineGroupOutputWhere = {
  AND?: InputMaybe<Array<ParsedLineGroupOutputWhere>>;
  NOT?: InputMaybe<ParsedLineGroupOutputWhere>;
  OR?: InputMaybe<Array<ParsedLineGroupOutputWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ParsedLineOutput = {
  __typename?: 'ParsedLineOutput';
  id: Scalars['ID']['output'];
  ordinal: Scalars['Float']['output'];
  revisionChainId: Scalars['ID']['output'];
};

export type ParsedLineOutputWhere = {
  AND?: InputMaybe<Array<ParsedLineOutputWhere>>;
  NOT?: InputMaybe<ParsedLineOutputWhere>;
  OR?: InputMaybe<Array<ParsedLineOutputWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ordinal?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  ordinal_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_LTE?: InputMaybe<Scalars['Float']['input']>;
  revisionChainId?: InputMaybe<Scalars['ID']['input']>;
  revisionChainId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  revisionChainId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  revisionChainId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisionChainId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ParsedLinesOutput = {
  __typename?: 'ParsedLinesOutput';
  createdLineInfo: Array<ParsedLinesOutputUnion>;
};

export type ParsedLinesOutputUnion = ParsedAudioGroupOutput | ParsedAudioOutput | ParsedLineGroupOutput | ParsedLineOutput;

export type ParsedLinesOutputUnionWhere = {
  ParsedAudioGroupOutput?: InputMaybe<ParsedAudioGroupOutputWhere>;
  ParsedAudioOutput?: InputMaybe<ParsedAudioOutputWhere>;
  ParsedLineGroupOutput?: InputMaybe<ParsedLineGroupOutputWhere>;
  ParsedLineOutput?: InputMaybe<ParsedLineOutputWhere>;
};

export type ProcessedCharacter = {
  alias?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type ProcessedLine = {
  additionalData: Scalars['JSONObject']['input'];
  character: ProcessedCharacter;
  existingId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lineNo: Scalars['String']['input'];
  operation: LineOperation;
  ordinal: Scalars['Float']['input'];
  parent: LineParent;
  status?: InputMaybe<LineStatus>;
  text: Scalars['String']['input'];
};

export type ProductionData = {
  __typename?: 'ProductionData';
  adrRecordingTime: Scalars['Int']['output'];
  adrRecordings: Scalars['Int']['output'];
  avgTimePerLine: Scalars['Int']['output'];
  cancelledLines: Scalars['Int']['output'];
  character: ProductionDataCharacterData;
  completedLines: Scalars['Int']['output'];
  incompleteLines: Scalars['Int']['output'];
  originalRecordings: Scalars['Int']['output'];
  pickupRecordings: Scalars['Int']['output'];
  totalLines: Scalars['Int']['output'];
  totalRecordingTime: Scalars['Int']['output'];
};

export type ProductionDataCharacterData = {
  __typename?: 'ProductionDataCharacterData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  appVersion: AppVersionResult;
  audio: Array<Audio>;
  audioConnection: AudioConnection;
  audioGroups: Array<AudioGroup>;
  audioGroupsConnection: AudioGroupsConnection;
  characters: Array<Character>;
  charactersConnection: CharactersConnection;
  comps: Array<Comp>;
  compsConnection: CompsConnection;
  contextBlocks: Array<ContextBlock>;
  contextBlocksConnection: ContextBlocksConnection;
  draftRecordingSessionLines: Array<RecordingSessionCharacter>;
  episodeContents: Array<EpisodeContent>;
  episodes: Array<Episode>;
  episodesConnection: EpisodesConnection;
  lineGroups: Array<LineGroup>;
  lineGroupsConnection: LineGroupsConnection;
  lines: Array<Line>;
  linesConnection: LinesConnection;
  parsedLinesOutputUnions: Array<ParsedLinesOutputUnion>;
  productionData: Array<ProductionData>;
  recordingSessions: Array<RecordingSession>;
  recordingSessionsConnection: RecordingSessionsConnection;
  scriptContents: Array<ScriptContent>;
  scripts: Array<Script>;
  scriptsConnection: ScriptsConnection;
  seasons: Array<Season>;
  seasonsConnection: SeasonsConnection;
  shows: Array<Show>;
  showsConnection: ShowsConnection;
  takes: Array<Take>;
  takesConnection: TakesConnection;
};


export type QueryAudioArgs = {
  options?: InputMaybe<AudioOptions>;
  where?: InputMaybe<AudioWhere>;
};


export type QueryAudioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AudioSort>>>;
  where?: InputMaybe<AudioWhere>;
};


export type QueryAudioGroupsArgs = {
  options?: InputMaybe<AudioGroupOptions>;
  where?: InputMaybe<AudioGroupWhere>;
};


export type QueryAudioGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AudioGroupSort>>>;
  where?: InputMaybe<AudioGroupWhere>;
};


export type QueryCharactersArgs = {
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type QueryCharactersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CharacterSort>>>;
  where?: InputMaybe<CharacterWhere>;
};


export type QueryCompsArgs = {
  options?: InputMaybe<CompOptions>;
  where?: InputMaybe<CompWhere>;
};


export type QueryCompsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompSort>>>;
  where?: InputMaybe<CompWhere>;
};


export type QueryContextBlocksArgs = {
  options?: InputMaybe<ContextBlockOptions>;
  where?: InputMaybe<ContextBlockWhere>;
};


export type QueryContextBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ContextBlockSort>>>;
  where?: InputMaybe<ContextBlockWhere>;
};


export type QueryDraftRecordingSessionLinesArgs = {
  characterIds: Array<Scalars['String']['input']>;
  episodeId: Scalars['String']['input'];
  lineTakeIds: Array<Scalars['String']['input']>;
};


export type QueryEpisodeContentsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<EpisodeContentWhere>;
};


export type QueryEpisodesArgs = {
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type QueryEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EpisodeSort>>>;
  where?: InputMaybe<EpisodeWhere>;
};


export type QueryLineGroupsArgs = {
  options?: InputMaybe<LineGroupOptions>;
  where?: InputMaybe<LineGroupWhere>;
};


export type QueryLineGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LineGroupSort>>>;
  where?: InputMaybe<LineGroupWhere>;
};


export type QueryLinesArgs = {
  options?: InputMaybe<LineOptions>;
  where?: InputMaybe<LineWhere>;
};


export type QueryLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LineSort>>>;
  where?: InputMaybe<LineWhere>;
};


export type QueryParsedLinesOutputUnionsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ParsedLinesOutputUnionWhere>;
};


export type QueryProductionDataArgs = {
  episodeId: Scalars['ID']['input'];
};


export type QueryRecordingSessionsArgs = {
  options?: InputMaybe<RecordingSessionOptions>;
  where?: InputMaybe<RecordingSessionWhere>;
};


export type QueryRecordingSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RecordingSessionSort>>>;
  where?: InputMaybe<RecordingSessionWhere>;
};


export type QueryScriptContentsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ScriptContentWhere>;
};


export type QueryScriptsArgs = {
  options?: InputMaybe<ScriptOptions>;
  where?: InputMaybe<ScriptWhere>;
};


export type QueryScriptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScriptSort>>>;
  where?: InputMaybe<ScriptWhere>;
};


export type QuerySeasonsArgs = {
  options?: InputMaybe<SeasonOptions>;
  where?: InputMaybe<SeasonWhere>;
};


export type QuerySeasonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SeasonSort>>>;
  where?: InputMaybe<SeasonWhere>;
};


export type QueryShowsArgs = {
  options?: InputMaybe<ShowOptions>;
  where?: InputMaybe<ShowWhere>;
};


export type QueryShowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ShowSort>>>;
  where?: InputMaybe<ShowWhere>;
};


export type QueryTakesArgs = {
  options?: InputMaybe<TakeOptions>;
  where?: InputMaybe<TakeWhere>;
};


export type QueryTakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TakeSort>>>;
  where?: InputMaybe<TakeWhere>;
};

/** Input type for options that can be specified on a query operation. */
export type QueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordingSession = {
  __typename?: 'RecordingSession';
  actor?: Maybe<Scalars['String']['output']>;
  audios: Array<Audio>;
  beginTime?: Maybe<Scalars['DateTime']['output']>;
  characters: Array<Character>;
  charactersConnection: RecordingSessionCharactersConnection;
  complete: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  engineer?: Maybe<Scalars['String']['output']>;
  episodes: Array<Episode>;
  episodesConnection: RecordingSessionEpisodesConnection;
  id: Scalars['ID']['output'];
  lines: Array<Line>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  scratch: Scalars['Boolean']['output'];
  script?: Maybe<Script>;
  studio?: Maybe<Scalars['String']['output']>;
};


export type RecordingSessionAudiosArgs = {
  episodeId: Scalars['ID']['input'];
};


export type RecordingSessionCharactersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type RecordingSessionCharactersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordingSessionCharactersConnectionSort>>;
  where?: InputMaybe<RecordingSessionCharactersConnectionWhere>;
};


export type RecordingSessionEpisodesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type RecordingSessionEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordingSessionEpisodesConnectionSort>>;
  where?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
};


export type RecordingSessionLinesArgs = {
  episodeId: Scalars['ID']['input'];
};


export type RecordingSessionScriptArgs = {
  episodeId: Scalars['ID']['input'];
};

export type RecordingSessionAudio = {
  __typename?: 'RecordingSessionAudio';
  character: RecordingSessionCharacterData;
  context: Scalars['String']['output'];
  customFields?: Maybe<Scalars['String']['output']>;
  group?: Maybe<RecordingSessionAudioGroupData>;
  id: Scalars['String']['output'];
  ordinal: Scalars['Float']['output'];
  performanceNotes?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type RecordingSessionAudioGroupData = {
  __typename?: 'RecordingSessionAudioGroupData';
  characters: Array<RecordingSessionCharacterData>;
};

export type RecordingSessionCharacter = {
  __typename?: 'RecordingSessionCharacter';
  audio: Array<RecordingSessionAudio>;
  id: Scalars['String']['output'];
  lines: Array<RecordingSessionLine>;
  name: Scalars['String']['output'];
};

export type RecordingSessionCharacterData = {
  __typename?: 'RecordingSessionCharacterData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RecordingSessionCharactersAggregateInput = {
  AND?: InputMaybe<Array<RecordingSessionCharactersAggregateInput>>;
  NOT?: InputMaybe<RecordingSessionCharactersAggregateInput>;
  OR?: InputMaybe<Array<RecordingSessionCharactersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordingSessionCharactersNodeAggregationWhereInput>;
};

export type RecordingSessionCharactersConnection = {
  __typename?: 'RecordingSessionCharactersConnection';
  edges: Array<RecordingSessionCharactersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordingSessionCharactersConnectionSort = {
  node?: InputMaybe<CharacterSort>;
};

export type RecordingSessionCharactersConnectionWhere = {
  AND?: InputMaybe<Array<RecordingSessionCharactersConnectionWhere>>;
  NOT?: InputMaybe<RecordingSessionCharactersConnectionWhere>;
  OR?: InputMaybe<Array<RecordingSessionCharactersConnectionWhere>>;
  node?: InputMaybe<CharacterWhere>;
};

export type RecordingSessionCharactersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordingSessionCharactersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordingSessionCharactersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordingSessionCharactersNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecordingSessionCharactersRelationship = {
  __typename?: 'RecordingSessionCharactersRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type RecordingSessionEdge = {
  __typename?: 'RecordingSessionEdge';
  cursor: Scalars['String']['output'];
  node: RecordingSession;
};

export type RecordingSessionEpisodesAggregateInput = {
  AND?: InputMaybe<Array<RecordingSessionEpisodesAggregateInput>>;
  NOT?: InputMaybe<RecordingSessionEpisodesAggregateInput>;
  OR?: InputMaybe<Array<RecordingSessionEpisodesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordingSessionEpisodesNodeAggregationWhereInput>;
};

export type RecordingSessionEpisodesConnection = {
  __typename?: 'RecordingSessionEpisodesConnection';
  edges: Array<RecordingSessionEpisodesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordingSessionEpisodesConnectionSort = {
  edge?: InputMaybe<SessionHasEpisodeSort>;
  node?: InputMaybe<EpisodeSort>;
};

export type RecordingSessionEpisodesConnectionWhere = {
  AND?: InputMaybe<Array<RecordingSessionEpisodesConnectionWhere>>;
  NOT?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
  OR?: InputMaybe<Array<RecordingSessionEpisodesConnectionWhere>>;
  edge?: InputMaybe<SessionHasEpisodeWhere>;
  node?: InputMaybe<EpisodeWhere>;
};

export type RecordingSessionEpisodesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordingSessionEpisodesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordingSessionEpisodesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordingSessionEpisodesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecordingSessionEpisodesRelationship = {
  __typename?: 'RecordingSessionEpisodesRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
  properties: SessionHasEpisode;
};

export type RecordingSessionEpisodesUpdateConnectionInput = {
  edge?: InputMaybe<SessionHasEpisodeUpdateInput>;
  node?: InputMaybe<EpisodeUpdateInput>;
};

export type RecordingSessionEpisodesUpdateFieldInput = {
  update?: InputMaybe<RecordingSessionEpisodesUpdateConnectionInput>;
  where?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
};

export type RecordingSessionLine = {
  __typename?: 'RecordingSessionLine';
  characterName: Scalars['String']['output'];
  customFields?: Maybe<Scalars['String']['output']>;
  group?: Maybe<RecordingSessionLineGroupData>;
  hasOverride: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lineNo: Scalars['String']['output'];
  ordinal: Scalars['Float']['output'];
  performanceNotes?: Maybe<Scalars['String']['output']>;
  revisionChainId: Scalars['String']['output'];
  revisions: Array<RecordingSessionRevision>;
  text: Scalars['String']['output'];
};

export type RecordingSessionLineGroupData = {
  __typename?: 'RecordingSessionLineGroupData';
  characterName: Array<Scalars['String']['output']>;
  text: Array<Scalars['String']['output']>;
};

export type RecordingSessionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RecordingSessionSort objects to sort RecordingSessions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RecordingSessionSort>>;
};

export type RecordingSessionRevision = {
  __typename?: 'RecordingSessionRevision';
  characterName: Scalars['String']['output'];
  customFields?: Maybe<Scalars['String']['output']>;
  group?: Maybe<RecordingSessionLineGroupData>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lineNo: Scalars['String']['output'];
  ordinal: Scalars['Float']['output'];
  performanceNotes?: Maybe<Scalars['String']['output']>;
  revisionChainId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Fields to sort RecordingSessions by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecordingSessionSort object. */
export type RecordingSessionSort = {
  actor?: InputMaybe<SortDirection>;
  beginTime?: InputMaybe<SortDirection>;
  complete?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  endTime?: InputMaybe<SortDirection>;
  engineer?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  notes?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  scratch?: InputMaybe<SortDirection>;
  script?: InputMaybe<SortDirection>;
  studio?: InputMaybe<SortDirection>;
};

export enum RecordingSessionType {
  Adr = 'ADR',
  ExcelUpload = 'EXCEL_UPLOAD',
  Original = 'ORIGINAL',
  Pickup = 'PICKUP'
}

export type RecordingSessionUpdateInput = {
  actor?: InputMaybe<Scalars['String']['input']>;
  beginTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  engineer?: InputMaybe<Scalars['String']['input']>;
  episodes?: InputMaybe<Array<RecordingSessionEpisodesUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scratch?: InputMaybe<Scalars['Boolean']['input']>;
  studio?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingSessionWhere = {
  AND?: InputMaybe<Array<RecordingSessionWhere>>;
  NOT?: InputMaybe<RecordingSessionWhere>;
  OR?: InputMaybe<Array<RecordingSessionWhere>>;
  actor?: InputMaybe<Scalars['String']['input']>;
  actor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  actor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  actor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  beginTime?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  beginTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  charactersAggregate?: InputMaybe<RecordingSessionCharactersAggregateInput>;
  /** Return RecordingSessions where all of the related RecordingSessionCharactersConnections match this filter */
  charactersConnection_ALL?: InputMaybe<RecordingSessionCharactersConnectionWhere>;
  /** Return RecordingSessions where none of the related RecordingSessionCharactersConnections match this filter */
  charactersConnection_NONE?: InputMaybe<RecordingSessionCharactersConnectionWhere>;
  /** Return RecordingSessions where one of the related RecordingSessionCharactersConnections match this filter */
  charactersConnection_SINGLE?: InputMaybe<RecordingSessionCharactersConnectionWhere>;
  /** Return RecordingSessions where some of the related RecordingSessionCharactersConnections match this filter */
  charactersConnection_SOME?: InputMaybe<RecordingSessionCharactersConnectionWhere>;
  /** Return RecordingSessions where all of the related Characters match this filter */
  characters_ALL?: InputMaybe<CharacterWhere>;
  /** Return RecordingSessions where none of the related Characters match this filter */
  characters_NONE?: InputMaybe<CharacterWhere>;
  /** Return RecordingSessions where one of the related Characters match this filter */
  characters_SINGLE?: InputMaybe<CharacterWhere>;
  /** Return RecordingSessions where some of the related Characters match this filter */
  characters_SOME?: InputMaybe<CharacterWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  engineer?: InputMaybe<Scalars['String']['input']>;
  engineer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  engineer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  engineer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  engineer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  episodesAggregate?: InputMaybe<RecordingSessionEpisodesAggregateInput>;
  /** Return RecordingSessions where all of the related RecordingSessionEpisodesConnections match this filter */
  episodesConnection_ALL?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
  /** Return RecordingSessions where none of the related RecordingSessionEpisodesConnections match this filter */
  episodesConnection_NONE?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
  /** Return RecordingSessions where one of the related RecordingSessionEpisodesConnections match this filter */
  episodesConnection_SINGLE?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
  /** Return RecordingSessions where some of the related RecordingSessionEpisodesConnections match this filter */
  episodesConnection_SOME?: InputMaybe<RecordingSessionEpisodesConnectionWhere>;
  /** Return RecordingSessions where all of the related Episodes match this filter */
  episodes_ALL?: InputMaybe<EpisodeWhere>;
  /** Return RecordingSessions where none of the related Episodes match this filter */
  episodes_NONE?: InputMaybe<EpisodeWhere>;
  /** Return RecordingSessions where one of the related Episodes match this filter */
  episodes_SINGLE?: InputMaybe<EpisodeWhere>;
  /** Return RecordingSessions where some of the related Episodes match this filter */
  episodes_SOME?: InputMaybe<EpisodeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  notes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scratch?: InputMaybe<Scalars['Boolean']['input']>;
  studio?: InputMaybe<Scalars['String']['input']>;
  studio_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  studio_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  studio_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  studio_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingSessionsConnection = {
  __typename?: 'RecordingSessionsConnection';
  edges: Array<RecordingSessionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum RecordingStatus {
  NotRecorded = 'NOT_RECORDED',
  Recorded = 'RECORDED',
  Scratch = 'SCRATCH'
}

export type Script = {
  __typename?: 'Script';
  content: Array<ScriptContent>;
  contentConnection: ScriptContentConnection;
  created: Scalars['DateTime']['output'];
  episode: Episode;
  episodeConnection: ScriptEpisodeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  previous?: Maybe<Script>;
  previousConnection: ScriptPreviousConnection;
  recordingSessions: Array<RecordingSession>;
  recordingSessionsConnection: ScriptRecordingSessionsConnection;
};


export type ScriptContentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ScriptContentWhere>;
};


export type ScriptContentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScriptContentConnectionWhere>;
};


export type ScriptEpisodeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type ScriptEpisodeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScriptEpisodeConnectionSort>>;
  where?: InputMaybe<ScriptEpisodeConnectionWhere>;
};


export type ScriptPreviousArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScriptOptions>;
  where?: InputMaybe<ScriptWhere>;
};


export type ScriptPreviousConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScriptPreviousConnectionSort>>;
  where?: InputMaybe<ScriptPreviousConnectionWhere>;
};


export type ScriptRecordingSessionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordingSessionOptions>;
  where?: InputMaybe<RecordingSessionWhere>;
};


export type ScriptRecordingSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScriptRecordingSessionsConnectionSort>>;
  where?: InputMaybe<ScriptRecordingSessionsConnectionWhere>;
};

export type ScriptContent = Audio | AudioGroup | ContextBlock | Line | LineGroup;

export type ScriptContentAudioConnectionWhere = {
  AND?: InputMaybe<Array<ScriptContentAudioConnectionWhere>>;
  NOT?: InputMaybe<ScriptContentAudioConnectionWhere>;
  OR?: InputMaybe<Array<ScriptContentAudioConnectionWhere>>;
  node?: InputMaybe<AudioWhere>;
};

export type ScriptContentAudioGroupConnectionWhere = {
  AND?: InputMaybe<Array<ScriptContentAudioGroupConnectionWhere>>;
  NOT?: InputMaybe<ScriptContentAudioGroupConnectionWhere>;
  OR?: InputMaybe<Array<ScriptContentAudioGroupConnectionWhere>>;
  node?: InputMaybe<AudioGroupWhere>;
};

export type ScriptContentConnection = {
  __typename?: 'ScriptContentConnection';
  edges: Array<ScriptContentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScriptContentConnectionWhere = {
  Audio?: InputMaybe<ScriptContentAudioConnectionWhere>;
  AudioGroup?: InputMaybe<ScriptContentAudioGroupConnectionWhere>;
  ContextBlock?: InputMaybe<ScriptContentContextBlockConnectionWhere>;
  Line?: InputMaybe<ScriptContentLineConnectionWhere>;
  LineGroup?: InputMaybe<ScriptContentLineGroupConnectionWhere>;
};

export type ScriptContentContextBlockConnectionWhere = {
  AND?: InputMaybe<Array<ScriptContentContextBlockConnectionWhere>>;
  NOT?: InputMaybe<ScriptContentContextBlockConnectionWhere>;
  OR?: InputMaybe<Array<ScriptContentContextBlockConnectionWhere>>;
  node?: InputMaybe<ContextBlockWhere>;
};

export type ScriptContentLineConnectionWhere = {
  AND?: InputMaybe<Array<ScriptContentLineConnectionWhere>>;
  NOT?: InputMaybe<ScriptContentLineConnectionWhere>;
  OR?: InputMaybe<Array<ScriptContentLineConnectionWhere>>;
  node?: InputMaybe<LineWhere>;
};

export type ScriptContentLineGroupConnectionWhere = {
  AND?: InputMaybe<Array<ScriptContentLineGroupConnectionWhere>>;
  NOT?: InputMaybe<ScriptContentLineGroupConnectionWhere>;
  OR?: InputMaybe<Array<ScriptContentLineGroupConnectionWhere>>;
  node?: InputMaybe<LineGroupWhere>;
};

export type ScriptContentRelationship = {
  __typename?: 'ScriptContentRelationship';
  cursor: Scalars['String']['output'];
  node: ScriptContent;
};

export type ScriptContentWhere = {
  Audio?: InputMaybe<AudioWhere>;
  AudioGroup?: InputMaybe<AudioGroupWhere>;
  ContextBlock?: InputMaybe<ContextBlockWhere>;
  Line?: InputMaybe<LineWhere>;
  LineGroup?: InputMaybe<LineGroupWhere>;
};

export type ScriptEdge = {
  __typename?: 'ScriptEdge';
  cursor: Scalars['String']['output'];
  node: Script;
};

export type ScriptEpisodeAggregateInput = {
  AND?: InputMaybe<Array<ScriptEpisodeAggregateInput>>;
  NOT?: InputMaybe<ScriptEpisodeAggregateInput>;
  OR?: InputMaybe<Array<ScriptEpisodeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScriptEpisodeNodeAggregationWhereInput>;
};

export type ScriptEpisodeConnection = {
  __typename?: 'ScriptEpisodeConnection';
  edges: Array<ScriptEpisodeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScriptEpisodeConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type ScriptEpisodeConnectionWhere = {
  AND?: InputMaybe<Array<ScriptEpisodeConnectionWhere>>;
  NOT?: InputMaybe<ScriptEpisodeConnectionWhere>;
  OR?: InputMaybe<Array<ScriptEpisodeConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type ScriptEpisodeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScriptEpisodeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScriptEpisodeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScriptEpisodeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScriptEpisodeRelationship = {
  __typename?: 'ScriptEpisodeRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type ScriptOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScriptSort objects to sort Scripts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScriptSort>>;
};

export type ScriptPreviousAggregateInput = {
  AND?: InputMaybe<Array<ScriptPreviousAggregateInput>>;
  NOT?: InputMaybe<ScriptPreviousAggregateInput>;
  OR?: InputMaybe<Array<ScriptPreviousAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScriptPreviousNodeAggregationWhereInput>;
};

export type ScriptPreviousConnection = {
  __typename?: 'ScriptPreviousConnection';
  edges: Array<ScriptPreviousRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScriptPreviousConnectionSort = {
  node?: InputMaybe<ScriptSort>;
};

export type ScriptPreviousConnectionWhere = {
  AND?: InputMaybe<Array<ScriptPreviousConnectionWhere>>;
  NOT?: InputMaybe<ScriptPreviousConnectionWhere>;
  OR?: InputMaybe<Array<ScriptPreviousConnectionWhere>>;
  node?: InputMaybe<ScriptWhere>;
};

export type ScriptPreviousNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScriptPreviousNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScriptPreviousNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScriptPreviousNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScriptPreviousRelationship = {
  __typename?: 'ScriptPreviousRelationship';
  cursor: Scalars['String']['output'];
  node: Script;
};

export type ScriptRecordingSessionsAggregateInput = {
  AND?: InputMaybe<Array<ScriptRecordingSessionsAggregateInput>>;
  NOT?: InputMaybe<ScriptRecordingSessionsAggregateInput>;
  OR?: InputMaybe<Array<ScriptRecordingSessionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScriptRecordingSessionsNodeAggregationWhereInput>;
};

export type ScriptRecordingSessionsConnection = {
  __typename?: 'ScriptRecordingSessionsConnection';
  edges: Array<ScriptRecordingSessionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScriptRecordingSessionsConnectionSort = {
  node?: InputMaybe<RecordingSessionSort>;
};

export type ScriptRecordingSessionsConnectionWhere = {
  AND?: InputMaybe<Array<ScriptRecordingSessionsConnectionWhere>>;
  NOT?: InputMaybe<ScriptRecordingSessionsConnectionWhere>;
  OR?: InputMaybe<Array<ScriptRecordingSessionsConnectionWhere>>;
  node?: InputMaybe<RecordingSessionWhere>;
};

export type ScriptRecordingSessionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScriptRecordingSessionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScriptRecordingSessionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScriptRecordingSessionsNodeAggregationWhereInput>>;
  actor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  beginTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  engineer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  engineer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  studio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  studio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScriptRecordingSessionsRelationship = {
  __typename?: 'ScriptRecordingSessionsRelationship';
  cursor: Scalars['String']['output'];
  node: RecordingSession;
};

/** Fields to sort Scripts by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScriptSort object. */
export type ScriptSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
};

export type ScriptWhere = {
  AND?: InputMaybe<Array<ScriptWhere>>;
  NOT?: InputMaybe<ScriptWhere>;
  OR?: InputMaybe<Array<ScriptWhere>>;
  /** Return Scripts where all of the related ScriptContentConnections match this filter */
  contentConnection_ALL?: InputMaybe<ScriptContentConnectionWhere>;
  /** Return Scripts where none of the related ScriptContentConnections match this filter */
  contentConnection_NONE?: InputMaybe<ScriptContentConnectionWhere>;
  /** Return Scripts where one of the related ScriptContentConnections match this filter */
  contentConnection_SINGLE?: InputMaybe<ScriptContentConnectionWhere>;
  /** Return Scripts where some of the related ScriptContentConnections match this filter */
  contentConnection_SOME?: InputMaybe<ScriptContentConnectionWhere>;
  /** Return Scripts where all of the related ScriptContents match this filter */
  content_ALL?: InputMaybe<ScriptContentWhere>;
  /** Return Scripts where none of the related ScriptContents match this filter */
  content_NONE?: InputMaybe<ScriptContentWhere>;
  /** Return Scripts where one of the related ScriptContents match this filter */
  content_SINGLE?: InputMaybe<ScriptContentWhere>;
  /** Return Scripts where some of the related ScriptContents match this filter */
  content_SOME?: InputMaybe<ScriptContentWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  episode?: InputMaybe<EpisodeWhere>;
  episodeAggregate?: InputMaybe<ScriptEpisodeAggregateInput>;
  episodeConnection?: InputMaybe<ScriptEpisodeConnectionWhere>;
  episodeConnection_NOT?: InputMaybe<ScriptEpisodeConnectionWhere>;
  episode_NOT?: InputMaybe<EpisodeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  previous?: InputMaybe<ScriptWhere>;
  previousAggregate?: InputMaybe<ScriptPreviousAggregateInput>;
  previousConnection?: InputMaybe<ScriptPreviousConnectionWhere>;
  previousConnection_NOT?: InputMaybe<ScriptPreviousConnectionWhere>;
  previous_NOT?: InputMaybe<ScriptWhere>;
  recordingSessionsAggregate?: InputMaybe<ScriptRecordingSessionsAggregateInput>;
  /** Return Scripts where all of the related ScriptRecordingSessionsConnections match this filter */
  recordingSessionsConnection_ALL?: InputMaybe<ScriptRecordingSessionsConnectionWhere>;
  /** Return Scripts where none of the related ScriptRecordingSessionsConnections match this filter */
  recordingSessionsConnection_NONE?: InputMaybe<ScriptRecordingSessionsConnectionWhere>;
  /** Return Scripts where one of the related ScriptRecordingSessionsConnections match this filter */
  recordingSessionsConnection_SINGLE?: InputMaybe<ScriptRecordingSessionsConnectionWhere>;
  /** Return Scripts where some of the related ScriptRecordingSessionsConnections match this filter */
  recordingSessionsConnection_SOME?: InputMaybe<ScriptRecordingSessionsConnectionWhere>;
  /** Return Scripts where all of the related RecordingSessions match this filter */
  recordingSessions_ALL?: InputMaybe<RecordingSessionWhere>;
  /** Return Scripts where none of the related RecordingSessions match this filter */
  recordingSessions_NONE?: InputMaybe<RecordingSessionWhere>;
  /** Return Scripts where one of the related RecordingSessions match this filter */
  recordingSessions_SINGLE?: InputMaybe<RecordingSessionWhere>;
  /** Return Scripts where some of the related RecordingSessions match this filter */
  recordingSessions_SOME?: InputMaybe<RecordingSessionWhere>;
};

export type ScriptsConnection = {
  __typename?: 'ScriptsConnection';
  edges: Array<ScriptEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Season = {
  __typename?: 'Season';
  created: Scalars['DateTime']['output'];
  episodes: Array<Episode>;
  episodesConnection: SeasonEpisodesConnection;
  id: Scalars['ID']['output'];
  show: Show;
  showConnection: SeasonShowConnection;
  title: Scalars['String']['output'];
  totalVoices: Scalars['Int']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type SeasonEpisodesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EpisodeOptions>;
  where?: InputMaybe<EpisodeWhere>;
};


export type SeasonEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SeasonEpisodesConnectionSort>>;
  where?: InputMaybe<SeasonEpisodesConnectionWhere>;
};


export type SeasonShowArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ShowOptions>;
  where?: InputMaybe<ShowWhere>;
};


export type SeasonShowConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SeasonShowConnectionSort>>;
  where?: InputMaybe<SeasonShowConnectionWhere>;
};

export type SeasonConnectInput = {
  episodes?: InputMaybe<Array<SeasonEpisodesConnectFieldInput>>;
  show?: InputMaybe<SeasonShowConnectFieldInput>;
};

export type SeasonConnectWhere = {
  node: SeasonWhere;
};

export type SeasonCreateInput = {
  episodes?: InputMaybe<SeasonEpisodesFieldInput>;
  show?: InputMaybe<SeasonShowFieldInput>;
  title: Scalars['String']['input'];
};

export type SeasonEdge = {
  __typename?: 'SeasonEdge';
  cursor: Scalars['String']['output'];
  node: Season;
};

export type SeasonEpisodesAggregateInput = {
  AND?: InputMaybe<Array<SeasonEpisodesAggregateInput>>;
  NOT?: InputMaybe<SeasonEpisodesAggregateInput>;
  OR?: InputMaybe<Array<SeasonEpisodesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SeasonEpisodesNodeAggregationWhereInput>;
};

export type SeasonEpisodesConnectFieldInput = {
  connect?: InputMaybe<Array<EpisodeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EpisodeConnectWhere>;
};

export type SeasonEpisodesConnection = {
  __typename?: 'SeasonEpisodesConnection';
  edges: Array<SeasonEpisodesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeasonEpisodesConnectionSort = {
  node?: InputMaybe<EpisodeSort>;
};

export type SeasonEpisodesConnectionWhere = {
  AND?: InputMaybe<Array<SeasonEpisodesConnectionWhere>>;
  NOT?: InputMaybe<SeasonEpisodesConnectionWhere>;
  OR?: InputMaybe<Array<SeasonEpisodesConnectionWhere>>;
  node?: InputMaybe<EpisodeWhere>;
};

export type SeasonEpisodesCreateFieldInput = {
  node: EpisodeCreateInput;
};

export type SeasonEpisodesFieldInput = {
  connect?: InputMaybe<Array<SeasonEpisodesConnectFieldInput>>;
  create?: InputMaybe<Array<SeasonEpisodesCreateFieldInput>>;
};

export type SeasonEpisodesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SeasonEpisodesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SeasonEpisodesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SeasonEpisodesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SeasonEpisodesRelationship = {
  __typename?: 'SeasonEpisodesRelationship';
  cursor: Scalars['String']['output'];
  node: Episode;
};

export type SeasonEpisodesUpdateConnectionInput = {
  node?: InputMaybe<EpisodeUpdateInput>;
};

export type SeasonEpisodesUpdateFieldInput = {
  connect?: InputMaybe<Array<SeasonEpisodesConnectFieldInput>>;
  create?: InputMaybe<Array<SeasonEpisodesCreateFieldInput>>;
  update?: InputMaybe<SeasonEpisodesUpdateConnectionInput>;
  where?: InputMaybe<SeasonEpisodesConnectionWhere>;
};

export type SeasonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SeasonSort objects to sort Seasons by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SeasonSort>>;
};

export type SeasonRelationInput = {
  episodes?: InputMaybe<Array<SeasonEpisodesCreateFieldInput>>;
  show?: InputMaybe<SeasonShowCreateFieldInput>;
};

export type SeasonShowAggregateInput = {
  AND?: InputMaybe<Array<SeasonShowAggregateInput>>;
  NOT?: InputMaybe<SeasonShowAggregateInput>;
  OR?: InputMaybe<Array<SeasonShowAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SeasonShowNodeAggregationWhereInput>;
};

export type SeasonShowConnectFieldInput = {
  connect?: InputMaybe<ShowConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ShowConnectWhere>;
};

export type SeasonShowConnection = {
  __typename?: 'SeasonShowConnection';
  edges: Array<SeasonShowRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeasonShowConnectionSort = {
  node?: InputMaybe<ShowSort>;
};

export type SeasonShowConnectionWhere = {
  AND?: InputMaybe<Array<SeasonShowConnectionWhere>>;
  NOT?: InputMaybe<SeasonShowConnectionWhere>;
  OR?: InputMaybe<Array<SeasonShowConnectionWhere>>;
  node?: InputMaybe<ShowWhere>;
};

export type SeasonShowCreateFieldInput = {
  node: ShowCreateInput;
};

export type SeasonShowFieldInput = {
  connect?: InputMaybe<SeasonShowConnectFieldInput>;
  create?: InputMaybe<SeasonShowCreateFieldInput>;
};

export type SeasonShowNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SeasonShowNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SeasonShowNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SeasonShowNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFieldsDefinition_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SeasonShowRelationship = {
  __typename?: 'SeasonShowRelationship';
  cursor: Scalars['String']['output'];
  node: Show;
};

export type SeasonShowUpdateConnectionInput = {
  node?: InputMaybe<ShowUpdateInput>;
};

export type SeasonShowUpdateFieldInput = {
  connect?: InputMaybe<SeasonShowConnectFieldInput>;
  create?: InputMaybe<SeasonShowCreateFieldInput>;
  update?: InputMaybe<SeasonShowUpdateConnectionInput>;
  where?: InputMaybe<SeasonShowConnectionWhere>;
};

/** Fields to sort Seasons by. The order in which sorts are applied is not guaranteed when specifying many fields in one SeasonSort object. */
export type SeasonSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  totalVoices?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export type SeasonUpdateInput = {
  episodes?: InputMaybe<Array<SeasonEpisodesUpdateFieldInput>>;
  show?: InputMaybe<SeasonShowUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeasonWhere = {
  AND?: InputMaybe<Array<SeasonWhere>>;
  NOT?: InputMaybe<SeasonWhere>;
  OR?: InputMaybe<Array<SeasonWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  episodesAggregate?: InputMaybe<SeasonEpisodesAggregateInput>;
  /** Return Seasons where all of the related SeasonEpisodesConnections match this filter */
  episodesConnection_ALL?: InputMaybe<SeasonEpisodesConnectionWhere>;
  /** Return Seasons where none of the related SeasonEpisodesConnections match this filter */
  episodesConnection_NONE?: InputMaybe<SeasonEpisodesConnectionWhere>;
  /** Return Seasons where one of the related SeasonEpisodesConnections match this filter */
  episodesConnection_SINGLE?: InputMaybe<SeasonEpisodesConnectionWhere>;
  /** Return Seasons where some of the related SeasonEpisodesConnections match this filter */
  episodesConnection_SOME?: InputMaybe<SeasonEpisodesConnectionWhere>;
  /** Return Seasons where all of the related Episodes match this filter */
  episodes_ALL?: InputMaybe<EpisodeWhere>;
  /** Return Seasons where none of the related Episodes match this filter */
  episodes_NONE?: InputMaybe<EpisodeWhere>;
  /** Return Seasons where one of the related Episodes match this filter */
  episodes_SINGLE?: InputMaybe<EpisodeWhere>;
  /** Return Seasons where some of the related Episodes match this filter */
  episodes_SOME?: InputMaybe<EpisodeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<ShowWhere>;
  showAggregate?: InputMaybe<SeasonShowAggregateInput>;
  showConnection?: InputMaybe<SeasonShowConnectionWhere>;
  showConnection_NOT?: InputMaybe<SeasonShowConnectionWhere>;
  show_NOT?: InputMaybe<ShowWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SeasonsConnection = {
  __typename?: 'SeasonsConnection';
  edges: Array<SeasonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SelectInfo = {
  __typename?: 'SelectInfo';
  alt: Array<SelectSessionInfo>;
  select?: Maybe<SelectSessionInfo>;
};

export type SelectSessionInfo = {
  __typename?: 'SelectSessionInfo';
  scratch: Scalars['Boolean']['output'];
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  sessionType: RecordingSessionType;
  take: Scalars['String']['output'];
  takeId: Scalars['String']['output'];
};

export enum SelectType {
  Alt = 'ALT',
  None = 'NONE',
  Select = 'SELECT'
}

/**
 * The edge properties for the following fields:
 * * Episode.recordingSessions
 * * RecordingSession.episodes
 */
export type SessionHasEpisode = {
  __typename?: 'SessionHasEpisode';
  type: RecordingSessionType;
};

export type SessionHasEpisodeSort = {
  type?: InputMaybe<SortDirection>;
};

export type SessionHasEpisodeUpdateInput = {
  type?: InputMaybe<RecordingSessionType>;
};

export type SessionHasEpisodeWhere = {
  AND?: InputMaybe<Array<SessionHasEpisodeWhere>>;
  NOT?: InputMaybe<SessionHasEpisodeWhere>;
  OR?: InputMaybe<Array<SessionHasEpisodeWhere>>;
  type?: InputMaybe<RecordingSessionType>;
  type_IN?: InputMaybe<Array<RecordingSessionType>>;
};

export type Show = {
  __typename?: 'Show';
  characters: Array<Character>;
  charactersConnection: ShowCharactersConnection;
  created: Scalars['DateTime']['output'];
  customFieldsDefinition?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  seasons: Array<Season>;
  seasonsConnection: ShowSeasonsConnection;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type ShowCharactersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CharacterOptions>;
  where?: InputMaybe<CharacterWhere>;
};


export type ShowCharactersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ShowCharactersConnectionSort>>;
  where?: InputMaybe<ShowCharactersConnectionWhere>;
};


export type ShowSeasonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SeasonOptions>;
  where?: InputMaybe<SeasonWhere>;
};


export type ShowSeasonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ShowSeasonsConnectionSort>>;
  where?: InputMaybe<ShowSeasonsConnectionWhere>;
};

export type ShowCharactersAggregateInput = {
  AND?: InputMaybe<Array<ShowCharactersAggregateInput>>;
  NOT?: InputMaybe<ShowCharactersAggregateInput>;
  OR?: InputMaybe<Array<ShowCharactersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ShowCharactersNodeAggregationWhereInput>;
};

export type ShowCharactersConnectFieldInput = {
  connect?: InputMaybe<Array<CharacterConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CharacterConnectWhere>;
};

export type ShowCharactersConnection = {
  __typename?: 'ShowCharactersConnection';
  edges: Array<ShowCharactersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ShowCharactersConnectionSort = {
  node?: InputMaybe<CharacterSort>;
};

export type ShowCharactersConnectionWhere = {
  AND?: InputMaybe<Array<ShowCharactersConnectionWhere>>;
  NOT?: InputMaybe<ShowCharactersConnectionWhere>;
  OR?: InputMaybe<Array<ShowCharactersConnectionWhere>>;
  node?: InputMaybe<CharacterWhere>;
};

export type ShowCharactersCreateFieldInput = {
  node: CharacterCreateInput;
};

export type ShowCharactersFieldInput = {
  connect?: InputMaybe<Array<ShowCharactersConnectFieldInput>>;
  create?: InputMaybe<Array<ShowCharactersCreateFieldInput>>;
};

export type ShowCharactersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ShowCharactersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ShowCharactersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ShowCharactersNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShowCharactersRelationship = {
  __typename?: 'ShowCharactersRelationship';
  cursor: Scalars['String']['output'];
  node: Character;
};

export type ShowCharactersUpdateConnectionInput = {
  node?: InputMaybe<CharacterUpdateInput>;
};

export type ShowCharactersUpdateFieldInput = {
  connect?: InputMaybe<Array<ShowCharactersConnectFieldInput>>;
  create?: InputMaybe<Array<ShowCharactersCreateFieldInput>>;
  update?: InputMaybe<ShowCharactersUpdateConnectionInput>;
  where?: InputMaybe<ShowCharactersConnectionWhere>;
};

export type ShowConnectInput = {
  characters?: InputMaybe<Array<ShowCharactersConnectFieldInput>>;
  seasons?: InputMaybe<Array<ShowSeasonsConnectFieldInput>>;
};

export type ShowConnectWhere = {
  node: ShowWhere;
};

export type ShowCreateInput = {
  characters?: InputMaybe<ShowCharactersFieldInput>;
  customFieldsDefinition?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<ShowSeasonsFieldInput>;
  title: Scalars['String']['input'];
};

export type ShowEdge = {
  __typename?: 'ShowEdge';
  cursor: Scalars['String']['output'];
  node: Show;
};

export type ShowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ShowSort objects to sort Shows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ShowSort>>;
};

export type ShowRelationInput = {
  characters?: InputMaybe<Array<ShowCharactersCreateFieldInput>>;
  seasons?: InputMaybe<Array<ShowSeasonsCreateFieldInput>>;
};

export type ShowSeasonsAggregateInput = {
  AND?: InputMaybe<Array<ShowSeasonsAggregateInput>>;
  NOT?: InputMaybe<ShowSeasonsAggregateInput>;
  OR?: InputMaybe<Array<ShowSeasonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ShowSeasonsNodeAggregationWhereInput>;
};

export type ShowSeasonsConnectFieldInput = {
  connect?: InputMaybe<Array<SeasonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SeasonConnectWhere>;
};

export type ShowSeasonsConnection = {
  __typename?: 'ShowSeasonsConnection';
  edges: Array<ShowSeasonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ShowSeasonsConnectionSort = {
  node?: InputMaybe<SeasonSort>;
};

export type ShowSeasonsConnectionWhere = {
  AND?: InputMaybe<Array<ShowSeasonsConnectionWhere>>;
  NOT?: InputMaybe<ShowSeasonsConnectionWhere>;
  OR?: InputMaybe<Array<ShowSeasonsConnectionWhere>>;
  node?: InputMaybe<SeasonWhere>;
};

export type ShowSeasonsCreateFieldInput = {
  node: SeasonCreateInput;
};

export type ShowSeasonsFieldInput = {
  connect?: InputMaybe<Array<ShowSeasonsConnectFieldInput>>;
  create?: InputMaybe<Array<ShowSeasonsCreateFieldInput>>;
};

export type ShowSeasonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ShowSeasonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ShowSeasonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ShowSeasonsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShowSeasonsRelationship = {
  __typename?: 'ShowSeasonsRelationship';
  cursor: Scalars['String']['output'];
  node: Season;
};

export type ShowSeasonsUpdateConnectionInput = {
  node?: InputMaybe<SeasonUpdateInput>;
};

export type ShowSeasonsUpdateFieldInput = {
  connect?: InputMaybe<Array<ShowSeasonsConnectFieldInput>>;
  create?: InputMaybe<Array<ShowSeasonsCreateFieldInput>>;
  update?: InputMaybe<ShowSeasonsUpdateConnectionInput>;
  where?: InputMaybe<ShowSeasonsConnectionWhere>;
};

/** Fields to sort Shows by. The order in which sorts are applied is not guaranteed when specifying many fields in one ShowSort object. */
export type ShowSort = {
  created?: InputMaybe<SortDirection>;
  customFieldsDefinition?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
};

export type ShowUpdateInput = {
  characters?: InputMaybe<Array<ShowCharactersUpdateFieldInput>>;
  customFieldsDefinition?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<ShowSeasonsUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShowWhere = {
  AND?: InputMaybe<Array<ShowWhere>>;
  NOT?: InputMaybe<ShowWhere>;
  OR?: InputMaybe<Array<ShowWhere>>;
  charactersAggregate?: InputMaybe<ShowCharactersAggregateInput>;
  /** Return Shows where all of the related ShowCharactersConnections match this filter */
  charactersConnection_ALL?: InputMaybe<ShowCharactersConnectionWhere>;
  /** Return Shows where none of the related ShowCharactersConnections match this filter */
  charactersConnection_NONE?: InputMaybe<ShowCharactersConnectionWhere>;
  /** Return Shows where one of the related ShowCharactersConnections match this filter */
  charactersConnection_SINGLE?: InputMaybe<ShowCharactersConnectionWhere>;
  /** Return Shows where some of the related ShowCharactersConnections match this filter */
  charactersConnection_SOME?: InputMaybe<ShowCharactersConnectionWhere>;
  /** Return Shows where all of the related Characters match this filter */
  characters_ALL?: InputMaybe<CharacterWhere>;
  /** Return Shows where none of the related Characters match this filter */
  characters_NONE?: InputMaybe<CharacterWhere>;
  /** Return Shows where one of the related Characters match this filter */
  characters_SINGLE?: InputMaybe<CharacterWhere>;
  /** Return Shows where some of the related Characters match this filter */
  characters_SOME?: InputMaybe<CharacterWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFieldsDefinition?: InputMaybe<Scalars['String']['input']>;
  customFieldsDefinition_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  customFieldsDefinition_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  customFieldsDefinition_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customFieldsDefinition_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  seasonsAggregate?: InputMaybe<ShowSeasonsAggregateInput>;
  /** Return Shows where all of the related ShowSeasonsConnections match this filter */
  seasonsConnection_ALL?: InputMaybe<ShowSeasonsConnectionWhere>;
  /** Return Shows where none of the related ShowSeasonsConnections match this filter */
  seasonsConnection_NONE?: InputMaybe<ShowSeasonsConnectionWhere>;
  /** Return Shows where one of the related ShowSeasonsConnections match this filter */
  seasonsConnection_SINGLE?: InputMaybe<ShowSeasonsConnectionWhere>;
  /** Return Shows where some of the related ShowSeasonsConnections match this filter */
  seasonsConnection_SOME?: InputMaybe<ShowSeasonsConnectionWhere>;
  /** Return Shows where all of the related Seasons match this filter */
  seasons_ALL?: InputMaybe<SeasonWhere>;
  /** Return Shows where none of the related Seasons match this filter */
  seasons_NONE?: InputMaybe<SeasonWhere>;
  /** Return Shows where one of the related Seasons match this filter */
  seasons_SINGLE?: InputMaybe<SeasonWhere>;
  /** Return Shows where some of the related Seasons match this filter */
  seasons_SOME?: InputMaybe<SeasonWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShowsConnection = {
  __typename?: 'ShowsConnection';
  edges: Array<ShowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC'
}

export type Take = {
  __typename?: 'Take';
  audio: Array<Audio>;
  audioConnection: TakeAudioConnection;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  line: Array<Line>;
  lineConnection: TakeLineConnection;
  note: Scalars['String']['output'];
  recordingSession: RecordingSession;
  recordingSessionConnection: TakeRecordingSessionConnection;
  take: Scalars['String']['output'];
};


export type TakeAudioArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AudioOptions>;
  where?: InputMaybe<AudioWhere>;
};


export type TakeAudioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TakeAudioConnectionSort>>;
  where?: InputMaybe<TakeAudioConnectionWhere>;
};


export type TakeLineArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LineOptions>;
  where?: InputMaybe<LineWhere>;
};


export type TakeLineConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TakeLineConnectionSort>>;
  where?: InputMaybe<TakeLineConnectionWhere>;
};


export type TakeRecordingSessionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordingSessionOptions>;
  where?: InputMaybe<RecordingSessionWhere>;
};


export type TakeRecordingSessionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TakeRecordingSessionConnectionSort>>;
  where?: InputMaybe<TakeRecordingSessionConnectionWhere>;
};

export type TakeAudioAggregateInput = {
  AND?: InputMaybe<Array<TakeAudioAggregateInput>>;
  NOT?: InputMaybe<TakeAudioAggregateInput>;
  OR?: InputMaybe<Array<TakeAudioAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TakeAudioNodeAggregationWhereInput>;
};

export type TakeAudioConnection = {
  __typename?: 'TakeAudioConnection';
  edges: Array<TakeAudioRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TakeAudioConnectionSort = {
  edge?: InputMaybe<HasTakeSort>;
  node?: InputMaybe<AudioSort>;
};

export type TakeAudioConnectionWhere = {
  AND?: InputMaybe<Array<TakeAudioConnectionWhere>>;
  NOT?: InputMaybe<TakeAudioConnectionWhere>;
  OR?: InputMaybe<Array<TakeAudioConnectionWhere>>;
  edge?: InputMaybe<HasTakeWhere>;
  node?: InputMaybe<AudioWhere>;
};

export type TakeAudioNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TakeAudioNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TakeAudioNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TakeAudioNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TakeAudioRelationship = {
  __typename?: 'TakeAudioRelationship';
  cursor: Scalars['String']['output'];
  node: Audio;
  properties: HasTake;
};

export type TakeEdge = {
  __typename?: 'TakeEdge';
  cursor: Scalars['String']['output'];
  node: Take;
};

export type TakeLineAggregateInput = {
  AND?: InputMaybe<Array<TakeLineAggregateInput>>;
  NOT?: InputMaybe<TakeLineAggregateInput>;
  OR?: InputMaybe<Array<TakeLineAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TakeLineNodeAggregationWhereInput>;
};

export type TakeLineConnection = {
  __typename?: 'TakeLineConnection';
  edges: Array<TakeLineRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TakeLineConnectionSort = {
  edge?: InputMaybe<HasTakeSort>;
  node?: InputMaybe<LineSort>;
};

export type TakeLineConnectionWhere = {
  AND?: InputMaybe<Array<TakeLineConnectionWhere>>;
  NOT?: InputMaybe<TakeLineConnectionWhere>;
  OR?: InputMaybe<Array<TakeLineConnectionWhere>>;
  edge?: InputMaybe<HasTakeWhere>;
  node?: InputMaybe<LineWhere>;
};

export type TakeLineNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TakeLineNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TakeLineNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TakeLineNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customFields_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customFields_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customFields_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customFields_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ordinal_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ordinal_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  performanceNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  performanceNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TakeLineRelationship = {
  __typename?: 'TakeLineRelationship';
  cursor: Scalars['String']['output'];
  node: Line;
  properties: HasTake;
};

export type TakeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TakeSort objects to sort Takes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TakeSort>>;
};

export type TakeRecordingSessionAggregateInput = {
  AND?: InputMaybe<Array<TakeRecordingSessionAggregateInput>>;
  NOT?: InputMaybe<TakeRecordingSessionAggregateInput>;
  OR?: InputMaybe<Array<TakeRecordingSessionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TakeRecordingSessionNodeAggregationWhereInput>;
};

export type TakeRecordingSessionConnection = {
  __typename?: 'TakeRecordingSessionConnection';
  edges: Array<TakeRecordingSessionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TakeRecordingSessionConnectionSort = {
  node?: InputMaybe<RecordingSessionSort>;
};

export type TakeRecordingSessionConnectionWhere = {
  AND?: InputMaybe<Array<TakeRecordingSessionConnectionWhere>>;
  NOT?: InputMaybe<TakeRecordingSessionConnectionWhere>;
  OR?: InputMaybe<Array<TakeRecordingSessionConnectionWhere>>;
  node?: InputMaybe<RecordingSessionWhere>;
};

export type TakeRecordingSessionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TakeRecordingSessionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TakeRecordingSessionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TakeRecordingSessionNodeAggregationWhereInput>>;
  actor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  beginTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  beginTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  engineer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  engineer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  engineer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  engineer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  engineer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  org_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  org_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  org_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  studio_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  studio_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  studio_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  studio_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  studio_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TakeRecordingSessionRelationship = {
  __typename?: 'TakeRecordingSessionRelationship';
  cursor: Scalars['String']['output'];
  node: RecordingSession;
};

/** Fields to sort Takes by. The order in which sorts are applied is not guaranteed when specifying many fields in one TakeSort object. */
export type TakeSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  note?: InputMaybe<SortDirection>;
  org?: InputMaybe<SortDirection>;
  take?: InputMaybe<SortDirection>;
};

export type TakeWhere = {
  AND?: InputMaybe<Array<TakeWhere>>;
  NOT?: InputMaybe<TakeWhere>;
  OR?: InputMaybe<Array<TakeWhere>>;
  audioAggregate?: InputMaybe<TakeAudioAggregateInput>;
  /** Return Takes where all of the related TakeAudioConnections match this filter */
  audioConnection_ALL?: InputMaybe<TakeAudioConnectionWhere>;
  /** Return Takes where none of the related TakeAudioConnections match this filter */
  audioConnection_NONE?: InputMaybe<TakeAudioConnectionWhere>;
  /** Return Takes where one of the related TakeAudioConnections match this filter */
  audioConnection_SINGLE?: InputMaybe<TakeAudioConnectionWhere>;
  /** Return Takes where some of the related TakeAudioConnections match this filter */
  audioConnection_SOME?: InputMaybe<TakeAudioConnectionWhere>;
  /** Return Takes where all of the related Audio match this filter */
  audio_ALL?: InputMaybe<AudioWhere>;
  /** Return Takes where none of the related Audio match this filter */
  audio_NONE?: InputMaybe<AudioWhere>;
  /** Return Takes where one of the related Audio match this filter */
  audio_SINGLE?: InputMaybe<AudioWhere>;
  /** Return Takes where some of the related Audio match this filter */
  audio_SOME?: InputMaybe<AudioWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lineAggregate?: InputMaybe<TakeLineAggregateInput>;
  /** Return Takes where all of the related TakeLineConnections match this filter */
  lineConnection_ALL?: InputMaybe<TakeLineConnectionWhere>;
  /** Return Takes where none of the related TakeLineConnections match this filter */
  lineConnection_NONE?: InputMaybe<TakeLineConnectionWhere>;
  /** Return Takes where one of the related TakeLineConnections match this filter */
  lineConnection_SINGLE?: InputMaybe<TakeLineConnectionWhere>;
  /** Return Takes where some of the related TakeLineConnections match this filter */
  lineConnection_SOME?: InputMaybe<TakeLineConnectionWhere>;
  /** Return Takes where all of the related Lines match this filter */
  line_ALL?: InputMaybe<LineWhere>;
  /** Return Takes where none of the related Lines match this filter */
  line_NONE?: InputMaybe<LineWhere>;
  /** Return Takes where one of the related Lines match this filter */
  line_SINGLE?: InputMaybe<LineWhere>;
  /** Return Takes where some of the related Lines match this filter */
  line_SOME?: InputMaybe<LineWhere>;
  note?: InputMaybe<Scalars['String']['input']>;
  note_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  note_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  note_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  note_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  org_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  org_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  org_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  org_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordingSession?: InputMaybe<RecordingSessionWhere>;
  recordingSessionAggregate?: InputMaybe<TakeRecordingSessionAggregateInput>;
  recordingSessionConnection?: InputMaybe<TakeRecordingSessionConnectionWhere>;
  recordingSessionConnection_NOT?: InputMaybe<TakeRecordingSessionConnectionWhere>;
  recordingSession_NOT?: InputMaybe<RecordingSessionWhere>;
  take?: InputMaybe<Scalars['String']['input']>;
  take_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  take_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  take_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  take_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TakesConnection = {
  __typename?: 'TakesConnection';
  edges: Array<TakeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UnchangedGroupChildren = {
  id: Scalars['String']['input'];
  type: UnchangedGroupChildrenType;
};

export enum UnchangedGroupChildrenType {
  Line = 'LINE'
}

export type UnchangedSongChildren = {
  id: Scalars['String']['input'];
  type: UnchangedSongChildrenType;
};

export enum UnchangedSongChildrenType {
  Line = 'LINE',
  LineGroup = 'LINE_GROUP'
}

export type UpdateAudioMutationResponse = {
  __typename?: 'UpdateAudioMutationResponse';
  audio: Array<Audio>;
  info: UpdateInfo;
};

export enum UpdateCharacterAssignmentType {
  Audio = 'AUDIO',
  AudioGroup = 'AUDIO_GROUP'
}

export type UpdateCharactersMutationResponse = {
  __typename?: 'UpdateCharactersMutationResponse';
  characters: Array<Character>;
  info: UpdateInfo;
};

export type UpdateEpisodesMutationResponse = {
  __typename?: 'UpdateEpisodesMutationResponse';
  episodes: Array<Episode>;
  info: UpdateInfo;
};

/** Information about the number of nodes and relationships created and deleted during an update mutation */
export type UpdateInfo = {
  __typename?: 'UpdateInfo';
  /** @deprecated This field has been deprecated because bookmarks are now handled by the driver. */
  bookmark?: Maybe<Scalars['String']['output']>;
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type UpdateLinesMutationResponse = {
  __typename?: 'UpdateLinesMutationResponse';
  info: UpdateInfo;
  lines: Array<Line>;
};

export type UpdateRecordingSessionsMutationResponse = {
  __typename?: 'UpdateRecordingSessionsMutationResponse';
  info: UpdateInfo;
  recordingSessions: Array<RecordingSession>;
};

export type UpdateSeasonsMutationResponse = {
  __typename?: 'UpdateSeasonsMutationResponse';
  info: UpdateInfo;
  seasons: Array<Season>;
};

export type UpdateShowsMutationResponse = {
  __typename?: 'UpdateShowsMutationResponse';
  info: UpdateInfo;
  shows: Array<Show>;
};

export type CreateEpisode_AddEpisodeDialogMutationVariables = Exact<{
  input: Array<EpisodeCreateInput> | EpisodeCreateInput;
}>;


export type CreateEpisode_AddEpisodeDialogMutation = { __typename: 'Mutation', createEpisodes: { __typename: 'CreateEpisodesMutationResponse', episodes: Array<{ __typename: 'Episode', id: string, title: string }> } };

export type CascadeDeleteEpisodeMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type CascadeDeleteEpisodeMutation = { __typename: 'Mutation', cascadeDeleteEpisode: { __typename: 'DeleteInfo', nodesDeleted: number, relationshipsDeleted: number } };

export type UpdateEpisodesMutationVariables = Exact<{
  where?: InputMaybe<EpisodeWhere>;
  update?: InputMaybe<EpisodeUpdateInput>;
}>;


export type UpdateEpisodesMutation = { __typename: 'Mutation', updateEpisodes: { __typename: 'UpdateEpisodesMutationResponse', episodes: Array<{ __typename: 'Episode', id: string, title: string }> } };

export type UpdateCharacterAssignmentMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  type: UpdateCharacterAssignmentType;
  newCharacterIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateCharacterAssignmentMutation = { __typename: 'Mutation', updateCharacterAssignment: { __typename: 'MutationResult', success: boolean, error?: string | null } };

export type UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanelMutationVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
  update?: InputMaybe<ShowUpdateInput>;
}>;


export type UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanelMutation = { __typename: 'Mutation', updateShows: { __typename: 'UpdateShowsMutationResponse', shows: Array<{ __typename: 'Show', id: string, customFieldsDefinition?: string | null }> } };

export type CustomFieldsInfoQueryVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
}>;


export type CustomFieldsInfoQuery = { __typename: 'Query', shows: Array<{ __typename: 'Show', id: string, customFieldsDefinition?: string | null }> };

export type UpdateLineCustomFieldsMutationVariables = Exact<{
  where?: InputMaybe<LineWhere>;
  update?: InputMaybe<LineUpdateInput>;
}>;


export type UpdateLineCustomFieldsMutation = { __typename: 'Mutation', updateLines: { __typename: 'UpdateLinesMutationResponse', lines: Array<{ __typename: 'Line', id: string, customFields?: string | null }> } };

export type UpdateAudioCustomFieldsMutationVariables = Exact<{
  where?: InputMaybe<AudioWhere>;
  update?: InputMaybe<AudioUpdateInput>;
}>;


export type UpdateAudioCustomFieldsMutation = { __typename: 'Mutation', updateAudio: { __typename: 'UpdateAudioMutationResponse', audio: Array<{ __typename: 'Audio', id: string, customFields?: string | null }> } };

export type UpdateLinePerformanceNotesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  performanceNotes: Scalars['String']['input'];
}>;


export type UpdateLinePerformanceNotesMutation = { __typename: 'Mutation', updatePerformanceNotes: { __typename: 'Line', id: string, performanceNotes?: string | null } };

export type UpdateAudioPerformanceNotesMutationVariables = Exact<{
  where?: InputMaybe<AudioWhere>;
  update?: InputMaybe<AudioUpdateInput>;
}>;


export type UpdateAudioPerformanceNotesMutation = { __typename: 'Mutation', updateAudio: { __typename: 'UpdateAudioMutationResponse', audio: Array<{ __typename: 'Audio', id: string, performanceNotes?: string | null }> } };

export type UpdateLineShotNoMutationVariables = Exact<{
  where?: InputMaybe<LineWhere>;
  update?: InputMaybe<LineUpdateInput>;
}>;


export type UpdateLineShotNoMutation = { __typename: 'Mutation', updateLines: { __typename: 'UpdateLinesMutationResponse', lines: Array<{ __typename: 'Line', id: string }> } };

export type UpdateAudioShotNoMutationVariables = Exact<{
  where?: InputMaybe<AudioWhere>;
  update?: InputMaybe<AudioUpdateInput>;
}>;


export type UpdateAudioShotNoMutation = { __typename: 'Mutation', updateAudio: { __typename: 'UpdateAudioMutationResponse', audio: Array<{ __typename: 'Audio', id: string }> } };

export type UpdateLineTimeCodeMutationVariables = Exact<{
  where?: InputMaybe<LineWhere>;
  update?: InputMaybe<LineUpdateInput>;
}>;


export type UpdateLineTimeCodeMutation = { __typename: 'Mutation', updateLines: { __typename: 'UpdateLinesMutationResponse', lines: Array<{ __typename: 'Line', id: string }> } };

export type UpdateAudioTimeCodeMutationVariables = Exact<{
  where?: InputMaybe<AudioWhere>;
  update?: InputMaybe<AudioUpdateInput>;
}>;


export type UpdateAudioTimeCodeMutation = { __typename: 'Mutation', updateAudio: { __typename: 'UpdateAudioMutationResponse', audio: Array<{ __typename: 'Audio', id: string }> } };

export type GetRevisions_RevisionsDetailQueryVariables = Exact<{
  where?: InputMaybe<LineWhere>;
}>;


export type GetRevisions_RevisionsDetailQuery = { __typename: 'Query', lines: Array<{ __typename: 'Line', revisions: Array<{ __typename: 'Line', id: string, lineNo: string, lineStatus: LineStatus, characterName: string, overrideCharacterName?: string | null, performanceNotes?: string | null, text: string, overrideText?: string | null, recordingStatus: RecordingStatus, library?: Library | null, hasTakes: boolean, customFields?: string | null, selectInfo: { __typename: 'SelectInfo', select?: { __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean } | null, alt: Array<{ __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean }> }, script: { __typename: 'Script', name: string } }> }> };

export type UpdateLineLibrary_LibraryActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  library?: InputMaybe<Library>;
}>;


export type UpdateLineLibrary_LibraryActionMutation = { __typename: 'Mutation', updateLines: { __typename: 'UpdateLinesMutationResponse', lines: Array<{ __typename: 'Line', id: string, library?: Library | null }> } };

export type UpdateAudioLibrary_LibraryActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  library?: InputMaybe<Library>;
}>;


export type UpdateAudioLibrary_LibraryActionMutation = { __typename: 'Mutation', updateAudio: { __typename: 'UpdateAudioMutationResponse', audio: Array<{ __typename: 'Audio', id: string, library?: Library | null }> } };

export type GetCharacters_LineCharacterEditQueryVariables = Exact<{
  where?: InputMaybe<CharacterWhere>;
}>;


export type GetCharacters_LineCharacterEditQuery = { __typename: 'Query', characters: Array<{ __typename: 'Character', id: string, name: string }> };

type LineDataGrid_Audio_Fragment = { __typename: 'Audio', id: string, ordinal: number, tag: string, text: string, performanceNotes?: string | null, hasTakes: boolean, recordingStatus: RecordingStatus, library?: Library | null, customFields?: string | null, cancelled: boolean, character?: { __typename: 'Character', id: string, name: string } | null, from: { __typename: 'ContextBlock', id: string, text: string }, selectInfo: { __typename: 'SelectInfo', select?: { __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean } | null, alt: Array<{ __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean }> }, script: { __typename: 'Script', name: string } } & { ' $fragmentName'?: 'LineDataGrid_Audio_Fragment' };

type LineDataGrid_AudioGroup_Fragment = { __typename: 'AudioGroup', id: string, ordinal: number, tag: string, cancelled: boolean, audios: Array<{ __typename: 'Audio', id: string, ordinal: number, tag: string, text: string, performanceNotes?: string | null, hasTakes: boolean, recordingStatus: RecordingStatus, library?: Library | null, customFields?: string | null, cancelled: boolean, character?: { __typename: 'Character', id: string, name: string } | null, from: { __typename: 'ContextBlock', id: string, text: string }, selectInfo: { __typename: 'SelectInfo', select?: { __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean } | null, alt: Array<{ __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean }> }, script: { __typename: 'Script', name: string } }> } & { ' $fragmentName'?: 'LineDataGrid_AudioGroup_Fragment' };

type LineDataGrid_ContextBlock_Fragment = { __typename: 'ContextBlock' } & { ' $fragmentName'?: 'LineDataGrid_ContextBlock_Fragment' };

type LineDataGrid_Line_Fragment = { __typename: 'Line', id: string, revisionChainId: string, ordinal: number, lineNo: string, text: string, overrideText?: string | null, performanceNotes?: string | null, characterName: string, overrideCharacterName?: string | null, lineStatus: LineStatus, hasRevisions: boolean, hasTakes: boolean, hasOverride: boolean, recordingStatus: RecordingStatus, library?: Library | null, customFields?: string | null, cancelled: boolean, selectInfo: { __typename: 'SelectInfo', select?: { __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean } | null, alt: Array<{ __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean }> }, script: { __typename: 'Script', name: string } } & { ' $fragmentName'?: 'LineDataGrid_Line_Fragment' };

type LineDataGrid_LineGroup_Fragment = { __typename: 'LineGroup', id: string, ordinal: number, lineNo: string, cancelled: boolean, lines: Array<{ __typename: 'Line', id: string, revisionChainId: string, ordinal: number, lineNo: string, text: string, overrideText?: string | null, performanceNotes?: string | null, characterName: string, overrideCharacterName?: string | null, lineStatus: LineStatus, hasRevisions: boolean, hasTakes: boolean, hasOverride: boolean, recordingStatus: RecordingStatus, library?: Library | null, customFields?: string | null, cancelled: boolean, selectInfo: { __typename: 'SelectInfo', select?: { __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean } | null, alt: Array<{ __typename: 'SelectSessionInfo', takeId: string, take: string, sessionId: string, sessionName: string, sessionType: RecordingSessionType, scratch: boolean }> }, script: { __typename: 'Script', name: string } }> } & { ' $fragmentName'?: 'LineDataGrid_LineGroup_Fragment' };

export type LineDataGridFragment = LineDataGrid_Audio_Fragment | LineDataGrid_AudioGroup_Fragment | LineDataGrid_ContextBlock_Fragment | LineDataGrid_Line_Fragment | LineDataGrid_LineGroup_Fragment;

export type EpisodeLinesQueryVariables = Exact<{
  episodeWhere?: InputMaybe<EpisodeWhere>;
  contentWhere?: InputMaybe<EpisodeContentWhere>;
  subLineOptions?: InputMaybe<LineOptions>;
  subAudioWhere?: InputMaybe<AudioWhere>;
  subAudioOptions?: InputMaybe<AudioOptions>;
}>;


export type EpisodeLinesQuery = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', hasLines?: boolean | null, content: Array<(
      { __typename: 'Audio' }
      & { ' $fragmentRefs'?: { 'LineDataGrid_Audio_Fragment': LineDataGrid_Audio_Fragment } }
    ) | (
      { __typename: 'AudioGroup' }
      & { ' $fragmentRefs'?: { 'LineDataGrid_AudioGroup_Fragment': LineDataGrid_AudioGroup_Fragment } }
    ) | (
      { __typename: 'ContextBlock' }
      & { ' $fragmentRefs'?: { 'LineDataGrid_ContextBlock_Fragment': LineDataGrid_ContextBlock_Fragment } }
    ) | (
      { __typename: 'Line' }
      & { ' $fragmentRefs'?: { 'LineDataGrid_Line_Fragment': LineDataGrid_Line_Fragment } }
    ) | (
      { __typename: 'LineGroup' }
      & { ' $fragmentRefs'?: { 'LineDataGrid_LineGroup_Fragment': LineDataGrid_LineGroup_Fragment } }
    )> }> };

export type GetProductionData_ProductionDataTableQueryVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type GetProductionData_ProductionDataTableQuery = { __typename: 'Query', productionData: Array<{ __typename: 'ProductionData', totalLines: number, completedLines: number, incompleteLines: number, cancelledLines: number, originalRecordings: number, pickupRecordings: number, totalRecordingTime: number, avgTimePerLine: number, adrRecordings: number, adrRecordingTime: number, character: { __typename: 'ProductionDataCharacterData', id: string, name: string } }> };

export type GetLineText_CompDetailQueryVariables = Exact<{
  where?: InputMaybe<LineWhere>;
}>;


export type GetLineText_CompDetailQuery = { __typename: 'Query', lines: Array<{ __typename: 'Line', text: string }> };

export type GetAudioText_CompDetailQueryVariables = Exact<{
  where?: InputMaybe<AudioWhere>;
}>;


export type GetAudioText_CompDetailQuery = { __typename: 'Query', audio: Array<{ __typename: 'Audio', text: string }> };

export type SaveRecordingSession_FinishSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type SaveRecordingSession_FinishSessionMutation = { __typename: 'Mutation', saveRecordingSessionDraft: { __typename: 'IdResult', id: string } };

export type GetSessionData_UseDraftSessionDataQueryVariables = Exact<{
  episodeId: Scalars['String']['input'];
  characterIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  lineTakeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSessionData_UseDraftSessionDataQuery = { __typename: 'Query', draftRecordingSessionLines: Array<{ __typename: 'RecordingSessionCharacter', id: string, name: string, lines: Array<{ __typename: 'RecordingSessionLine', id: string, ordinal: number, lineNo: string, text: string, performanceNotes?: string | null, characterName: string, customFields?: string | null, revisionChainId: string, hasOverride: boolean, revisions: Array<{ __typename: 'RecordingSessionRevision', id: string, ordinal: number, lineNo: string, text: string, performanceNotes?: string | null, characterName: string, customFields?: string | null, hidden: boolean, group?: { __typename: 'RecordingSessionLineGroupData', characterName: Array<string> } | null }>, group?: { __typename: 'RecordingSessionLineGroupData', characterName: Array<string>, text: Array<string> } | null }>, audio: Array<{ __typename: 'RecordingSessionAudio', id: string, ordinal: number, tag: string, text: string, performanceNotes?: string | null, customFields?: string | null, context: string, group?: { __typename: 'RecordingSessionAudioGroupData', characters: Array<{ __typename: 'RecordingSessionCharacterData', id: string, name: string }> } | null, character: { __typename: 'RecordingSessionCharacterData', id: string, name: string } }> }> };

export type GetScriptViewData_ScriptViewWrapper_SessionDraftQueryVariables = Exact<{
  episodeWhere?: InputMaybe<EpisodeWhere>;
  contentWhere?: InputMaybe<EpisodeContentWhere>;
}>;


export type GetScriptViewData_ScriptViewWrapper_SessionDraftQuery = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', content: Array<{ __typename: 'Audio' } | { __typename: 'AudioGroup' } | { __typename: 'ContextBlock', id: string, ordinal: number, type: ContextBlockType, text: string, audios: Array<{ __typename: 'Audio', id: string, tag: string, text: string, recordingStatus: RecordingStatus, library?: Library | null, character?: { __typename: 'Character', id: string, name: string } | null, groups: Array<{ __typename: 'AudioGroup', audios: Array<{ __typename: 'Audio', character?: { __typename: 'Character', id: string, name: string } | null }> }> }> } | { __typename: 'Line', id: string, revisionChainId: string, ordinal: number, lineNo: string, text: string, hasOverride: boolean, performanceNotes?: string | null, characterName: string, recordingStatus: RecordingStatus, library?: Library | null, character: { __typename: 'Character', id: string, name: string }, revisions: Array<{ __typename: 'Line', id: string, lineNo: string, text: string, characterName: string, character: { __typename: 'Character', id: string }, groups: Array<{ __typename: 'LineGroup', characterName: Array<string> }> }> } | { __typename: 'LineGroup', id: string, ordinal: number, lines: Array<{ __typename: 'Line', id: string, revisionChainId: string, lineNo: string, text: string, hasOverride: boolean, performanceNotes?: string | null, characterName: string, recordingStatus: RecordingStatus, library?: Library | null, character: { __typename: 'Character', id: string, name: string }, revisions: Array<{ __typename: 'Line', id: string, lineNo: string, text: string, characterName: string, character: { __typename: 'Character', id: string }, groups: Array<{ __typename: 'LineGroup', characterName: Array<string> }> }> }> }> }> };

export type GetSeasonOptionsQueryVariables = Exact<{
  where?: InputMaybe<SeasonWhere>;
}>;


export type GetSeasonOptionsQuery = { __typename: 'Query', seasons: Array<{ __typename: 'Season', id: string, title: string }> };

export type GetEpisodeOptionsQueryVariables = Exact<{
  where?: InputMaybe<EpisodeWhere>;
}>;


export type GetEpisodeOptionsQuery = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', id: string, title: string }> };

export type GetCharacterOptionsQueryVariables = Exact<{
  where?: InputMaybe<CharacterWhere>;
  options?: InputMaybe<CharacterOptions>;
}>;


export type GetCharacterOptionsQuery = { __typename: 'Query', characters: Array<{ __typename: 'Character', id: string, name: string }> };

export type GetCompDetail_CompDetailWrapperQueryVariables = Exact<{
  where?: InputMaybe<CompWhere>;
}>;


export type GetCompDetail_CompDetailWrapperQuery = { __typename: 'Query', comps: Array<{ __typename: 'Comp', id: string, circled: boolean, alt: boolean, note: string, takesConnection: { __typename: 'CompTakesConnection', edges: Array<{ __typename: 'CompTakesRelationship', properties: { __typename: 'CompHasTake', subStrings: string }, node: { __typename: 'Take', id: string, take: string } }> } }> };

export type DeleteTakeMutationVariables = Exact<{
  where?: InputMaybe<TakeWhere>;
}>;


export type DeleteTakeMutation = { __typename: 'Mutation', deleteTakes: { __typename: 'DeleteInfo', nodesDeleted: number } };

export type UpdateRecordingSessionMutationVariables = Exact<{
  where?: InputMaybe<RecordingSessionWhere>;
  update?: InputMaybe<RecordingSessionUpdateInput>;
}>;


export type UpdateRecordingSessionMutation = { __typename: 'Mutation', updateRecordingSessions: { __typename: 'UpdateRecordingSessionsMutationResponse', recordingSessions: Array<{ __typename: 'RecordingSession', id: string, name: string, actor?: string | null, beginTime?: any | null, endTime?: any | null, engineer?: string | null, notes?: string | null, scratch: boolean, studio?: string | null }> } };

export type UpdateTakeProperties_EditTakeDataMutationVariables = Exact<{
  lineId: Scalars['ID']['input'];
  takeId: Scalars['ID']['input'];
  select: SelectType;
  take?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTakeProperties_EditTakeDataMutation = { __typename: 'Mutation', updateTakeProperties: { __typename: 'MutationResult', success: boolean } };

export type GetScriptViewData_ScriptViewWrapper_SessionFinalQueryVariables = Exact<{
  recordingSessionId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
  where?: InputMaybe<RecordingSessionWhere>;
  audioTakeWhere?: InputMaybe<TakeWhere>;
}>;


export type GetScriptViewData_ScriptViewWrapper_SessionFinalQuery = { __typename: 'Query', recordingSessions: Array<{ __typename: 'RecordingSession', script?: { __typename: 'Script', content: Array<{ __typename: 'Audio' } | { __typename: 'AudioGroup' } | { __typename: 'ContextBlock', id: string, ordinal: number, type: ContextBlockType, text: string, audios: Array<{ __typename: 'Audio', id: string, tag: string, text: string, character?: { __typename: 'Character', id: string, name: string } | null, takes: Array<{ __typename: 'Take', id: string, take: string, note: string, audioConnection: { __typename: 'TakeAudioConnection', edges: Array<{ __typename: 'TakeAudioRelationship', properties: { __typename: 'HasTake', select?: SelectType | null }, node: { __typename: 'Audio', id: string, text: string } }> } }> }> } | { __typename: 'Line', id: string, revisionChainId: string, ordinal: number, lineNo: string, text: string, characterName: string, character: { __typename: 'Character', id: string, name: string }, allTakes: Array<{ __typename: 'Take', id: string, take: string, note: string, lineConnection: { __typename: 'TakeLineConnection', edges: Array<{ __typename: 'TakeLineRelationship', properties: { __typename: 'HasTake', select?: SelectType | null }, node: { __typename: 'Line', id: string, revisionChainId: string, text: string, characterName: string } }> } }> } | { __typename: 'LineGroup', id: string, ordinal: number, lines: Array<{ __typename: 'Line', id: string, revisionChainId: string, ordinal: number, lineNo: string, text: string, characterName: string, character: { __typename: 'Character', id: string, name: string }, allTakes: Array<{ __typename: 'Take', id: string, take: string, note: string, lineConnection: { __typename: 'TakeLineConnection', edges: Array<{ __typename: 'TakeLineRelationship', properties: { __typename: 'HasTake', select?: SelectType | null }, node: { __typename: 'Line', id: string, revisionChainId: string, text: string, characterName: string } }> } }> }> }> } | null }> };

export type GetSessionLines_TableWrapperQueryVariables = Exact<{
  recordingSessionId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
  where?: InputMaybe<RecordingSessionWhere>;
  groupWhere?: InputMaybe<LineGroupWhere>;
  audioTakeWhere?: InputMaybe<TakeWhere>;
}>;


export type GetSessionLines_TableWrapperQuery = { __typename: 'Query', recordingSessions: Array<{ __typename: 'RecordingSession', lines: Array<{ __typename: 'Line', id: string, revisionChainId: string, ordinal: number, lineNo: string, text: string, overrideText?: string | null, recordingStatus: RecordingStatus, performanceNotes?: string | null, characterName: string, overrideCharacterName?: string | null, customFields?: string | null, character: { __typename: 'Character', id: string, name: string }, groups: Array<{ __typename: 'LineGroup', characterName: Array<string>, text: Array<string> }>, allTakes: Array<{ __typename: 'Take', id: string, take: string, note: string, lineConnection: { __typename: 'TakeLineConnection', edges: Array<{ __typename: 'TakeLineRelationship', properties: { __typename: 'HasTake', select?: SelectType | null }, node: { __typename: 'Line', id: string, revisionChainId: string, text: string, characterName: string } }> } }>, override?: { __typename: 'Take', id: string } | null }>, audios: Array<{ __typename: 'Audio', id: string, ordinal: number, tag: string, text: string, recordingStatus: RecordingStatus, performanceNotes?: string | null, customFields?: string | null, from: { __typename: 'ContextBlock', text: string }, groups: Array<{ __typename: 'AudioGroup', characters: Array<{ __typename: 'Character', id: string, name: string }> }>, character?: { __typename: 'Character', id: string, name: string } | null, takes: Array<{ __typename: 'Take', id: string, take: string, note: string, audioConnection: { __typename: 'TakeAudioConnection', edges: Array<{ __typename: 'TakeAudioRelationship', properties: { __typename: 'HasTake', select?: SelectType | null }, node: { __typename: 'Audio', id: string, text: string } }> } }> }> }> };

export type GetRecordingSessionEpisodes_RecordingSessionQueryVariables = Exact<{
  where?: InputMaybe<RecordingSessionWhere>;
}>;


export type GetRecordingSessionEpisodes_RecordingSessionQuery = { __typename: 'Query', recordingSessions: Array<(
    { __typename: 'RecordingSession' }
    & { ' $fragmentRefs'?: { 'RecordingSessionFragmentFragment': RecordingSessionFragmentFragment } }
  )> };

export type RecordingSessionFragmentFragment = { __typename: 'RecordingSession', id: string, name: string, complete: boolean, actor?: string | null, beginTime?: any | null, endTime?: any | null, engineer?: string | null, notes?: string | null, scratch: boolean, studio?: string | null, episodesConnection: { __typename: 'RecordingSessionEpisodesConnection', edges: Array<{ __typename: 'RecordingSessionEpisodesRelationship', node: { __typename: 'Episode', id: string, title: string }, properties: { __typename: 'SessionHasEpisode', type: RecordingSessionType } }> } } & { ' $fragmentName'?: 'RecordingSessionFragmentFragment' };

export type GetRecordingSessions_RecordingSessionTableQueryVariables = Exact<{
  where?: InputMaybe<RecordingSessionWhere>;
  options?: InputMaybe<RecordingSessionOptions>;
  epSort?: InputMaybe<Array<RecordingSessionEpisodesConnectionSort> | RecordingSessionEpisodesConnectionSort>;
}>;


export type GetRecordingSessions_RecordingSessionTableQuery = { __typename: 'Query', recordingSessions: Array<{ __typename: 'RecordingSession', id: string, name: string, scratch: boolean, complete: boolean, episodesConnection: { __typename: 'RecordingSessionEpisodesConnection', edges: Array<{ __typename: 'RecordingSessionEpisodesRelationship', properties: { __typename: 'SessionHasEpisode', type: RecordingSessionType }, node: { __typename: 'Episode', title: string } }> }, characters: Array<{ __typename: 'Character', name: string }> }> };

export type GetEpisodeTitle_RecordingSessionTableQueryVariables = Exact<{
  where?: InputMaybe<EpisodeWhere>;
}>;


export type GetEpisodeTitle_RecordingSessionTableQuery = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', id: string, title: string }> };

export type GetCharacterName_RecordingSessionTableQueryVariables = Exact<{
  where?: InputMaybe<CharacterWhere>;
}>;


export type GetCharacterName_RecordingSessionTableQuery = { __typename: 'Query', characters: Array<{ __typename: 'Character', id: string, name: string }> };

export type GetLineText_CompsQueryVariables = Exact<{
  lineWhere?: InputMaybe<LineWhere>;
}>;


export type GetLineText_CompsQuery = { __typename: 'Query', lines: Array<{ __typename: 'Line', id: string, lineNo: string, text: string }> };

export type GetAudioText_CompsQueryVariables = Exact<{
  audioWhere?: InputMaybe<AudioWhere>;
}>;


export type GetAudioText_CompsQuery = { __typename: 'Query', audio: Array<{ __typename: 'Audio', id: string, tag: string, text: string }> };

export type GetLineInfo_TakesQueryVariables = Exact<{
  lineWhere?: InputMaybe<LineWhere>;
}>;


export type GetLineInfo_TakesQuery = { __typename: 'Query', lines: Array<{ __typename: 'Line', id: string, lineNo: string }> };

export type GetAudioInfo_TakesQueryVariables = Exact<{
  audioWhere?: InputMaybe<AudioWhere>;
}>;


export type GetAudioInfo_TakesQuery = { __typename: 'Query', audio: Array<{ __typename: 'Audio', id: string, tag: string }> };

export type DeleteScriptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
}>;


export type DeleteScriptMutation = { __typename: 'Mutation', deleteScript: { __typename: 'MutationResult', success: boolean } };

export type GetScripts_ScriptTableWidgetQueryVariables = Exact<{
  where?: InputMaybe<EpisodeWhere>;
}>;


export type GetScripts_ScriptTableWidgetQuery = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', scripts: Array<{ __typename: 'Script', id: string, name: string, created: any }> }> };

export type CreateSeason_AddSeasonDialogMutationVariables = Exact<{
  input: Array<SeasonCreateInput> | SeasonCreateInput;
}>;


export type CreateSeason_AddSeasonDialogMutation = { __typename: 'Mutation', createSeasons: { __typename: 'CreateSeasonsMutationResponse', seasons: Array<{ __typename: 'Season', id: string, title: string, totalVoices: number }> } };

export type CascadeDeleteSeason_DeleteSeasonDialogMutationVariables = Exact<{
  seasonId: Scalars['ID']['input'];
}>;


export type CascadeDeleteSeason_DeleteSeasonDialogMutation = { __typename: 'Mutation', cascadeDeleteSeason: { __typename: 'DeleteInfo', nodesDeleted: number, relationshipsDeleted: number } };

export type UpdateSeasons_EditSeasonDialogMutationVariables = Exact<{
  where?: InputMaybe<SeasonWhere>;
  update?: InputMaybe<SeasonUpdateInput>;
}>;


export type UpdateSeasons_EditSeasonDialogMutation = { __typename: 'Mutation', updateSeasons: { __typename: 'UpdateSeasonsMutationResponse', seasons: Array<{ __typename: 'Season', id: string, title: string }> } };

export type CreateShow_AddShowDialogMutationVariables = Exact<{
  input: Array<ShowCreateInput> | ShowCreateInput;
}>;


export type CreateShow_AddShowDialogMutation = { __typename: 'Mutation', createShows: { __typename: 'CreateShowsMutationResponse', shows: Array<{ __typename: 'Show', id: string, title: string }> } };

export type CascadeDeleteShow_DeleteShowDialogMutationVariables = Exact<{
  showId: Scalars['ID']['input'];
}>;


export type CascadeDeleteShow_DeleteShowDialogMutation = { __typename: 'Mutation', cascadeDeleteShow: { __typename: 'DeleteInfo', nodesDeleted: number, relationshipsDeleted: number } };

export type UpdateShow_EditShowDialogMutationVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
  update?: InputMaybe<ShowUpdateInput>;
}>;


export type UpdateShow_EditShowDialogMutation = { __typename: 'Mutation', updateShows: { __typename: 'UpdateShowsMutationResponse', shows: Array<{ __typename: 'Show', id: string, title: string }> } };

export type AppBarEpisodeDataFragment = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', id: string, title: string }> } & { ' $fragmentName'?: 'AppBarEpisodeDataFragment' };

export type DrawerEpisodeDataFragment = { __typename: 'Query', episodes: Array<{ __typename: 'Episode', id: string, title: string }> } & { ' $fragmentName'?: 'DrawerEpisodeDataFragment' };

export type GetEpisodesForSeason_LayoutQueryVariables = Exact<{
  where?: InputMaybe<EpisodeWhere>;
  options?: InputMaybe<EpisodeOptions>;
}>;


export type GetEpisodesForSeason_LayoutQuery = (
  { __typename: 'Query' }
  & { ' $fragmentRefs'?: { 'AppBarEpisodeDataFragment': AppBarEpisodeDataFragment;'DrawerEpisodeDataFragment': DrawerEpisodeDataFragment } }
);

export type GetShows_SeasonShowProviderQueryVariables = Exact<{
  options?: InputMaybe<ShowOptions>;
}>;


export type GetShows_SeasonShowProviderQuery = { __typename: 'Query', shows: Array<{ __typename: 'Show', id: string, title: string }> };

export type GetSeasonFromShow_SeasonShowProviderQueryVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
  options?: InputMaybe<SeasonOptions>;
}>;


export type GetSeasonFromShow_SeasonShowProviderQuery = { __typename: 'Query', shows: Array<{ __typename: 'Show', seasons: Array<{ __typename: 'Season', id: string, title: string, totalVoices: number }> }> };

export type AppVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type AppVersionQuery = { __typename: 'Query', appVersion: { __typename: 'AppVersionResult', version: string } };

export type GetShowCharacters_UploadDialogQueryVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
}>;


export type GetShowCharacters_UploadDialogQuery = { __typename: 'Query', shows: Array<{ __typename: 'Show', characters: Array<{ __typename: 'Character', id: string, name: string }> }> };

export type ShowAndSeasonsForEpisodeQueryVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
  seasonWhere?: InputMaybe<SeasonWhere>;
}>;


export type ShowAndSeasonsForEpisodeQuery = { __typename: 'Query', shows: Array<{ __typename: 'Show', id: string, title: string, seasons: Array<{ __typename: 'Season', id: string, title: string, totalVoices: number }> }> };

export type CustomFieldsInfo_ParseExcelQueryVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
}>;


export type CustomFieldsInfo_ParseExcelQuery = { __typename: 'Query', shows: Array<{ __typename: 'Show', id: string, customFieldsDefinition?: string | null }> };

export type UpdateShowCustomFieldsDefinition_ParseExcelMutationVariables = Exact<{
  where?: InputMaybe<ShowWhere>;
  update?: InputMaybe<ShowUpdateInput>;
}>;


export type UpdateShowCustomFieldsDefinition_ParseExcelMutation = { __typename: 'Mutation', updateShows: { __typename: 'UpdateShowsMutationResponse', shows: Array<{ __typename: 'Show', id: string, customFieldsDefinition?: string | null }> } };

export type ExistingCharsFragmentFragment = { __typename: 'Character', id: string, name: string } & { ' $fragmentName'?: 'ExistingCharsFragmentFragment' };

export type ExistingLineFragmentFragment = { __typename: 'Line', id: string, lineNo: string, ordinal: number, text: string, overrideText?: string | null, lineStatus: LineStatus, overrideCharacterName?: string | null, library?: Library | null, performanceNotes?: string | null, customFields?: string | null, characterConnection: { __typename: 'LineCharacterConnection', edges: Array<{ __typename: 'LineCharacterRelationship', properties: { __typename: 'CharacterHasLine', alias?: string | null }, node: { __typename: 'Character', id: string, name: string } }> }, overrideCharacter?: { __typename: 'Character', id: string, name: string } | null } & { ' $fragmentName'?: 'ExistingLineFragmentFragment' };

export type ExistingLineGroupFragmentFragment = { __typename: 'LineGroup', id: string, lineNo: string, ordinal: number, lines: Array<{ __typename: 'Line', id: string, lineNo: string, ordinal: number, text: string, overrideText?: string | null, lineStatus: LineStatus, overrideCharacterName?: string | null, library?: Library | null, performanceNotes?: string | null, customFields?: string | null, characterConnection: { __typename: 'LineCharacterConnection', edges: Array<{ __typename: 'LineCharacterRelationship', properties: { __typename: 'CharacterHasLine', alias?: string | null }, node: { __typename: 'Character', id: string, name: string } }> }, overrideCharacter?: { __typename: 'Character', id: string, name: string } | null }> } & { ' $fragmentName'?: 'ExistingLineGroupFragmentFragment' };

export type ExistingAudioFragmentFragment = { __typename: 'Audio', id: string, tag: string } & { ' $fragmentName'?: 'ExistingAudioFragmentFragment' };

export type ExistingAudioGroupFragmentFragment = { __typename: 'AudioGroup', id: string, tag: string } & { ' $fragmentName'?: 'ExistingAudioGroupFragmentFragment' };

export type ExistingLinesAndGroups_UploadDialogQueryVariables = Exact<{
  characterWhere?: InputMaybe<CharacterWhere>;
  lineWhere?: InputMaybe<LineWhere>;
  lineGroupsWhere?: InputMaybe<LineGroupWhere>;
  lineOptions?: InputMaybe<LineOptions>;
  lineGroupOptions?: InputMaybe<LineGroupOptions>;
  audioWhere?: InputMaybe<AudioWhere>;
  audioGroupWhere?: InputMaybe<AudioGroupWhere>;
}>;


export type ExistingLinesAndGroups_UploadDialogQuery = { __typename: 'Query', characters: Array<(
    { __typename: 'Character' }
    & { ' $fragmentRefs'?: { 'ExistingCharsFragmentFragment': ExistingCharsFragmentFragment } }
  )>, lines: Array<(
    { __typename: 'Line' }
    & { ' $fragmentRefs'?: { 'ExistingLineFragmentFragment': ExistingLineFragmentFragment } }
  )>, lineGroups: Array<(
    { __typename: 'LineGroup' }
    & { ' $fragmentRefs'?: { 'ExistingLineGroupFragmentFragment': ExistingLineGroupFragmentFragment } }
  )>, audio: Array<(
    { __typename: 'Audio' }
    & { ' $fragmentRefs'?: { 'ExistingAudioFragmentFragment': ExistingAudioFragmentFragment } }
  )>, audioGroups: Array<(
    { __typename: 'AudioGroup' }
    & { ' $fragmentRefs'?: { 'ExistingAudioGroupFragmentFragment': ExistingAudioGroupFragmentFragment } }
  )> };

export type CreateParsedLines_UploadDialogMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  createCharacters: Array<CreateCharacter> | CreateCharacter;
  createGroups: Array<CreateLineGroup> | CreateLineGroup;
  createSongs: Array<CreateSong> | CreateSong;
  createContextBlocks: Array<CreateContextBlock> | CreateContextBlock;
  audio: Array<AudioInput> | AudioInput;
  lines: Array<ProcessedLine> | ProcessedLine;
  cancel: Array<CancelContent> | CancelContent;
  detach: Array<DetachContent> | DetachContent;
  fileName: Scalars['String']['input'];
  fromDraftScript: Scalars['Boolean']['input'];
  closeDraftScript?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateParsedLines_UploadDialogMutation = { __typename: 'Mutation', createParsedLines: { __typename: 'ParsedLinesOutput', createdLineInfo: Array<{ __typename: 'ParsedAudioGroupOutput', id: string, tag: string, ordinal: number, audios: Array<{ __typename: 'ParsedAudioOutput', id: string, tag: string, ordinal: number, character?: { __typename: 'ParsedAudioCharacter', id: string } | null }> } | { __typename: 'ParsedAudioOutput', id: string, tag: string, ordinal: number, character?: { __typename: 'ParsedAudioCharacter', id: string } | null } | { __typename: 'ParsedLineGroupOutput', id: string, ordinal: number, lines: Array<{ __typename: 'ParsedLineOutput', id: string, revisionChainId: string, ordinal: number }> } | { __typename: 'ParsedLineOutput', id: string, revisionChainId: string, ordinal: number }> } };

export const LineDataGridFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineDataGrid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subLineOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Audio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAudioWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAudioOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<LineDataGridFragment, unknown>;
export const RecordingSessionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordingSessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSession"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"actor"}},{"kind":"Field","name":{"kind":"Name","value":"beginTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"engineer"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}},{"kind":"Field","name":{"kind":"Name","value":"studio"}},{"kind":"Field","name":{"kind":"Name","value":"episodesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"node"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RecordingSessionFragmentFragment, unknown>;
export const AppBarEpisodeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppBarEpisodeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<AppBarEpisodeDataFragment, unknown>;
export const DrawerEpisodeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DrawerEpisodeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<DrawerEpisodeDataFragment, unknown>;
export const ExistingCharsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingCharsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Character"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ExistingCharsFragmentFragment, unknown>;
export const ExistingLineFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingLineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"characterConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]} as unknown as DocumentNode<ExistingLineFragmentFragment, unknown>;
export const ExistingLineGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingLineGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"characterConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]}}]} as unknown as DocumentNode<ExistingLineGroupFragmentFragment, unknown>;
export const ExistingAudioFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingAudioFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Audio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}}]} as unknown as DocumentNode<ExistingAudioFragmentFragment, unknown>;
export const ExistingAudioGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingAudioGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}}]} as unknown as DocumentNode<ExistingAudioGroupFragmentFragment, unknown>;
export const CreateEpisode_AddEpisodeDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEpisode_AddEpisodeDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeCreateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createEpisodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEpisode_AddEpisodeDialogMutation, CreateEpisode_AddEpisodeDialogMutationVariables>;
export const CascadeDeleteEpisodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CascadeDeleteEpisode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cascadeDeleteEpisode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"nodesDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipsDeleted"}}]}}]}}]} as unknown as DocumentNode<CascadeDeleteEpisodeMutation, CascadeDeleteEpisodeMutationVariables>;
export const UpdateEpisodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEpisodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateEpisodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEpisodesMutation, UpdateEpisodesMutationVariables>;
export const UpdateCharacterAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCharacterAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCharacterAssignmentType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newCharacterIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateCharacterAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"newCharacterIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newCharacterIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<UpdateCharacterAssignmentMutation, UpdateCharacterAssignmentMutationVariables>;
export const UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateShows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFieldsDefinition"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanelMutation, UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanelMutationVariables>;
export const CustomFieldsInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomFieldsInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFieldsDefinition"}}]}}]}}]} as unknown as DocumentNode<CustomFieldsInfoQuery, CustomFieldsInfoQueryVariables>;
export const UpdateLineCustomFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLineCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLineCustomFieldsMutation, UpdateLineCustomFieldsMutationVariables>;
export const UpdateAudioCustomFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAudioCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAudioCustomFieldsMutation, UpdateAudioCustomFieldsMutationVariables>;
export const UpdateLinePerformanceNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLinePerformanceNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"performanceNotes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updatePerformanceNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"performanceNotes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}}]}}]}}]} as unknown as DocumentNode<UpdateLinePerformanceNotesMutation, UpdateLinePerformanceNotesMutationVariables>;
export const UpdateAudioPerformanceNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAudioPerformanceNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAudioPerformanceNotesMutation, UpdateAudioPerformanceNotesMutationVariables>;
export const UpdateLineShotNoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLineShotNo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLineShotNoMutation, UpdateLineShotNoMutationVariables>;
export const UpdateAudioShotNoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAudioShotNo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAudioShotNoMutation, UpdateAudioShotNoMutationVariables>;
export const UpdateLineTimeCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLineTimeCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLineTimeCodeMutation, UpdateLineTimeCodeMutationVariables>;
export const UpdateAudioTimeCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAudioTimeCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAudioTimeCodeMutation, UpdateAudioTimeCodeMutationVariables>;
export const GetRevisions_RevisionsDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRevisions_RevisionsDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRevisions_RevisionsDetailQuery, GetRevisions_RevisionsDetailQueryVariables>;
export const UpdateLineLibrary_LibraryActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLineLibrary_LibraryAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"library"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Library"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"library"},"value":{"kind":"Variable","name":{"kind":"Name","value":"library"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLineLibrary_LibraryActionMutation, UpdateLineLibrary_LibraryActionMutationVariables>;
export const UpdateAudioLibrary_LibraryActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAudioLibrary_LibraryAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"library"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Library"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"library"},"value":{"kind":"Variable","name":{"kind":"Name","value":"library"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAudioLibrary_LibraryActionMutation, UpdateAudioLibrary_LibraryActionMutationVariables>;
export const GetCharacters_LineCharacterEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharacters_LineCharacterEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCharacters_LineCharacterEditQuery, GetCharacters_LineCharacterEditQueryVariables>;
export const EpisodeLinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EpisodeLines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeContentWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subLineOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subAudioWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subAudioOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"hasLines"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineDataGrid"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineDataGrid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subLineOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Audio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAudioWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAudioOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTakes"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"selectInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"takeId"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionName"}},{"kind":"Field","name":{"kind":"Name","value":"sessionType"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<EpisodeLinesQuery, EpisodeLinesQueryVariables>;
export const GetProductionData_ProductionDataTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductionData_ProductionDataTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"productionData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalLines"}},{"kind":"Field","name":{"kind":"Name","value":"completedLines"}},{"kind":"Field","name":{"kind":"Name","value":"incompleteLines"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledLines"}},{"kind":"Field","name":{"kind":"Name","value":"originalRecordings"}},{"kind":"Field","name":{"kind":"Name","value":"pickupRecordings"}},{"kind":"Field","name":{"kind":"Name","value":"totalRecordingTime"}},{"kind":"Field","name":{"kind":"Name","value":"avgTimePerLine"}},{"kind":"Field","name":{"kind":"Name","value":"adrRecordings"}},{"kind":"Field","name":{"kind":"Name","value":"adrRecordingTime"}}]}}]}}]} as unknown as DocumentNode<GetProductionData_ProductionDataTableQuery, GetProductionData_ProductionDataTableQueryVariables>;
export const GetLineText_CompDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLineText_CompDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<GetLineText_CompDetailQuery, GetLineText_CompDetailQueryVariables>;
export const GetAudioText_CompDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAudioText_CompDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<GetAudioText_CompDetailQuery, GetAudioText_CompDetailQueryVariables>;
export const SaveRecordingSession_FinishSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveRecordingSession_FinishSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"saveRecordingSessionDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveRecordingSession_FinishSessionMutation, SaveRecordingSession_FinishSessionMutationVariables>;
export const GetSessionData_UseDraftSessionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSessionData_useDraftSessionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"characterIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineTakeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"draftRecordingSessionLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"characterIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"characterIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"lineTakeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineTakeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSessionData_UseDraftSessionDataQuery, GetSessionData_UseDraftSessionDataQueryVariables>;
export const GetScriptViewData_ScriptViewWrapper_SessionDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScriptViewData_ScriptViewWrapper_SessionDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeContentWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContextBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ordinal"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ordinal"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ordinal"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"hasOverride"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetScriptViewData_ScriptViewWrapper_SessionDraftQuery, GetScriptViewData_ScriptViewWrapper_SessionDraftQueryVariables>;
export const GetSeasonOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeasonOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SeasonWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetSeasonOptionsQuery, GetSeasonOptionsQueryVariables>;
export const GetEpisodeOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEpisodeOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetEpisodeOptionsQuery, GetEpisodeOptionsQueryVariables>;
export const GetCharacterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharacterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCharacterOptionsQuery, GetCharacterOptionsQueryVariables>;
export const GetCompDetail_CompDetailWrapperDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompDetail_CompDetailWrapper"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"comps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circled"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"takesConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"subStrings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"take"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompDetail_CompDetailWrapperQuery, GetCompDetail_CompDetailWrapperQueryVariables>;
export const DeleteTakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TakeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"deleteTakes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"nodesDeleted"}}]}}]}}]} as unknown as DocumentNode<DeleteTakeMutation, DeleteTakeMutationVariables>;
export const UpdateRecordingSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRecordingSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateRecordingSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"actor"}},{"kind":"Field","name":{"kind":"Name","value":"beginTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"engineer"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}},{"kind":"Field","name":{"kind":"Name","value":"studio"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRecordingSessionMutation, UpdateRecordingSessionMutationVariables>;
export const UpdateTakeProperties_EditTakeDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTakeProperties_EditTakeData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"takeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"select"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateTakeProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}},{"kind":"Argument","name":{"kind":"Name","value":"takeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"takeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"select"},"value":{"kind":"Variable","name":{"kind":"Name","value":"select"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateTakeProperties_EditTakeDataMutation, UpdateTakeProperties_EditTakeDataMutationVariables>;
export const GetScriptViewData_ScriptViewWrapper_SessionFinalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScriptViewData_ScriptViewWrapper_SessionFinal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audioTakeWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TakeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"script"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContextBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ordinal"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"takes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audioTakeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"audioConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ordinal"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"allTakes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"lineConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"allTakes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"lineConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetScriptViewData_ScriptViewWrapper_SessionFinalQuery, GetScriptViewData_ScriptViewWrapper_SessionFinalQueryVariables>;
export const GetSessionLines_TableWrapperDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSessionLines_TableWrapper"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroupWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audioTakeWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TakeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allTakes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"lineConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characterName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"override"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"recordingStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordingSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingSessionId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"takes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audioTakeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"audioConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"select"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSessionLines_TableWrapperQuery, GetSessionLines_TableWrapperQueryVariables>;
export const GetRecordingSessionEpisodes_RecordingSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecordingSessionEpisodes_RecordingSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecordingSessionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecordingSessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSession"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"actor"}},{"kind":"Field","name":{"kind":"Name","value":"beginTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"engineer"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}},{"kind":"Field","name":{"kind":"Name","value":"studio"}},{"kind":"Field","name":{"kind":"Name","value":"episodesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"node"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecordingSessionEpisodes_RecordingSessionQuery, GetRecordingSessionEpisodes_RecordingSessionQueryVariables>;
export const GetRecordingSessions_RecordingSessionTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecordingSessions_RecordingSessionTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epSort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingSessionEpisodesConnectionSort"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scratch"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"episodesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecordingSessions_RecordingSessionTableQuery, GetRecordingSessions_RecordingSessionTableQueryVariables>;
export const GetEpisodeTitle_RecordingSessionTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEpisodeTitle_RecordingSessionTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetEpisodeTitle_RecordingSessionTableQuery, GetEpisodeTitle_RecordingSessionTableQueryVariables>;
export const GetCharacterName_RecordingSessionTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharacterName_RecordingSessionTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCharacterName_RecordingSessionTableQuery, GetCharacterName_RecordingSessionTableQueryVariables>;
export const GetLineText_CompsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLineText_Comps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<GetLineText_CompsQuery, GetLineText_CompsQueryVariables>;
export const GetAudioText_CompsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAudioText_Comps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audioWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audioWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<GetAudioText_CompsQuery, GetAudioText_CompsQueryVariables>;
export const GetLineInfo_TakesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLineInfo_Takes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}}]}}]}}]} as unknown as DocumentNode<GetLineInfo_TakesQuery, GetLineInfo_TakesQueryVariables>;
export const GetAudioInfo_TakesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAudioInfo_Takes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audioWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audioWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}}]}}]} as unknown as DocumentNode<GetAudioInfo_TakesQuery, GetAudioInfo_TakesQueryVariables>;
export const DeleteScriptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScript"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"deleteScript"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scriptId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteScriptMutation, DeleteScriptMutationVariables>;
export const GetScripts_ScriptTableWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScripts_ScriptTableWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]} as unknown as DocumentNode<GetScripts_ScriptTableWidgetQuery, GetScripts_ScriptTableWidgetQueryVariables>;
export const CreateSeason_AddSeasonDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSeason_AddSeasonDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SeasonCreateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalVoices"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSeason_AddSeasonDialogMutation, CreateSeason_AddSeasonDialogMutationVariables>;
export const CascadeDeleteSeason_DeleteSeasonDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CascadeDeleteSeason_DeleteSeasonDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cascadeDeleteSeason"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"nodesDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipsDeleted"}}]}}]}}]} as unknown as DocumentNode<CascadeDeleteSeason_DeleteSeasonDialogMutation, CascadeDeleteSeason_DeleteSeasonDialogMutationVariables>;
export const UpdateSeasons_EditSeasonDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSeasons_EditSeasonDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SeasonWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SeasonUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSeasons_EditSeasonDialogMutation, UpdateSeasons_EditSeasonDialogMutationVariables>;
export const CreateShow_AddShowDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShow_AddShowDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowCreateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createShows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<CreateShow_AddShowDialogMutation, CreateShow_AddShowDialogMutationVariables>;
export const CascadeDeleteShow_DeleteShowDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CascadeDeleteShow_DeleteShowDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cascadeDeleteShow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"nodesDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipsDeleted"}}]}}]}}]} as unknown as DocumentNode<CascadeDeleteShow_DeleteShowDialogMutation, CascadeDeleteShow_DeleteShowDialogMutationVariables>;
export const UpdateShow_EditShowDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShow_EditShowDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateShows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShow_EditShowDialogMutation, UpdateShow_EditShowDialogMutationVariables>;
export const GetEpisodesForSeason_LayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEpisodesForSeason_Layout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpisodeOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppBarEpisodeData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DrawerEpisodeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppBarEpisodeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DrawerEpisodeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetEpisodesForSeason_LayoutQuery, GetEpisodesForSeason_LayoutQueryVariables>;
export const GetShows_SeasonShowProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShows_SeasonShowProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetShows_SeasonShowProviderQuery, GetShows_SeasonShowProviderQueryVariables>;
export const GetSeasonFromShow_SeasonShowProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeasonFromShow_SeasonShowProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SeasonOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalVoices"}}]}}]}}]}}]} as unknown as DocumentNode<GetSeasonFromShow_SeasonShowProviderQuery, GetSeasonFromShow_SeasonShowProviderQueryVariables>;
export const AppVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<AppVersionQuery, AppVersionQueryVariables>;
export const GetShowCharacters_UploadDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShowCharacters_UploadDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetShowCharacters_UploadDialogQuery, GetShowCharacters_UploadDialogQueryVariables>;
export const ShowAndSeasonsForEpisodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShowAndSeasonsForEpisode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SeasonWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalVoices"}}]}}]}}]}}]} as unknown as DocumentNode<ShowAndSeasonsForEpisodeQuery, ShowAndSeasonsForEpisodeQueryVariables>;
export const CustomFieldsInfo_ParseExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomFieldsInfo_parseExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFieldsDefinition"}}]}}]}}]} as unknown as DocumentNode<CustomFieldsInfo_ParseExcelQuery, CustomFieldsInfo_ParseExcelQueryVariables>;
export const UpdateShowCustomFieldsDefinition_ParseExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShowCustomFieldsDefinition_parseExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"updateShows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFieldsDefinition"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShowCustomFieldsDefinition_ParseExcelMutation, UpdateShowCustomFieldsDefinition_ParseExcelMutationVariables>;
export const ExistingLinesAndGroups_UploadDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExistingLinesAndGroups_UploadDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"characterWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineGroupsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroupWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineGroupOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroupOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audioWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audioGroupWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioGroupWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"characterWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExistingCharsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExistingLineFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineGroupsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineGroupOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExistingLineGroupFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audioWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExistingAudioFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audioGroupWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExistingAudioGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingCharsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Character"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingLineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"characterConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingLineGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineNo"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overrideText"}},{"kind":"Field","name":{"kind":"Name","value":"lineStatus"}},{"kind":"Field","name":{"kind":"Name","value":"characterConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacterName"}},{"kind":"Field","name":{"kind":"Name","value":"overrideCharacter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"library"}},{"kind":"Field","name":{"kind":"Name","value":"performanceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingAudioFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Audio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExistingAudioGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}}]} as unknown as DocumentNode<ExistingLinesAndGroups_UploadDialogQuery, ExistingLinesAndGroups_UploadDialogQueryVariables>;
export const CreateParsedLines_UploadDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParsedLines_UploadDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createCharacters"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCharacter"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createGroups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLineGroup"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createSongs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSong"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createContextBlocks"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContextBlock"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audio"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lines"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessedLine"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancel"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelContent"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"detach"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DetachContent"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDraftScript"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closeDraftScript"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createParsedLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"episodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createCharacters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createCharacters"}}},{"kind":"Argument","name":{"kind":"Name","value":"createGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"createSongs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createSongs"}}},{"kind":"Argument","name":{"kind":"Name","value":"createContextBlocks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createContextBlocks"}}},{"kind":"Argument","name":{"kind":"Name","value":"audio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audio"}}},{"kind":"Argument","name":{"kind":"Name","value":"lines"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lines"}}},{"kind":"Argument","name":{"kind":"Name","value":"cancel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancel"}}},{"kind":"Argument","name":{"kind":"Name","value":"detach"},"value":{"kind":"Variable","name":{"kind":"Name","value":"detach"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromDraftScript"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDraftScript"}}},{"kind":"Argument","name":{"kind":"Name","value":"closeDraftScript"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closeDraftScript"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdLineInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParsedLineOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParsedLineGroupOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revisionChainId"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParsedAudioOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParsedAudioGroupOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"audios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"character"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateParsedLines_UploadDialogMutation, CreateParsedLines_UploadDialogMutationVariables>;
export const namedOperations = {
  Query: {
    CustomFieldsInfo: 'CustomFieldsInfo',
    GetRevisions_RevisionsDetail: 'GetRevisions_RevisionsDetail',
    GetCharacters_LineCharacterEdit: 'GetCharacters_LineCharacterEdit',
    EpisodeLines: 'EpisodeLines',
    GetProductionData_ProductionDataTable: 'GetProductionData_ProductionDataTable',
    GetLineText_CompDetail: 'GetLineText_CompDetail',
    GetAudioText_CompDetail: 'GetAudioText_CompDetail',
    GetSessionData_useDraftSessionData: 'GetSessionData_useDraftSessionData',
    GetScriptViewData_ScriptViewWrapper_SessionDraft: 'GetScriptViewData_ScriptViewWrapper_SessionDraft',
    GetSeasonOptions: 'GetSeasonOptions',
    GetEpisodeOptions: 'GetEpisodeOptions',
    GetCharacterOptions: 'GetCharacterOptions',
    GetCompDetail_CompDetailWrapper: 'GetCompDetail_CompDetailWrapper',
    GetScriptViewData_ScriptViewWrapper_SessionFinal: 'GetScriptViewData_ScriptViewWrapper_SessionFinal',
    GetSessionLines_TableWrapper: 'GetSessionLines_TableWrapper',
    GetRecordingSessionEpisodes_RecordingSession: 'GetRecordingSessionEpisodes_RecordingSession',
    GetRecordingSessions_RecordingSessionTable: 'GetRecordingSessions_RecordingSessionTable',
    GetEpisodeTitle_RecordingSessionTable: 'GetEpisodeTitle_RecordingSessionTable',
    GetCharacterName_RecordingSessionTable: 'GetCharacterName_RecordingSessionTable',
    GetLineText_Comps: 'GetLineText_Comps',
    GetAudioText_Comps: 'GetAudioText_Comps',
    GetLineInfo_Takes: 'GetLineInfo_Takes',
    GetAudioInfo_Takes: 'GetAudioInfo_Takes',
    GetScripts_ScriptTableWidget: 'GetScripts_ScriptTableWidget',
    GetEpisodesForSeason_Layout: 'GetEpisodesForSeason_Layout',
    GetShows_SeasonShowProvider: 'GetShows_SeasonShowProvider',
    GetSeasonFromShow_SeasonShowProvider: 'GetSeasonFromShow_SeasonShowProvider',
    AppVersion: 'AppVersion',
    GetShowCharacters_UploadDialog: 'GetShowCharacters_UploadDialog',
    ShowAndSeasonsForEpisode: 'ShowAndSeasonsForEpisode',
    CustomFieldsInfo_parseExcel: 'CustomFieldsInfo_parseExcel',
    ExistingLinesAndGroups_UploadDialog: 'ExistingLinesAndGroups_UploadDialog'
  },
  Mutation: {
    CreateEpisode_AddEpisodeDialog: 'CreateEpisode_AddEpisodeDialog',
    CascadeDeleteEpisode: 'CascadeDeleteEpisode',
    UpdateEpisodes: 'UpdateEpisodes',
    UpdateCharacterAssignment: 'UpdateCharacterAssignment',
    UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanel: 'UpdateShowCustomFieldsDefinition_CustomFieldsColumnsPanel',
    UpdateLineCustomFields: 'UpdateLineCustomFields',
    UpdateAudioCustomFields: 'UpdateAudioCustomFields',
    UpdateLinePerformanceNotes: 'UpdateLinePerformanceNotes',
    UpdateAudioPerformanceNotes: 'UpdateAudioPerformanceNotes',
    UpdateLineShotNo: 'UpdateLineShotNo',
    UpdateAudioShotNo: 'UpdateAudioShotNo',
    UpdateLineTimeCode: 'UpdateLineTimeCode',
    UpdateAudioTimeCode: 'UpdateAudioTimeCode',
    UpdateLineLibrary_LibraryAction: 'UpdateLineLibrary_LibraryAction',
    UpdateAudioLibrary_LibraryAction: 'UpdateAudioLibrary_LibraryAction',
    SaveRecordingSession_FinishSession: 'SaveRecordingSession_FinishSession',
    DeleteTake: 'DeleteTake',
    UpdateRecordingSession: 'UpdateRecordingSession',
    UpdateTakeProperties_EditTakeData: 'UpdateTakeProperties_EditTakeData',
    DeleteScript: 'DeleteScript',
    CreateSeason_AddSeasonDialog: 'CreateSeason_AddSeasonDialog',
    CascadeDeleteSeason_DeleteSeasonDialog: 'CascadeDeleteSeason_DeleteSeasonDialog',
    UpdateSeasons_EditSeasonDialog: 'UpdateSeasons_EditSeasonDialog',
    CreateShow_AddShowDialog: 'CreateShow_AddShowDialog',
    CascadeDeleteShow_DeleteShowDialog: 'CascadeDeleteShow_DeleteShowDialog',
    UpdateShow_EditShowDialog: 'UpdateShow_EditShowDialog',
    UpdateShowCustomFieldsDefinition_parseExcel: 'UpdateShowCustomFieldsDefinition_parseExcel',
    CreateParsedLines_UploadDialog: 'CreateParsedLines_UploadDialog'
  },
  Fragment: {
    LineDataGrid: 'LineDataGrid',
    RecordingSessionFragment: 'RecordingSessionFragment',
    AppBarEpisodeData: 'AppBarEpisodeData',
    DrawerEpisodeData: 'DrawerEpisodeData',
    ExistingCharsFragment: 'ExistingCharsFragment',
    ExistingLineFragment: 'ExistingLineFragment',
    ExistingLineGroupFragment: 'ExistingLineGroupFragment',
    ExistingAudioFragment: 'ExistingAudioFragment',
    ExistingAudioGroupFragment: 'ExistingAudioGroupFragment'
  }
}